<div class="all-in-one-table content-layout" *ngIf="read">
  <calsoft-page-header *ngIf="secondaryType==1" [height]="'180px'" background="url(assets/images/headers/pattern-3.png)"
    [reverse]="true">
  </calsoft-page-header>


  <div class="container">
    <calsoft-breadcrumbs *ngIf="secondaryType==1 && GridType !=9" [url]="'commonProduct'"
      [currentPage]="(currentRouterPath | moduleName) || title" [header]="'primary'"></calsoft-breadcrumbs>
    <div *ngIf="GridType == 6" class="lead-container" style="margin-bottom: 24px;">

      <span>

        <div class="lead-stats" style="margin: 10px;" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px"
          fxLayout.lt-md="column">
          <div class="lead-box total-leads" [class.active]="selectedLeadStat === 'total'"
            [attr.guide]="'lead-stats-total'" (click)="viewPageTotal()">
            <span>Total Leads</span>
            <h2>{{ pageListTwo }}</h2>
          </div>

          <div class="stat-box" [class.active]="selectedLeadStat === 'today'" [attr.guide]="'lead-stats-today'"
            (click)="viewPageToday()">
            <span>Today Leads
              <mat-icon
                matTooltip="{{ pageListThree > 0 ? 'Leads added today with pending follow-ups.' : 'No new leads added today.' }}">info</mat-icon>
            </span>
            <h2>{{ pageListThree }}</h2>
          </div>

          <!-- <div class="stat-box">
            <span>Idle 
              <i class="info-icon">
                <mat-icon matTooltip="{{ pageListThree == 0 ? 'No activity on leads for 30 days.' : 'Some leads have past activity but no updates in the last 30 days.' }}">info</mat-icon>
              </i>
            </span>
            <h2>0</h2>
          </div> -->

          <div class="stat-box" [class.active]="selectedLeadStat === 'untouched'" [attr.guide]="'lead-stats-untouched'"
            (click)="viewTodayUntouch()">
            <span>Today Untouched Leads
              <mat-icon
                matTooltip="{{ pageListFour > 0 ? 'Leads with completed activity but no future follow-ups.' : 'All leads have scheduled follow-ups.' }}">info</mat-icon>
            </span>
            <h2>{{ todayUntochedCnt }}</h2>
          </div>

          <!-- <div class="stat-box">
            <span>Overdue</span>
            <h2>0</h2>
          </div> -->

          <div class="stat-box" [class.active]="selectedLeadStat === 'assigned'" [attr.guide]="'lead-stats-assigned'"
            (click)="viewPageAssignToday()">
            <span>Today Assigned Leads</span>
            <h2>{{ assignLeadCnt }}</h2>
          </div>
          <!--           
          <div class="stat-box">
            <span>Upcoming 
              <i class="info-icon">
                <mat-icon matTooltip="{{ pageListFive > 0 ? 'Leads with activities due in the next 30 days.' : 'No upcoming activities scheduled.' }}">info</mat-icon>
              </i>
            </span>
            <h2>0</h2>
          </div> -->
        </div>

      </span>




    </div>


    <div *ngIf="GridType == 7 || GridType == 5" class="header-container" fxLayout="column" fxLayoutGap=".8rem"
      fxLayoutGap.lt-md="0px">

      <h2 class="title">All Leads</h2>

      <div fxLayout="row" fxLayoutAlign="end center" class="top-bar-new" fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="center center" [ngStyle.lt-md]="'margin-bottom:0rem;'">


        <div fxLayout="row" fxLayoutGap="8px" class="export-buttons" fxLayout.lt-md="column" fxLayoutGap.lt-md="15px"
          [ngStyle.lt-md]="'width:100%;'">
          <button mat-flat-button color="primary" class="padding-button" [disabled]="selectionLead.length <= 0"
            [attr.guide]="'btn-random-assign'" (click)="transferLead(1)">
            <mat-icon class="icon-minimize">shuffle</mat-icon> Random Assign for Leads
          </button>
          <button *ngIf="!contactPage&&!connectedCall" mat-flat-button color="primary" class="padding-button"
            [attr.guide]="'btn-import-leads'" (click)="importExcel()">
            <mat-icon>upload</mat-icon> Import Leads
          </button>
          <button mat-flat-button class="list-view-btn padding-button" [attr.guide]="'btn-lead-view'"
            (click)="selectView('leadView')">Lead
            View</button>
          <button mat-flat-button class="kanban-btn padding-button" [attr.guide]="'btn-kanban-view'"
            (click)="switchView('kanban')">Kanban
            Board</button>
          <button mat-flat-button color="primary" class="padding-button" [attr.guide]="'btn-add-lead-top'"
            (click)="addproduct()">
            <mat-icon>add</mat-icon> Add Lead
          </button>





        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="space-between center" class="bottom-bar" fxLayout.lt-md="column">

        <div fxLayout="row" fxLayoutGap="10px" class="action-buttons" fxLayout.lt-md="column"
          [ngStyle.lt-md]="'width:100%;padding-bottom:15px'">
          <button mat-stroked-button class="padding-button hover-button" [attr.guide]="'btn-col-visibility'"
            (click)="OpenTwopopup()">
            <mat-icon>visibility</mat-icon> Column visibility
          </button>

          <button mat-stroked-button class="padding-button hover-button" [attr.guide]="'btn-export-excel'"
            (click)="bulkUpload ? restritionPopup() : exportDataFilter()">
            <mat-icon>table_chart</mat-icon> Export to Excel
          </button>
          <button mat-stroked-button class="padding-button hover-button" [attr.guide]="'btn-filter'"
            (click)="openNew1()">
            <mat-icon>filter_list</mat-icon> Filter
          </button>
        </div>



        <div fxLayout="row" fxLayoutAlign="end center" class="search-section" fxLayout.lt-md="column"
          fxLayoutAlign.lt-md="center center" fxLayoutGap.lt-md="15px" [ngStyle.lt-md]="'width:100%;'">
          <input [attr.guide]="'common-product-inp-5' + '__' + sanitizeUrl(url)" [ngStyle.lt-md]="'width:100%;'"
            type="text" [(ngModel)]="searchTermMain" class="search-input" placeholder="Search..." />
          <button [ngStyle.lt-md]="'width:100%;'" mat-flat-button color="primary" class="padding-button"
            [attr.guide]="'btn-search-main'" (click)="searchFilterMain(1)">Search</button>
          <button [ngStyle.lt-md]="'width:100%;'" mat-stroked-button color="warn" class="padding-button"
            [attr.guide]="'btn-clear-search'" (click)="clearSearch()">Clear</button>
        </div>
      </div>
    </div>


    <div *ngIf="GridType ==  9" class="custom-table gridtable-class"
      [class.filter-open-layout]="isFilterPanelOpen || isFilterPanelColumnOpen" fxLayout="row" [fxLayoutGap]="rowgap">
      <div [fxFlex]="rowLeft" *ngIf="isGridVisible" style="width: 100%;">
        <div class="crm-container-new-eight">

          <main class="main-content">


            <section class="contacts-view">
              <div class="contacts-header">
                <section>
                  <div>
                    <h2 *ngIf="!contactPage&&!connectedCall" class="sg-title">{{(currentRouterPath | moduleName) ||
                      'Lead'}}
                    </h2>
                    <h2 *ngIf="contactPage&&!connectedCall" class="sg-title">{{(currentRouterPath | moduleName) ||
                      'Contacts'}}
                    </h2>
                  </div>
                </section>
                <div class="contact-tabs" fxFlex="40" fxFlex.xs="100">
                  <!-- Tabs control area: arrows + scrollable tabs (occupies ~50% width) -->
                  <div class="tabs-controls">
                    <button type="button" class="tab-arrow left" (click)="scrollTabs('left', $event)"
                      [attr.guide]="'btn-scroll-tabs-left'" aria-label="Scroll left">
                      <mat-icon>chevron_left</mat-icon>
                    </button>

                    <div class="tabs-scroll" #tabsScroll>

                      <span *ngIf="!contactPage&&!connectedCall">
                        <span class="tab-item" [class.active]="activeTab === 'new'" [attr.guide]="'tab-new-lead'"
                          (click)="onTabClick('new', $event)">
                          New Lead<span class="count" *ngIf="activeTab === 'new'">{{newContactCount || 0}}</span>
                        </span>
                      </span>

                      <span *ngIf="!contactPage&&!connectedCall">
                        <span *ngIf="!contactPage&&!connectedCall" class="tab-item" [class.active]="activeTab === 'all'"
                          [attr.guide]="'tab-all-lead'" (click)="onTabClick('all', $event)">
                          All Lead <span *ngIf="activeTab === 'all'" class="count">{{pageList}}</span>
                        </span>

                      </span>

                      <span *ngIf="contactPage">
                        <span class="tab-item" [class.active]="activeTab === 'all'" [attr.guide]="'tab-all-contacts'"
                          (click)="onTabClick('all', $event)">
                          All Contacts <span *ngIf="activeTab === 'all'" class="count">{{pageList}}</span>
                        </span>


                      </span>


                      <span *ngFor="let tab of smartViewList; let i = index">
                        <span class="tab-item" [class.active]="activeTab === tab.tabName"
                          [attr.guide]="'tab-' + tab.tabName" (click)="onClickTabData(tab)">
                          {{tab.tabName}} <span class="count" *ngIf="activeTab === tab.tabName">{{pageList|| 0}}</span>
                        </span>
                      </span>

                    </div>

                    <button type="button" class="tab-arrow right" (click)="scrollTabs('right', $event)"
                      [attr.guide]="'btn-scroll-tabs-right'" aria-label="Scroll right">
                      <mat-icon>chevron_right</mat-icon>
                    </button>
                  </div>
                </div>



                <div class="contact-actions" fxFlex fxLayout="row" fxLayout.xs="column" fxLayoutAlign="end center">
                  <button mat-button [matMenuTriggerFor]="leadMenu" class="btn btn-outline bhover"
                    [attr.guide]="'btn-more-actions'">
                    <!-- <mat-icon>more_horiz</mat-icon> -->
                    More Actions
                  </button>

                  <!-- The popup menu -->
                  <mat-menu #leadMenu="matMenu">
                    <!-- <button [attr.guide]="'common-product-btn-8' + '__' + sanitizeUrl(url)" mat-menu-item (click)="housingLeadData()">
                    <mat-icon class="material-icons-outlined mat-icon-sm">date_range</mat-icon>
                    <span>Common Floor Lead</span>
                  </button> -->

                    <button *ngIf="!selection.isEmpty()" mat-menu-item [attr.guide]="'menu-whatsapp'"
                      (click)="sendWhatsappMessage()">
                      <img src="assets/icons/whatsapp.svg" alt="Whatsapp"
                        style="width: 17px; height: 17px; vertical-align: middle; margin-right: 4px;">
                      <span>Whatsapp Message</span>
                    </button>

                    <button *ngIf="!selection.isEmpty()&&dialerType == 5" mat-menu-item [attr.guide]="'menu-autodial'"
                      (click)="sequenceCallWithWebsocketConnect()">
                      <mat-icon style="font-size: 17px;padding-top: 5px;" class="primary-icon">call</mat-icon>
                      <span> Auto dial</span>
                    </button>

                    <button [disabled]="!read" (click)="LeadOwnerSearch(productList)" [attr.guide]="'menu-owner-search'"
                      mat-menu-item>
                      <mat-icon>settings_phone</mat-icon>
                      <span>Lead Owner Search</span>
                    </button>

                    <button *ngIf="!selection.isEmpty()" mat-menu-item [attr.guide]="'menu-send-email'"
                      (click)="sendEmailMessage()">
                      <mat-icon class="material-icons-outlined mat-icon-sm">email</mat-icon>
                      <span>Send Email</span>
                    </button>
                  </mat-menu>
                  <button class="btn btn-outline bhover" [attr.guide]="'btn-refresh'" (click)="refresh()">
                    <mat-icon>refresh</mat-icon>
                    Refresh</button>
                  <button *ngIf="!connectedCall" class="btn btn-outline bhover" [attr.guide]="'btn-export'"
                    (click)="bulkUpload ? restritionPopup() : exportDataFilter()">
                    <mat-icon>file_download</mat-icon>
                    Export</button>
                  <button *ngIf="!contactPage&&!connectedCall" class="btn btn-outline bhover"
                    [attr.guide]="'btn-import-advance'" (click)="importExcelAdvance()">
                    <mat-icon>cloud_upload</mat-icon>
                    Import
                    Lead</button>

                  <button *ngIf="!contactPage&&!connectedCall" class="btn btn-primary"
                    [attr.guide]="'btn-add-lead-bottom'" (click)="addproduct()"><mat-icon>add</mat-icon>
                    Add Lead</button>
                </div>
              </div>

              <div class="table-controls-wrapper">

                <div class="table-controls" *ngIf="isSelectionEmpty()">

                  <div class="contacts-header">
                    <div class="contact-actions">

                      <button class="btn btn-outline bhover" mat-button [matMenuTriggerFor]="viewTableMenu"
                        [attr.guide]="'btn-table-menu'"
                        style="justify-content: center;"><mat-icon>table_chart</mat-icon>
                        Table </button>

                      <button mat-button [matMenuTriggerFor]="viewMenu" class="btn-two btn-outline bhover"
                        [attr.guide]="'btn-view-menu'">
                        <mat-icon>layers</mat-icon>
                      </button>

                      <button class="btn btn-outline bhover" [attr.guide]="'btn-filter-columns'" (click)="goToPopUp()">
                        <mat-icon>search</mat-icon>
                      </button>

                      <mat-menu #viewTableMenu="matMenu">
                        <button mat-menu-item [attr.guide]="'menu-table-view'" (click)="setTableView('tableView')">
                          <mat-icon>table_chart</mat-icon>
                          <span style="margin-left: 8px;">Table View</span>
                          <mat-icon *ngIf="tableViewMode != 'kanbanView'">check</mat-icon>
                        </button>
                        <button mat-menu-item [attr.guide]="'menu-kanban-view'" (click)="setTableView('kanbanView')">
                          <mat-icon>view_column</mat-icon>
                          <span style="margin-left: 8px;">Kanban View</span>
                          <mat-icon *ngIf="tableViewMode == 'kanbanView'">check</mat-icon>
                        </button>
                      </mat-menu>


                      <mat-menu #viewMenu="matMenu">
                        <button mat-menu-item [attr.guide]="'menu-view-compact'" (click)="setView('compact')">
                          <mat-icon>compress</mat-icon>
                          <span style="margin-left: 8px;">Compact</span>
                          <mat-icon *ngIf="viewMode === 'compact'" style="margin-left:5px;">check</mat-icon>
                        </button>
                        <button mat-menu-item [attr.guide]="'menu-view-comfortable'" (click)="setView('comfortable')">
                          <mat-icon>expand</mat-icon>
                          <span style="margin-left: 8px;">Comfortable</span>
                          <mat-icon *ngIf="viewMode === 'comfortable'" style="margin-left:5px;">check</mat-icon>
                        </button>
                      </mat-menu>

                      <button class="btn btn-outline bhover" [attr.guide]="'btn-bulk-actions'"
                        (click)="selectAllForBulkAction()">Bulk actions</button>
                      <button class="btn btn-outline bhover d-flex align-items-center gap-2"
                        [class.active-filter]="filterActive" [attr.guide]="'btn-toggle-filter'"
                        (click)="toggleFilterPanel()">
                        <!-- Icon switches based on filterActive -->
                        <mat-icon class="me-1">
                          {{ filterActive ? 'filter_alt' : 'filter_list' }}
                        </mat-icon>

                        <span>Filter</span>

                        <!-- Nice little pill when applied -->
                        <span *ngIf="filterActive" class="filter-pill">
                          <mat-icon class="pill-icon">check_circle</mat-icon>

                        </span>
                      </button>
                      <button class="btn btn-outline bhover" [attr.guide]="'btn-filter-columns'"
                        (click)="toggleFilterColumnPanel()" [class.active-filter]="isFilterPanelColumnOpen">
                        Filter by Columns
                      </button>

                      <button *ngIf="!contactPage&&!connectedCall" class="btn btn-outline bhover"
                        [attr.guide]="'btn-advance-filter'" (click)="advanceFilter()">
                        <mat-icon>add</mat-icon>
                        Advance Filter</button>
                      <!-- <button [attr.guide]="'common-product-btn-10' + '__' + sanitizeUrl(url)" *ngIf="!contactPage&&!connectedCall" class="btn btn-outline" (click)="LeadOwnerSearch(productList)">
                      <mat-icon>settings_phone</mat-icon>
                      Lead Owner Search</button> -->
                      <button [disabled]="!resourcePrivilege?.delete" *ngIf="!contactPage&&!connectedCall"
                        class="btn btn-outline bhover" [attr.guide]="'btn-delete-all'"
                        (click)="deleteAllProductDialog()">
                        <mat-icon>delete_forever</mat-icon>
                        Delete All</button>

                    </div>
                  </div>


                </div>

                <div class="bulk-action-bar" *ngIf="!isSelectionEmpty()">
                  <div class="contacts-header">
                    <div class="contact-actions">
                      <span class="selection-count">{{ getSelectedCount() }} selected</span>
                      <button class="btn btn-outline" [disabled]="!resourcePrivilege?.update"
                        [attr.guide]="'btn-bulk-transfer'" (click)="transferLead(0)">Transfer</button>
                      <button class="btn btn-outline" [disabled]="!resourcePrivilege?.update"
                        [attr.guide]="'btn-bulk-random-assign'" (click)="transferLead(1)">Random Assign</button>
                      <button class="btn btn-outline" [attr.guide]="'btn-bulk-download'"
                        (click)="bulkUpload ? restritionPopup() : exportDataFilterSelected('selected')">Download
                        Selected</button>
                      <button class="btn btn-outline" [disabled]="!resourcePrivilege?.delete"
                        [attr.guide]="'btn-bulk-delete'" (click)="deleteSelectedDialog()">Delete Selected </button>

                      <button class="btn btn-outline" [disabled]="!resourcePrivilege?.update"
                        [attr.guide]="'btn-bulk-add-sequence'" (click)="SequenceStatusPopup('selected',null)">Add Leads
                        To
                        Sequence </button>
                      <button class="btn btn-outline" [disabled]="!resourcePrivilege?.update"
                        [attr.guide]="'btn-bulk-update-status'" (click)="UpdateStatus()">Update Status </button>
                      <div class="cancel-action">
                        <button mat-button [attr.guide]="'btn-cancel-bulk'" (click)="cancelBulkSelection()">
                          <mat-icon>close</mat-icon> Cancel selection
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div *ngIf="tableViewMode == 'tableView'" class="leads-content-area"
                [class.filter-open]="isFilterPanelOpen" [class.filter-column-open]="isFilterPanelColumnOpen">
                <div class="table-wrapper">


                  <table mat-table [dataSource]="productList" matSort (matSortChange)="sortData($event)"
                    class="contacts-table" [ngClass]="viewMode">

                    <ng-container *ngFor="let col of columns; trackBy: trackByProp" [sticky]="!isMobile && col.isSticky"
                      [matColumnDef]="col.property">
                      <ng-container *ngIf="col.isModelProperty!='false'">

                        <ng-container *ngIf="col.property !== 'actions'">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{ col.name }}
                          </th>
                        </ng-container>
                        <ng-container *ngIf="col.property === 'actions'">
                          <th mat-header-cell *matHeaderCellDef class="actions-cell">
                            {{ col.name }}
                          </th>
                        </ng-container>

                        <td mat-cell *matCellDef="let element ;let i = index" class="hover-cell">
                          <div class="cell-content-wrapper">
                            <div class="cell-data" style="padding-left: 15px;">

                              <ng-container [ngSwitch]="col.property">


                                <span *ngSwitchCase="'name'">
                                  <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else nameReadMode">

                                    <input [attr.guide]="'common-product-inp-11' + '__' + sanitizeUrl(url)"
                                      *ngIf="col.inputType === 'text'" matInput [(ngModel)]="element.name"
                                      placeholder="Enter name" />

                                  </ng-container>
                                  <ng-template #nameReadMode>
                                    <div class="user-cell">
                                      <img *ngIf="element.avatarUrl" [src]="element.avatarUrl" class="contact-avatar" />
                                      <div *ngIf="!element.avatarUrl" class="contact-avatar owner-avatar">
                                        {{ getInitialsTwo(element.name || element.ownerIdName) }}
                                      </div>
                                      <span (click)="openLeadPanel(element)" class="name-cell"
                                        [attr.guide]="'link-lead-name'">{{ element.name || '(No
                                        Name)' }}
                                        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
                                          <mat-icon (click)="phoneNumbercall(element); $event.stopPropagation()"
                                            [attr.guide]="'icon-call-lead'" [icIcon]="icPhone" size="18px"
                                            style="cursor: pointer;height: 25px; color: green;font-size: 16px;">
                                          </mat-icon>
                                          {{ element.phoneNumber }}
                                        </div>
                                      </span>
                                    </div>
                                  </ng-template>
                                </span>

                                <span *ngSwitchCase="'email'">
                                  <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else emailReadMode">

                                    <input [attr.guide]="'common-product-inp-12' + '__' + sanitizeUrl(url)"
                                      *ngIf="col.inputType === 'text'" matInput [(ngModel)]="element.email"
                                      placeholder="Enter email" />
                                  </ng-container>
                                  <ng-template #emailReadMode>
                                    <div class="user-cell1">
                                      <a (click)="openEmailPopup(element)" class="name-cell"
                                        [attr.guide]="'link-lead-email'">{{ element.email || '(No
                                        Email)' }}</a>
                                    </div>
                                  </ng-template>
                                </span>


                                <span *ngSwitchCase="'phoneNumber'">
                                  <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else phoneNumberReadMode">

                                    <input [attr.guide]="'common-product-inp-13' + '__' + sanitizeUrl(url)"
                                      *ngIf="col.inputType === 'text'" numbersOnly matInput
                                      [(ngModel)]="element.phoneNumber" placeholder="Enter Phone Number" />

                                  </ng-container>
                                  <ng-template #phoneNumberReadMode>
                                    <div class="user-cell">
                                      {{ element.phoneNumber }}
                                    </div>
                                  </ng-template>
                                </span>



                                <span *ngSwitchCase="'statusName'">
                                  <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else statusNameReadMode">

                                    <mat-select style="width: 100px;" *ngIf="col.inputType === 'select'"
                                      [(ngModel)]="element[col.property]">

                                      <ng-container *ngIf="col.property == 'statusName'">
                                        <mat-option
                                          (onSelectionChange)="setStatusName($event,opt , element.entityId,element)"
                                          *ngFor="let opt of filteredleadStatusTypeList; let i=index;"
                                          [value]="opt.statusName">
                                          {{opt.statusName}}
                                        </mat-option>
                                      </ng-container>

                                    </mat-select>

                                  </ng-container>


                                  <ng-template #statusNameReadMode>
                                    <span class="user-cell user-lead-status" style="border-radius: 15px;"
                                      [style.background-color]="element.leadStatusColour"
                                      [style.color]="element.darkTextColor">
                                      <!-- {{ element.statusName }} -->
                                      {{ getStatusName(element.statusName) }}
                                    </span>
                                  </ng-template>
                                </span>


                                <span *ngSwitchCase="'tagName'">
                                  <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else tagNameReadMode">

                                    <mat-select style="width: 100px;" *ngIf="col.inputType === 'select'"
                                      [(ngModel)]="element[col.property]">

                                      <ng-container *ngIf="col.property == 'tagName' || col.property == 'Tags'">
                                        <mat-option
                                          (onSelectionChange)="setTagName($event,opt , element.entityId,element)"
                                          *ngFor="let opt of filteredtagsTypeList; let i=index;"
                                          [value]="opt.statusName">
                                          {{opt.statusName}}
                                        </mat-option>
                                      </ng-container>

                                    </mat-select>

                                  </ng-container>
                                  <ng-template #tagNameReadMode>
                                    <span class="user-cell user-lead-status"
                                      [style.background-color]="getTagColor(element.tagName || element.tagNames || element.Tags) || element.tagNameColour"
                                      [style.color]="getTagTextColor(element.tagName || element.tagNames || element.Tags) || element.darkTextColorTag">
                                      {{ getTagName(element.tagName || element.tagNames || element.Tags) }}
                                    </span>
                                  </ng-template>
                                </span>

                                <span *ngSwitchCase="'propertyName'">
                                  <span (click)="openPropertyName(element, col); $event.stopPropagation()"
                                    class="user-cell" style="cursor: pointer;">
                                    {{ getPropertyDisplayValue(element, col) || '--' }}
                                  </span>
                                </span>
                                <span *ngSwitchCase="'PropertyName'">
                                  <span (click)="openPropertyName(element, col); $event.stopPropagation()"
                                    class="user-cell" style="cursor: pointer;">
                                    {{ getPropertyDisplayValue(element, col) || '--' }}
                                  </span>
                                </span>
                                <span *ngSwitchCase="'Property'">
                                  <span (click)="openPropertyName(element, col); $event.stopPropagation()"
                                    class="user-cell" style="cursor: pointer;">
                                    {{ getPropertyDisplayValue(element, col) || '--' }}
                                  </span>
                                </span>
                                <span *ngSwitchCase="'property'">
                                  <span (click)="openPropertyName(element, col); $event.stopPropagation()"
                                    class="user-cell" style="cursor: pointer;">
                                    {{ getPropertyDisplayValue(element, col) || '--' }}
                                  </span>
                                </span>
                                <span *ngSwitchCase="'State'">
                                  <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else stateReadMode1">
                                    <input [attr.guide]="'common-product-inp-state' + '__' + sanitizeUrl(url)"
                                      *ngIf="col.inputType === 'text'" matInput [(ngModel)]="element[col.property]"
                                      placeholder="Enter state" />
                                  </ng-container>
                                  <ng-template #stateReadMode1>
                                    <span class="user-cell">
                                      {{ element.state || element.State || element.State_cust || '--' }}
                                    </span>
                                  </ng-template>
                                </span>
                                <span *ngSwitchCase="'state'">
                                  <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else stateReadMode2">
                                    <input [attr.guide]="'common-product-inp-state' + '__' + sanitizeUrl(url)"
                                      *ngIf="col.inputType === 'text'" matInput [(ngModel)]="element[col.property]"
                                      placeholder="Enter state" />
                                  </ng-container>
                                  <ng-template #stateReadMode2>
                                    <span class="user-cell">
                                      {{ element.state || element.State || element.State_cust || '--' }}
                                    </span>
                                  </ng-template>
                                </span>
                                <span *ngSwitchCase="'State_cust'">
                                  <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else stateReadMode3">
                                    <input [attr.guide]="'common-product-inp-state' + '__' + sanitizeUrl(url)"
                                      *ngIf="col.inputType === 'text'" matInput [(ngModel)]="element[col.property]"
                                      placeholder="Enter state" />
                                  </ng-container>
                                  <ng-template #stateReadMode3>
                                    <span class="user-cell">
                                      {{ element.state || element.State || element.State_cust || '--' }}
                                    </span>
                                  </ng-template>
                                </span>


                                <span *ngSwitchCase="'favourite'">
                                  <button class="fav-button" type="button" mat-icon-button
                                    [matTooltip]="isMobile ? '' : 'Favourite'"
                                    [matTooltipPosition]="isMobile ? '' : 'above'" (click)="toggleFavorite(element);"
                                    [ngClass]="{ 'favorite': element.favourite==1 }">
                                    <mat-icon>{{ element.favourite==1 ? 'favorite' : 'favorite_border' }}
                                    </mat-icon>
                                  </button>
                                </span>

                                <span *ngSwitchCase="'company'">
                                  <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else companyReadMode">

                                    <input [attr.guide]="'common-product-inp-14' + '__' + sanitizeUrl(url)"
                                      *ngIf="col.inputType === 'text'" matInput [(ngModel)]="element.company"
                                      (input)="onInlineCompanyInput($event, element)" [matAutocomplete]="auto"
                                      #autoTrigger="matAutocompleteTrigger" placeholder="Enter Company" />

                                    <mat-autocomplete #auto="matAutocomplete"
                                      (closed)="onInlineAutocompleteClosed(element)">
                                      <mat-option (onSelectionChange)="onCompanySelected($event,opt,element)"
                                        *ngFor="let opt of companyList" [value]="opt.name">
                                        {{ opt.name }}
                                      </mat-option>
                                      <!-- <mat-option *ngIf="companyList?.length === 0" disabled>
                                      No company found
                                    </mat-option> -->

                                      <mat-option (onSelectionChange)="addNewCompany(element,element.company)"
                                        *ngIf="companyList?.length === 0 && element.company">
                                        <mat-icon color="primary" class="mr-2">add_circle</mat-icon>
                                        Add "{{ element.company }}" as a new company
                                      </mat-option>
                                    </mat-autocomplete>


                                  </ng-container>
                                  <ng-template #companyReadMode>
                                    <span (click)="companyNavigation(element.companyId)" class="user-cell"
                                      [attr.guide]="'link-company'">
                                      {{ element.company }}
                                    </span>
                                  </ng-template>
                                </span>

                                <span *ngSwitchCase="'icons'">
                                  <div *ngIf="element.phoneNumber != null" style="display: flex; align-items: center;">
                                    <mat-icon (click)="phoneNumbercall(element); $event.stopPropagation()"
                                      [attr.guide]="'icon-phone-call'" [icIcon]="icPhone" size="18px"
                                      style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                                    </mat-icon>
                                    <img (click)="phonewhatsapp(element); $event.stopPropagation()"
                                      [attr.guide]="'icon-whatsapp'" src="assets/icons/whatsapp.svg" alt="Whatsapp"
                                      style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                                  </div>

                                  <div *ngIf="element.secondaryphoneno?.length > 0"
                                    style="margin-top: 5px; display: flex; align-items: center;">
                                    <mat-icon (click)="secondaryphoneNumbercall(element); $event.stopPropagation()"
                                      [attr.guide]="'icon-sec-phone-call'" [icIcon]="icPhone" size="18px"
                                      style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                                    </mat-icon>
                                    <img
                                      (click)="secondaryphonewhatsapp(element.customField10); $event.stopPropagation()"
                                      [attr.guide]="'icon-sec-whatsapp'" src="assets/icons/whatsapp.svg" alt="Whatsapp"
                                      style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                                  </div>
                                </span>



                                <!-- Created Date -->
                                <span *ngSwitchCase="'totalCallDuration'">
                                  {{ formatSecondsToTime(element.totalCallDuration) }}
                                </span>

                                <span *ngSwitchCase="'createdDate'">
                                  <ng-container *ngIf="element.createdDate; else noDate">
                                    {{ element.createdDate | date: 'medium' }}
                                  </ng-container>
                                  <ng-template #noDate>--</ng-template>
                                </span>

                                <span *ngSwitchCase="'emailValid'">
                                  <ng-container *ngIf="element.emailValid">
                                    {{ element.emailValid==1 ? 'true' : 'false' }}
                                  </ng-container>

                                </span>

                                <span *ngSwitchCase="'firstResponseTime'">
                                  <ng-container *ngIf="element.firstResponseTime">

                                    {{ element.firstResponseTime | date: 'medium' }}
                                  </ng-container>

                                </span>


                                <span *ngSwitchCase="'lastActivityNotes'">
                                  <ng-container>
                                    {{ element.lastActivityNotes}}
                                  </ng-container>

                                </span>

                                <!-- Updated Date -->
                                <span *ngSwitchCase="'updatedDate'">
                                  <ng-container *ngIf="element.updatedDate; else noDateUpdated">
                                    {{ element.updatedDate | date: 'medium' }}
                                  </ng-container>
                                  <ng-template #noDateUpdated>--</ng-template>
                                </span>


                                <span *ngSwitchCase="'select'">

                                  <mat-checkbox [attr.guide]="'common-product-chk-15' + '__' + sanitizeUrl(url)"
                                    (click)="$event.stopPropagation()"
                                    (change)="changeValue($event.checked, element); $event ? selection.toggle(element) : null"
                                    [checked]="selection.isSelected(element) || isRowSelected(element)"
                                    [aria-label]="checkboxLabel(element)">
                                  </mat-checkbox>

                                </span>

                                <span *ngSwitchCase="'actions'">
                                  <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                                    [attr.guide]="'btn-row-actions'" (click)="$event.stopPropagation()"
                                    class="premium-action-trigger">
                                    <mat-icon>more_horiz</mat-icon>
                                  </button>
                                  <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before"
                                    class="premium-action-menu">
                                    <button [disabled]="!resourcePrivilege?.update"
                                      (click)="editProduct(element.entityId, element.attributeSetId)"
                                      [attr.guide]="'menu-edit-lead'" mat-menu-item class="menu-item-edit">
                                      <mat-icon>edit_note</mat-icon>
                                      <span>Edit Details</span>
                                    </button>

                                    <ng-container *ngIf="crmType==0 || crmType==4 || enableEditStatusPopup==1">
                                      <button (click)="openLeadStage(element, i)" [attr.guide]="'menu-lead-stage'"
                                        mat-menu-item class="menu-item-stage">
                                        <mat-icon>moving</mat-icon>
                                        <span>Lead Stage</span>
                                      </button>
                                    </ng-container>

                                    <button [disabled]="!resourcePrivilege?.delete"
                                      (click)="deleteAllProductId(element.entityId)" [attr.guide]="'menu-delete-lead'"
                                      mat-menu-item class="menu-item-delete">
                                      <mat-icon>delete_outline</mat-icon>
                                      <span>Delete</span>
                                    </button>

                                    <mat-divider
                                      *ngIf="leadToCustomer == 1 || enableSequence || crmType==0 || crmType==4"></mat-divider>

                                    <button *ngIf="leadToCustomer == 1" (click)="getApprove(element)"
                                      [attr.guide]="'menu-convert-customer'" mat-menu-item class="menu-item-convert">
                                      <mat-icon>swap_horiz</mat-icon>
                                      <span>Convert to Customer</span>
                                    </button>

                                    <button *ngIf="enableSequence" (click)="SequenceStatusPopup('single',element)"
                                      [attr.guide]="'menu-add-sequence'" mat-menu-item class="menu-item-sequence">
                                      <mat-icon>playlist_add</mat-icon>
                                      <span>Add Lead Sequences</span>
                                    </button>

                                    <ng-container *ngIf="crmType==0 || crmType==4">
                                      <button (click)="openLeadStage(element, i)" [attr.guide]="'menu-lead-stage'"
                                        mat-menu-item class="menu-item-stage">
                                        <mat-icon>moving</mat-icon>
                                        <span>Lead Stage</span>
                                      </button>
                                      <button (click)="openLeadPriority(element)" [attr.guide]="'menu-lead-priority'"
                                        mat-menu-item class="menu-item-priority">
                                        <mat-icon>flag</mat-icon>
                                        <span>Add Lead Priority</span>
                                      </button>
                                    </ng-container>
                                  </mat-menu>
                                </span>



                                <span *ngSwitchDefault>
                                  <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else readMode">

                                    <input [attr.guide]="'common-product-inp-16' + '__' + sanitizeUrl(url)"
                                      *ngIf="col.inputType === 'text'" matInput [(ngModel)]="element[col.property]"
                                      placeholder="Enter value" />

                                    <mat-select style="width: 100px;"
                                      *ngIf="col.inputType === 'select' && col.frontEndType !== 'boolean'"
                                      [(ngModel)]="element[col.property]">
                                      <ng-container *ngIf="col.property == 'ownerEmail'">
                                        <mat-option (onSelectionChange)="onOwnerSelected($event,opt,element)"
                                          *ngFor="let opt of filtereduserTypeList; let i=index;" [value]="opt.email">
                                          {{opt.email}}
                                        </mat-option>
                                      </ng-container>

                                      <ng-container *ngIf="col.property == 'tagName' || col.property == 'Tags'">
                                        <mat-option
                                          (onSelectionChange)="setTagName($event,opt , element.entityId,element)"
                                          *ngFor="let opt of filteredtagsTypeList; let i=index;"
                                          [value]="opt.statusName">
                                          {{opt.statusName}}
                                        </mat-option>
                                      </ng-container>

                                      <ng-container *ngIf="col.property == 'sourceName'">
                                        <mat-option
                                          (onSelectionChange)="setSourceName($event,opt , element.entityId,element)"
                                          *ngFor="let opt of filteredLeadSourceTypeList; let i=index;"
                                          [value]="opt.sourceName">
                                          {{opt.sourceName}}
                                        </mat-option>
                                      </ng-container>

                                      <ng-container
                                        *ngIf="(col.optionValues && col.optionValues.length) || (col.options && col.options.length)">
                                        <mat-option
                                          *ngFor="let opt of (col.optionValues && col.optionValues.length ? col.optionValues : col.options)"
                                          [value]="opt?.countryName !== undefined ? opt?.countryName : (opt?.value !== undefined ? opt?.value : (opt?.name !== undefined ? opt?.name : opt))">
                                          {{ opt?.countryName || opt?.viewValue || opt?.value || opt?.name || opt?.label || opt }}
                                        </mat-option>
                                      </ng-container>

                                    </mat-select>

                                    <mat-select style="width: 100px;"
                                      *ngIf="col.inputType === 'boolean' || col.frontEndType === 'boolean'"
                                      [(ngModel)]="element[col.property]">
                                      <mat-option [value]="'YES'">Yes</mat-option>
                                      <mat-option [value]="'NO'">No</mat-option>
                                    </mat-select>

                                    <mat-select style="width: 100px;"
                                      *ngIf="col.inputType === 'multiSelect' || col.inputType === 'multiselect'"
                                      multiple [(ngModel)]="element[col.property]">

                                      <ng-container *ngIf="col.property == 'ownerEmail'">
                                        <mat-option (onSelectionChange)="onOwnerSelected($event,opt,element)"
                                          *ngFor="let opt of filtereduserTypeList; let i=index;" [value]="opt.email">
                                          {{opt.email}}
                                        </mat-option>
                                      </ng-container>

                                      <ng-container *ngIf="col.property == 'tagName' || col.property == 'Tags'">
                                        <mat-option
                                          (onSelectionChange)="setTagName($event,opt , element.entityId,element)"
                                          *ngFor="let opt of filteredtagsTypeList; let i=index;"
                                          [value]="opt.statusName">
                                          {{opt.statusName}}
                                        </mat-option>
                                      </ng-container>

                                      <ng-container *ngIf="col.property == 'tagName' || col.property == 'Tags'">
                                        <mat-option
                                          (onSelectionChange)="setTagName($event,opt , element.entityId,element)"
                                          *ngFor="let opt of filteredtagsTypeList; let i=index;"
                                          [value]="opt.statusName">
                                          {{opt.statusName}}
                                        </mat-option>
                                      </ng-container>

                                      <!-- <ng-container *ngIf="col.property == 'sourceName'">
                                        <mat-option
                                          (onSelectionChange)="setSourceName($event,opt , element.entityId,element)"
                                          *ngFor="let opt of filteredLeadSourceTypeList; let i=index;"
                                          [value]="opt.sourceName">
                                          {{opt.sourceName}}
                                        </mat-option>
                                      </ng-container> -->

                                      <ng-container
                                        *ngIf="(col.optionValues && col.optionValues.length) || (col.options && col.options.length)">
                                        <mat-option
                                          *ngFor="let opt of (col.optionValues && col.optionValues.length ? col.optionValues : col.options)"
                                          [value]="opt?.countryName !== undefined ? opt?.countryName : (opt?.value !== undefined ? opt?.value : (opt?.name !== undefined ? opt?.name : opt))">
                                          {{ opt?.countryName || opt?.viewValue || opt?.value || opt?.name || opt?.label || opt }}
                                        </mat-option>
                                      </ng-container>


                                    </mat-select>


                                  </ng-container>
                                  <ng-template #readMode>
                                    <span *ngIf="col.property.includes('customValuesIs'); else normalField">
                                      <ng-container
                                        *ngIf="col.frontEndType === 'boolean' || col.inputType === 'boolean'; else notBooleanCustom">
                                        <ng-container
                                          *ngIf="!element.isCustomizedValue || element.isCustomizedValue[col.propertyName] === null || element.isCustomizedValue[col.propertyName] === undefined || element.isCustomizedValue[col.propertyName] === ''; else hasValue">
                                          --
                                        </ng-container>
                                        <ng-template #hasValue>
                                          {{ (element.isCustomizedValue && (element.isCustomizedValue[col.propertyName]
                                          == 1 ||
                                          element.isCustomizedValue[col.propertyName] === '1' ||
                                          element.isCustomizedValue[col.propertyName] === true ||
                                          element.isCustomizedValue[col.propertyName] === 'true' ||
                                          element.isCustomizedValue[col.propertyName] === 'Yes' ||
                                          element.isCustomizedValue[col.propertyName] === 'YES')) ? 'Yes' : 'No' }}
                                        </ng-template>
                                      </ng-container>
                                      <ng-template #notBooleanCustom>
                                        {{ getColumnValue(element, col) }}
                                      </ng-template>
                                    </span>
                                    <ng-template #normalField>
                                      <ng-container
                                        *ngIf="col.frontEndType === 'boolean' || col.inputType === 'boolean'; else normalNotBoolean">
                                        <ng-container
                                          *ngIf="element[col.property] === null || element[col.property] === undefined || element[col.property] === ''; else normalHasValue">
                                          --
                                        </ng-container>
                                        <ng-template #normalHasValue>
                                          {{ (element[col.property] == 1 ||
                                          element[col.property] === '1' ||
                                          element[col.property] === true ||
                                          element[col.property] === 'true' ||
                                          element[col.property] === 'Yes' ||
                                          element[col.property] === 'YES') ? 'Yes' : 'No' }}
                                        </ng-template>
                                      </ng-container>
                                      <ng-template #normalNotBoolean>
                                        <span *ngIf="isPropertyColumn(col.property, col); else normalDefaultText"
                                          (click)="openPropertyName(element, col); $event.stopPropagation()"
                                          style="cursor: pointer;">
                                          {{ getPropertyDisplayValue(element, col) || '--' }}
                                        </span>
                                        <ng-template #normalDefaultText>
                                          {{ getColumnValue(element, col) }}
                                        </ng-template>
                                      </ng-template>
                                    </ng-template>
                                  </ng-template>
                                </span>

                              </ng-container>
                            </div>


                            <div *ngIf="col.property != 'actions' && col.property != 'select'
                          && col.property != 'lastActivityNotes' && col.property != 'favourite'
                           && col.property != 'icons'
                           && col.property != 'createdDate'
                           && col.property != 'updatedDate'
                            && col.property != 'activityCountOnLead'
                            && col.property != 'totalCallDuration'
                            && col.property != 'score'
                            && col.property != 'emailValid'
                            && col.property != 'emailBounced'
                            && col.property != 'firstResponseTime'
                            && col.property != 'lifeCycleStage'
                            && col.property != 'isClosedWon'
                            && col.attributeCode != 'OwnerFirstName'
                            && !isDateColumn(col)
                           " class="cell-actions"
                              [class.icons-static]="leadPageIconVisibility == 1 && col.property === 'name'">
                              <ng-container *ngIf="col.property === 'name'; else defaultEditIcon">
                                <button id="btn-open-details1" mat-icon-button [matTooltip]="isMobile ? '' : 'Open'"
                                  [matTooltipPosition]="isMobile ? '' : 'above'"
                                  (click)="details(element.entityId, element.attributeSetId); $event.stopPropagation()"
                                  [attr.guide]="'btn-open-details'" aria-label="Open details"
                                  class="icon-color icon-hover">
                                  <mat-icon style="font-size: 17px;">open_in_new</mat-icon>
                                </button>

                                <button id="btn-call-lead1" mat-icon-button [matTooltip]="isMobile ? '' : 'Call'"
                                  [matTooltipPosition]="isMobile ? '' : 'above'"
                                  (click)="phoneNumbercall(element); $event.stopPropagation()"
                                  [attr.guide]="'btn-call-lead'" aria-label="Make a call" class="icon-color icon-hover">
                                  <mat-icon style="font-size: 17px;">phone</mat-icon>
                                </button>

                                <button id="btn-send-email1" mat-icon-button [matTooltip]="isMobile ? '' : 'Send Email'"
                                  [matTooltipPosition]="isMobile ? '' : 'above'"
                                  (click)="openEmailPopup(element); $event.stopPropagation()"
                                  [attr.guide]="'btn-send-email'" aria-label="Send Email" class="icon-color icon-hover">
                                  <mat-icon style="font-size: 17px;">email</mat-icon>
                                </button>

                                <button id="btn-add-task1" mat-icon-button [matTooltip]="isMobile ? '' : 'Add Task'"
                                  [matTooltipPosition]="isMobile ? '' : 'above'"
                                  (click)="addLeadActivity('Follow Up', 0, null, element.entityId)"
                                  [attr.guide]="'btn-add-task'" aria-label="Task Actions" class="icon-color icon-hover">
                                  <mat-icon style="font-size: 17px;">task</mat-icon>
                                </button>

                                <button id="btn-add-note1" mat-icon-button [matTooltip]="isMobile ? '' : 'Add Note'"
                                  [matTooltipPosition]="isMobile ? '' : 'above'"
                                  (click)="createNote(null, 0, element.entityId)" [attr.guide]="'btn-add-note'"
                                  aria-label="Notes Actions" class="icon-color icon-hover">
                                  <mat-icon style="font-size: 17px;">assignment</mat-icon>
                                </button>

                                <button id="btn-send-whatsapp1" mat-icon-button
                                  [matTooltip]="isMobile ? '' : 'Send Whatsapp'"
                                  [matTooltipPosition]="isMobile ? '' : 'above'"
                                  (click)="phonewhatsapp(element); $event.stopPropagation()"
                                  [attr.guide]="'btn-send-whatsapp'" aria-label="Send Whatsapp"
                                  class="icon-color icon-hover">
                                  <img src="assets/icons/whatsapp.svg" alt="Whatsapp"
                                    style="width: 17px; height: 17px; vertical-align: middle;">
                                </button>

                              </ng-container>

                              <ng-template #defaultEditIcon>


                                <button [attr.guide]="'common-product-btn-edit-value' + '__' + sanitizeUrl(url)"
                                  [disabled]="!resourcePrivilege?.update" mat-icon-button *ngIf="!(editingCell?.rowId === element.entityId
                                 && editingCell?.colProperty === col.property)" aria-label="Edit value"
                                  class="icon-color icon-background">
                                  <mat-icon (click)="startEdit(element.entityId, col.property, element, col);
                                   $event.stopPropagation()" [attr.guide]="'btn-start-edit-cell'"
                                    style="font-size: 17px;">edit</mat-icon>
                                </button>

                                <button [attr.guide]="'common-product-btn-save-value' + '__' + sanitizeUrl(url)"
                                  mat-icon-button
                                  *ngIf="editingCell?.rowId === element.entityId && editingCell?.colProperty === col.property"
                                  aria-label="Save value" class="icon-color icon-background">
                                  <mat-icon
                                    (click)="saveEdit(element.entityId, col.property , element[col.property],element , col); $event.stopPropagation()"
                                    [attr.guide]="'btn-save-edit-cell'" style="font-size: 17px;">check</mat-icon>
                                </button>

                                <button [attr.guide]="'common-product-btn-cancel-value' + '__' + sanitizeUrl(url)"
                                  mat-icon-button *ngIf="editingCell?.rowId === element.entityId 
                                && editingCell?.colProperty === col.property" aria-label="Cancel edit"
                                  class="icon-color icon-background">
                                  <mat-icon
                                    (click)="closeEdit(element.entityId, col.property , element[col.property],element); $event.stopPropagation()"
                                    [attr.guide]="'btn-cancel-edit-cell'" style="font-size: 17px;">close</mat-icon>
                                </button>


                              </ng-template>
                            </div>
                          </div>
                        </td>


                      </ng-container>
                    </ng-container>


                    <!-- Table footer -->
                    <tr mat-header-row *matHeaderRowDef="visibleColumns;sticky:true"></tr>
                    <!-- Use column properties -->
                    <tr mat-row *matRowDef="let row; columns: visibleColumns;"
                      [class.selected-row]="selection.isSelected(row)">
                    </tr>

                  </table>
                  <div class="products-padding" fxLayoutAlign="center center"
                    *ngIf="productList?.data?.length === 0 || productList?.length === 0">
                    No records found
                  </div>
                </div>


              </div>
              <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
                <mat-spinner [diameter]="20" *ngIf="spinner"></mat-spinner>
                <mat-paginator *ngIf="tableViewMode === 'tableView'" class="paginator" (page)="getUpdate($event)"
                  showFirstLastButtons [length]="pageList" [pageIndex]="page" [pageSize]="size"
                  [pageSizeOptions]="pageSizeValue">
                </mat-paginator>
              </div>

              <div *ngIf="tableViewMode == 'kanbanView'">
                <calsoft-crmdealskanban [resourcePrivilege]="resourcePrivilege"></calsoft-crmdealskanban>
              </div>
            </section>
          </main>
        </div>
      </div>

      <div class="side-form-container" *ngIf="isFilterPanelOpen" [fxFlex]="rowRight">
        <div class="side-form-card mat-elevation-z4" style="height: 100%;">
          <div style="flex: 1; display: flex; flex-direction: column; overflow: hidden; min-height: 0;">
            <calsoft-filter-list-popup
              style="display: flex; flex-direction: column; flex: 1; min-height: 0; height: 100%;" [type]="1"
              [columns]="columns" [filterSelectObj]="filterSelectObj"
              (filterChangeColumn)="onFilterChangeColumn($event,1)" [name]="'Lead'"
              (closePopup)="closePopupNew($event)"></calsoft-filter-list-popup>
          </div>
        </div>
      </div>

      <div class="side-form-container" *ngIf="isFilterPanelColumnOpen" [fxFlex]="rowRight">
        <div class="side-form-card mat-elevation-z4" style="height: 100%;">
          <div class="side-form-header" fxLayout="row" fxLayoutAlign="space-between center">
            <div class="title-area" fxLayout="row" fxLayoutAlign="space-between center">
              <!-- <mat-icon color="primary">view_column</mat-icon> -->
              <h3 style="margin: 0; margin-left: 5px;">Filter By Column</h3>
            </div>
            <button mat-icon-button (click)="toggleFilterColumnPanel()" aria-label="Close filter panel"
              [attr.guide]="sanitizedUrl + '-btn-close-filter-column'">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <div class="side-form-content">
            <calsoft-column-visibility [columns]="columns" [filterType]="true"
              (filterChangeColumn)="onFilterChangeColumn($event,1)"
              (closePopup)="closePopupTwo($event)"></calsoft-column-visibility>
          </div>
        </div>
      </div>

    </div>

    <div *ngIf="GridType ==  8 && (display || leadTypeInMobile == 0)" class="custom-table gridtable-class"
      [class.filter-open-layout]="isFilterPanelOpen || isFilterPanelColumnOpen" fxLayout="row" [fxLayoutGap]="rowgap">
      <div [fxFlex]="rowLeft" *ngIf="isGridVisible" style="width: 100%;">
        <div class="crm-container-new-eight">

          <main class="main-content">


            <section class="contacts-view">
              <div class="contacts-header">
                <section>
                  <div>
                    <h2 *ngIf="!contactPage&&!connectedCall" class="sg-title">{{(currentRouterPath | moduleName) ||
                      'Lead'}}
                    </h2>
                    <h2 *ngIf="contactPage&&!connectedCall" class="sg-title">{{(currentRouterPath | moduleName) ||
                      'Contacts'}}
                    </h2>
                  </div>
                </section>
                <!-- <section class="sg-container">
                <div class="sg-header">
                  <h2 *ngIf="!contactPage&&!connectedCall" class="sg-title">{{(currentRouterPath | moduleName) ||
                    'Lead'}}
                  </h2>  
                </div>
              </section> -->
                <div class="contact-tabs" fxFlex="40" fxFlex.xs="100">
                  <!-- Tabs control area: arrows + scrollable tabs (occupies ~50% width) -->
                  <div *ngIf="tableViewMode === 'tableView'" class="tabs-controls">
                    <button type="button" class="tab-arrow left" (click)="scrollTabs('left', $event)"
                      [attr.guide]="'btn-scroll-tabs-left'" aria-label="Scroll left">
                      <mat-icon>chevron_left</mat-icon>
                    </button>

                    <div class="tabs-scroll" #tabsScroll>

                      <span *ngIf="!contactPage&&!connectedCall">
                        <span class="tab-item" [class.active]="activeTab === 'new'" [attr.guide]="'tab-new-lead'"
                          (click)="onTabClick('new', $event)">
                          New Lead<span class="count" *ngIf="activeTab === 'new'">{{newContactCount || 0}}</span>
                        </span>
                      </span>

                      <span *ngIf="!contactPage&&!connectedCall">
                        <span *ngIf="!contactPage&&!connectedCall" class="tab-item" [class.active]="activeTab === 'all'"
                          [attr.guide]="'tab-all-lead'" (click)="onTabClick('all', $event)">
                          All Lead <span *ngIf="activeTab === 'all'" class="count">{{pageList}}</span>
                        </span>

                      </span>

                      <span *ngIf="contactPage">
                        <span class="tab-item" [class.active]="activeTab === 'all'" [attr.guide]="'tab-all-contacts'"
                          (click)="onTabClick('all', $event)">
                          All Contacts <span *ngIf="activeTab === 'all'" class="count">{{pageList}}</span>
                        </span>


                      </span>


                      <span *ngFor="let tab of smartViewList; let i = index">
                        <span class="tab-item" [class.active]="activeTab === tab.tabName"
                          [attr.guide]="'tab-' + tab.tabName" (click)="onClickTabData(tab)">
                          {{tab.tabName}} <span class="count" *ngIf="activeTab === tab.tabName">{{pageList|| 0}}</span>
                        </span>
                      </span>

                    </div>

                    <button type="button" class="tab-arrow right" (click)="scrollTabs('right', $event)"
                      [attr.guide]="'btn-scroll-tabs-right'" aria-label="Scroll right">
                      <mat-icon>chevron_right</mat-icon>
                    </button>
                  </div>
                </div>
                <div class="contact-actions" fxFlex fxLayout="row" fxLayout.xs="column" fxLayoutAlign="end center">
                  <button mat-button [matMenuTriggerFor]="leadMenu" class="btn btn-outline bhover"
                    [attr.guide]="'btn-more-actions'">
                    <!-- <mat-icon>more_horiz</mat-icon> -->
                    More Actions
                  </button>

                  <!-- The popup menu -->
                  <mat-menu #leadMenu="matMenu">
                    <!-- <button [attr.guide]="'common-product-btn-23' + '__' + sanitizeUrl(url)" mat-menu-item (click)="housingLeadData()">
                    <mat-icon class="material-icons-outlined mat-icon-sm">date_range</mat-icon>
                    <span>Common Floor Lead</span>
                  </button> -->

                    <button *ngIf="!selection.isEmpty()" mat-menu-item [attr.guide]="'menu-whatsapp'"
                      (click)="sendWhatsappMessage()">
                      <img src="assets/icons/whatsapp.svg" alt="Whatsapp"
                        style="width: 17px; height: 17px; vertical-align: middle; margin-right: 4px;">
                      <span>Whatsapp Message</span>
                    </button>

                    <button *ngIf="!selection.isEmpty()&&dialerType == 5" mat-menu-item [attr.guide]="'menu-autodial'"
                      (click)="sequenceCallWithWebsocketConnect()">
                      <mat-icon style="font-size: 17px;padding-top: 5px;" class="primary-icon">call</mat-icon>
                      <span> Auto dial</span>
                    </button>

                    <button [disabled]="!read" (click)="LeadOwnerSearch(productList)" [attr.guide]="'menu-owner-search'"
                      mat-menu-item>
                      <mat-icon>settings_phone</mat-icon>
                      <span>Lead Owner Search</span>
                    </button>

                    <button *ngIf="!selection.isEmpty()" mat-menu-item [attr.guide]="'menu-send-email'"
                      (click)="sendEmailMessage()">
                      <mat-icon class="material-icons-outlined mat-icon-sm">email</mat-icon>
                      <span>Send Email</span>
                    </button>
                  </mat-menu>
                  <button class="btn btn-outline bhover" [attr.guide]="'btn-refresh'" (click)="refresh()">
                    <mat-icon>refresh</mat-icon>
                    Refresh</button>

                  <button (click)="bulkUpload ? restritionPopup() : exportDataFilter()" *ngIf="!connectedCall"
                    class="btn btn-outline bhover" [attr.guide]="'btn-export'">
                    <mat-icon>file_download</mat-icon>
                    Export</button>

                  <button *ngIf="!contactPage&&!connectedCall" class="btn btn-outline bhover"
                    [attr.guide]="'btn-import-advance'" (click)="importExcelAdvance()">
                    <mat-icon>cloud_upload</mat-icon>
                    Import
                    Lead</button>

                  <button [attr.guide]="'common-product-btn-25' + '__' + sanitizeUrl(url)" guide="add-lead"
                    *ngIf="!contactPage&&!connectedCall" class="btn btn-primary"
                    (click)="addproduct()"><mat-icon>add</mat-icon>
                    Add Lead</button>
                </div>
              </div>

              <div class="main-layout-container" [class.filter-open]="isFilterPanelOpen"
                [class.filter-column-open]="isFilterPanelColumnOpen">
                <div class="left-content-layout">
                  <div class="table-controls-wrapper">

                    <div class="table-controls" *ngIf="isSelectionEmpty()">

                      <div class="contacts-header">
                        <div class="contact-actions">

                          <button [attr.guide]="'common-product-btn-26' + '__' + sanitizeUrl(url)"
                            class="btn btn-outline bhover" mat-button [matMenuTriggerFor]="viewTableMenu"
                            style="justify-content: center;"><mat-icon>table_chart</mat-icon> Table </button>

                          <button [attr.guide]="'common-product-btn-27' + '__' + sanitizeUrl(url)" mat-button
                            [matMenuTriggerFor]="viewMenu" class="btn-two btn-outline bhover">
                            <mat-icon>layers</mat-icon>
                          </button>

                          <button class="btn btn-outline bhover" [attr.guide]="'table-search-btn'"
                            (click)="goToPopUp()">
                            <mat-icon>search</mat-icon>
                          </button>

                          <mat-menu #viewTableMenu="matMenu">
                            <button [attr.guide]="'common-product-btn-28' + '__' + sanitizeUrl(url)" mat-menu-item
                              (click)="setTableView('tableView')">
                              <mat-icon>table_chart</mat-icon>
                              <span style="margin-left: 8px;">Table View</span>

                              <mat-icon *ngIf="tableViewMode != 'kanbanView'">check</mat-icon>
                            </button>
                            <button [attr.guide]="'common-product-btn-29' + '__' + sanitizeUrl(url)" mat-menu-item
                              (click)="setTableView('kanbanView')">
                              <mat-icon>view_column</mat-icon>
                              <span style="margin-left: 8px;">Kanban View</span>
                              <mat-icon *ngIf="tableViewMode == 'kanbanView'">check</mat-icon>

                            </button>
                          </mat-menu>


                          <mat-menu #viewMenu="matMenu">
                            <button [attr.guide]="'common-product-btn-30' + '__' + sanitizeUrl(url)" mat-menu-item
                              (click)="setView('compact')">
                              <mat-icon>compress</mat-icon>
                              <span style="margin-left: 8px;">Compact</span>
                              <mat-icon *ngIf="viewMode === 'compact'" style="margin-left:5px;">check</mat-icon>
                            </button>
                            <button [attr.guide]="'common-product-btn-31' + '__' + sanitizeUrl(url)" mat-menu-item
                              (click)="setView('comfortable')">
                              <mat-icon>expand</mat-icon>
                              <span style="margin-left: 8px;">Comfortable</span>
                              <mat-icon *ngIf="viewMode === 'comfortable'" style="margin-left:5px;">check</mat-icon>
                            </button>
                          </mat-menu>

                          <button [attr.guide]="'common-product-btn-32' + '__' + sanitizeUrl(url)"
                            class="btn btn-outline bhover" (click)="selectAllForBulkAction()">Bulk actions</button>
                          <button [attr.guide]="'common-product-btn-33' + '__' + sanitizeUrl(url)"
                            class="btn btn-outline bhover d-flex align-items-center gap-2"
                            [class.active-filter]="filterActive" (click)="toggleFilterPanel()">
                            <!-- Icon switches based on filterActive -->
                            <mat-icon class="me-1">
                              {{ filterActive ? 'filter_alt' : 'filter_list' }}
                            </mat-icon>

                            <span>Filter</span>

                            <!-- Nice little pill when applied -->
                            <span *ngIf="filterActive" class="filter-pill">
                              <mat-icon class="pill-icon">check_circle</mat-icon>

                            </span>
                          </button>
                          <button [attr.guide]="'common-product-btn-34' + '__' + sanitizeUrl(url)"
                            class="btn btn-outline bhover" (click)="toggleFilterColumnPanel()"
                            [class.active-filter]="isFilterPanelColumnOpen">
                            Filter by Columns
                          </button>

                          <button [attr.guide]="'common-product-btn-35' + '__' + sanitizeUrl(url)"
                            *ngIf="!contactPage&&!connectedCall"
                            class="btn btn-outline bhover d-flex align-items-center gap-2"
                            [class.active-filter]="advanceFilterEnble" (click)="advanceFilter()">
                            <mat-icon>{{ advanceFilterEnble ? 'filter_alt' : 'add' }}</mat-icon>
                            <span>Advance Filter</span>
                            <span *ngIf="advanceFilterEnble" class="filter-pill">
                              <mat-icon class="pill-icon">check_circle</mat-icon>
                            </span>
                          </button>
                          <!-- <button [attr.guide]="'common-product-btn-36' + '__' + sanitizeUrl(url)" *ngIf="!contactPage&&!connectedCall" class="btn btn-outline" (click)="LeadOwnerSearch(productList)">
                      <mat-icon>settings_phone</mat-icon>
                      Lead Owner Search</button> -->
                          <button [disabled]="!resourcePrivilege?.delete" *ngIf="!contactPage&&!connectedCall"
                            class="btn btn-outline bhover" [attr.guide]="'btn-delete-all'"
                            (click)="deleteAllProductDialog()">
                            <mat-icon>delete_forever</mat-icon>
                            Delete All</button>

                        </div>
                      </div>


                    </div>

                    <div class="bulk-action-bar" *ngIf="!isSelectionEmpty()">
                      <div class="contacts-header">
                        <div class="contact-actions">
                          <span class="selection-count">{{ getSelectedCount() }} selected</span>
                          <button class="btn btn-outline" [disabled]="!resourcePrivilege?.update"
                            [attr.guide]="'btn-bulk-transfer'" (click)="transferLead(0)">Transfer</button>
                          <button class="btn btn-outline" [disabled]="!resourcePrivilege?.update"
                            [attr.guide]="'btn-bulk-random-assign'" (click)="transferLead(1)">Random Assign</button>
                          <button class="btn btn-outline" [attr.guide]="'btn-bulk-download'"
                            (click)="bulkUpload ? restritionPopup() : exportDataFilterSelected('selected')">Download
                            Selected</button>
                          <button class="btn btn-outline" [disabled]="!resourcePrivilege?.delete"
                            [attr.guide]="'btn-bulk-delete'" (click)="deleteSelectedDialog()">Delete Selected </button>

                          <button class="btn btn-outline" [disabled]="!resourcePrivilege?.update"
                            [attr.guide]="'btn-bulk-sequence'" (click)="SequenceStatusPopup('selected',null)">Add Leads
                            To
                            Sequence </button>
                          <button class="btn btn-outline" [disabled]="!resourcePrivilege?.update"
                            [attr.guide]="'btn-bulk-update-status'" (click)="UpdateStatus()">Update Status </button>
                          <div class="cancel-action">
                            <button [attr.guide]="'common-product-btn-37' + '__' + sanitizeUrl(url)" mat-button
                              (click)="cancelBulkSelection()">
                              <mat-icon>close</mat-icon> Cancel selection
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="leads-content-area">
                    <div class="view-content">
                      <div *ngIf="tableViewMode == 'tableView'">
                        <div class="table-wrapper">


                          <table mat-table [dataSource]="productList" matSort (matSortChange)="sortData($event)"
                            class="contacts-table" [ngClass]="viewMode">

                            <ng-container *ngFor="let col of columns; trackBy: trackByProp"
                              [sticky]="!isMobile && col.isSticky" [matColumnDef]="col.property">
                              <ng-container *ngIf="col.isModelProperty!='false'">

                                <ng-container *ngIf="col.property !== 'actions' && col.property !== 'name'">
                                  <th mat-header-cell *matHeaderCellDef mat-sort-header [appResizable]="col.property"
                                    [tableId]="'lead-table-grid8'" storageStrategy="external"
                                    [initialWidth]="columnWidths[col.property] || null"
                                    (widthResized)="onColumnResized(col.property, $event)"
                                    (resizeEnd)="onColumnResizeEnd(col.property, $event)" style="min-width: 150px;">
                                    {{ col.name }}
                                  </th>
                                </ng-container>
                                <ng-container *ngIf="col.property === 'name'">
                                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="name-col-fixed">
                                    {{ col.name }}
                                  </th>
                                </ng-container>
                                <ng-container *ngIf="col.property === 'actions'">
                                  <th mat-header-cell *matHeaderCellDef class="actions-cell" [appResizable]="'actions'"
                                    [tableId]="'lead-table-grid8'" storageStrategy="external"
                                    [initialWidth]="columnWidths['actions'] || null"
                                    (widthResized)="onColumnResized('actions', $event)"
                                    (resizeEnd)="onColumnResizeEnd('actions', $event)">
                                    {{ col.name }}
                                  </th>
                                </ng-container>

                                <td mat-cell *matCellDef="let element ;let i = index" class="hover-cell"
                                  [class.name-col-fixed]="col.property === 'name'"
                                  [class.active-edit]="editingCell?.rowId === element.entityId && editingCell?.colProperty === col.property"
                                  [style.maxWidth]="col.property !== 'name' ? ((columnWidths[col.property] > 0 ? columnWidths[col.property] : 80) + 'px') : null"
                                  [style.minWidth]="col.property !== 'name' ? '80px' : null"
                                  [ngClass]="{'hide-icons': columnWidths[col.property] < 250, 'hide-avatar': columnWidths[col.property] < 120}">
                                  <div class="cell-content-wrapper">
                                    <div class="cell-data" style="padding-left: 15px;">

                                      <ng-container [ngSwitch]="col.property">


                                        <span *ngSwitchCase="'name'">
                                          <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else nameReadMode">

                                            <input [attr.guide]="'common-product-inp-38' + '__' + sanitizeUrl(url)"
                                              *ngIf="col.inputType === 'text'" matInput [(ngModel)]="element.name"
                                              placeholder="Enter name" />

                                          </ng-container>
                                          <ng-template #nameReadMode>
                                            <div class="user-cell">
                                              <img *ngIf="element.avatarUrl" [src]="element.avatarUrl"
                                                class="contact-avatar" />
                                              <div *ngIf="!element.avatarUrl" class="contact-avatar owner-avatar">
                                                {{ getInitialsTwo(element.name || element.ownerIdName) }}
                                              </div>
                                              <span (click)="openLeadPanel(element)" class="name-cell"
                                                [attr.guide]="'link-lead-name'">{{ element.name || '(No
                                                Name)' }}</span>
                                            </div>
                                          </ng-template>
                                        </span>

                                        <span *ngSwitchCase="'email'">
                                          <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else emailReadMode">

                                            <input [attr.guide]="'common-product-inp-39' + '__' + sanitizeUrl(url)"
                                              *ngIf="col.inputType === 'text'" matInput [(ngModel)]="element.email"
                                              placeholder="Enter email" />
                                          </ng-container>
                                          <ng-template #emailReadMode>
                                            <div class="user-cell1">
                                              <a (click)="openEmailPopup(element)" class="name-cell"
                                                [attr.guide]="'link-lead-email'">{{ element.email || '(No
                                                Email)' }}</a>
                                            </div>
                                          </ng-template>
                                        </span>


                                        <span *ngSwitchCase="'phoneNumber'">
                                          <ng-container *ngIf="editingCell?.rowId === element.entityId 
                                && editingCell?.colProperty === col.property; else phoneNumberReadMode">

                                            <div
                                              style="display: flex; flex-direction: column; gap: 6px; padding: 4px 0;">
                                              <input [attr.guide]="'common-product-inp-40' + '__' + sanitizeUrl(url)"
                                                *ngIf="col.inputType === 'text'" numbersOnly matInput
                                                [(ngModel)]="element.phoneNumber" placeholder="Primary Phone Number" />
                                              <input
                                                [attr.guide]="'common-product-inp-40-sec' + '__' + sanitizeUrl(url)"
                                                *ngIf="col.inputType === 'text'" numbersOnly matInput
                                                [(ngModel)]="element.secondaryphoneno"
                                                placeholder="Secondary Phone Number" />
                                            </div>

                                          </ng-container>
                                          <ng-template #phoneNumberReadMode>
                                            <div class="user-cell"
                                              style="display: flex; flex-direction: column; align-items: flex-start; justify-content: center;">
                                              <div *ngIf="element.phoneNumber != null && element.phoneNumber !== ''">
                                                <span *ngIf="encryptPhone==0">
                                                  {{ element.phoneNumber }}
                                                </span>
                                                <span *ngIf="encryptPhone==1">
                                                  {{ element.phoneNumber | slice:0:4 }} ****
                                                </span>
                                              </div>
                                              <div
                                                *ngIf="element.secondaryphoneno != null && element.secondaryphoneno !== ''"
                                                style="margin-top: 4px;">
                                                <span *ngIf="encryptPhone==0">
                                                  {{ element.secondaryphoneno }}
                                                </span>
                                                <span *ngIf="encryptPhone==1">
                                                  {{ element.secondaryphoneno | slice:0:4 }} ****
                                                </span>
                                              </div>
                                            </div>
                                          </ng-template>
                                        </span>



                                        <span *ngSwitchCase="'statusName'">
                                          <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else statusNameReadMode">

                                            <mat-select style="width: 100px;" *ngIf="col.inputType === 'select'"
                                              [(ngModel)]="element[col.property]">

                                              <ng-container *ngIf="col.property == 'statusName'">
                                                <mat-option
                                                  (onSelectionChange)="setStatusName($event,opt , element.entityId,element)"
                                                  *ngFor="let opt of filteredleadStatusTypeList; let i=index;"
                                                  [value]="opt.statusName">
                                                  {{opt.statusName}}
                                                </mat-option>
                                              </ng-container>

                                            </mat-select>

                                          </ng-container>


                                          <ng-template #statusNameReadMode>
                                            <span class="user-cell user-lead-status"
                                              [style.background-color]="element.leadStatusColour"
                                              [style.color]="element.darkTextColor">
                                              <!-- {{ element.statusName }} -->
                                              {{ getStatusName(element.statusName) }}
                                            </span>
                                          </ng-template>
                                        </span>

                                        <span *ngSwitchCase="'Country'">
                                          <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else countryReadMode">

                                            <mat-select style="width: 100px;" *ngIf="col.inputType === 'select'"
                                              [(ngModel)]="element[col.property]">

                                              <ng-container
                                                *ngIf="col.property == 'Country' || col.property == 'country' || col.property == 'customValuesIsCountry' || col.property == 'Country_cust'">
                                                <mat-option *ngFor="let opt of (filteredcountryTypeList || countryTypeList); let i=index;"
                                                  [value]="opt?.countryName || opt?.name || opt">
                                                  {{opt?.countryName || opt?.name || opt}}
                                                </mat-option>
                                              </ng-container>

                                            </mat-select>

                                          </ng-container>


                                          <ng-template #countryReadMode>
                                            <span class="user-cell user-lead-country">
                                              {{element.country || element.Country || element.customValuesIsCountry ||
                                              element.Country_cust || '--'}}
                                            </span>
                                          </ng-template>
                                        </span>


                                        <span *ngSwitchCase="'tagName'">
                                          <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else tagNameReadMode">

                                            <mat-select style="width: 100px;"
                                              *ngIf="col.inputType === 'select'" [(ngModel)]="element[col.property]">

                                              <ng-container *ngIf="col.property == 'tagName' || col.property == 'Tags'">
                                                <mat-option
                                                  (onSelectionChange)="setTagName($event,opt , element.entityId,element)"
                                                  *ngFor="let opt of filteredtagsTypeList; let i=index;"
                                                  [value]="opt.statusName">
                                                  {{opt.statusName}}
                                                </mat-option>
                                              </ng-container>

                                            </mat-select>

                                          </ng-container>
                                          <ng-template #tagNameReadMode>
                                            <span class="user-cell user-lead-status"
                                              [style.background-color]="getTagColor(element.tagName || element.tagNames || element.Tags) || element.tagNameColour"
                                              [style.color]="getTagTextColor(element.tagName || element.tagNames || element.Tags) || element.darkTextColorTag">
                                              {{ getTagName(element.tagName || element.tagNames || element.Tags) }}
                                            </span>
                                          </ng-template>
                                        </span>


                                        <span *ngSwitchCase="'favourite'">
                                          <button class="fav-button" type="button" mat-icon-button
                                            (click)="toggleFavorite(element);"
                                            [ngClass]="{ 'favorite': element.favourite==1 }">
                                            <mat-icon>{{ element.favourite==1 ? 'favorite' : 'favorite_border' }}
                                            </mat-icon>
                                          </button>
                                        </span>

                                        <span *ngSwitchCase="'company'">
                                          <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else companyReadMode">

                                            <input [attr.guide]="'common-product-inp-41' + '__' + sanitizeUrl(url)"
                                              *ngIf="col.inputType === 'text'" matInput [(ngModel)]="element.company"
                                              (input)="onInlineCompanyInput($event, element)" [matAutocomplete]="auto"
                                              #autoTrigger="matAutocompleteTrigger" placeholder="Enter Company" />

                                            <mat-autocomplete #auto="matAutocomplete"
                                              (closed)="onInlineAutocompleteClosed(element)">
                                              <mat-option (onSelectionChange)="onCompanySelected($event,opt,element)"
                                                *ngFor="let opt of companyList" [value]="opt.name">
                                                {{ opt.name }}
                                              </mat-option>
                                              <!-- <mat-option *ngIf="companyList?.length === 0" disabled>
                                      No company found
                                    </mat-option> -->

                                              <mat-option (onSelectionChange)="addNewCompany(element,element.company)"
                                                *ngIf="companyList?.length === 0 && element.company">
                                                <mat-icon color="primary" class="mr-2">add_circle</mat-icon>
                                                Add "{{ element.company }}" as a new company
                                              </mat-option>
                                            </mat-autocomplete>


                                          </ng-container>
                                          <ng-template #companyReadMode>
                                            <span (click)="companyNavigation(element.companyId)" class="user-cell"
                                              [attr.guide]="'link-company'">
                                              {{ element.company }}
                                            </span>
                                          </ng-template>
                                        </span>

                                        <span *ngSwitchCase="'icons'">
                                          <div *ngIf="element.phoneNumber != null"
                                            style="display: flex; align-items: center;">
                                            <mat-icon (click)="phoneNumbercall(element); $event.stopPropagation()"
                                              [attr.guide]="'icon-phone-call'" [icIcon]="icPhone" size="18px"
                                              style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                                            </mat-icon>
                                            <img (click)="phonewhatsapp(element); $event.stopPropagation()"
                                              [attr.guide]="'icon-whatsapp'" src="assets/icons/whatsapp.svg"
                                              alt="Whatsapp"
                                              style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                                          </div>

                                          <div
                                            *ngIf="element.secondaryphoneno != null && element.secondaryphoneno !== ''"
                                            style="margin-top: 5px; display: flex; align-items: center;">
                                            <mat-icon
                                              (click)="secondaryphoneNumbercall(element); $event.stopPropagation()"
                                              [attr.guide]="'icon-sec-phone-call'" [icIcon]="icPhone" size="18px"
                                              style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                                            </mat-icon>
                                            <img
                                              (click)="secondaryphonewhatsapp(element.customField10); $event.stopPropagation()"
                                              [attr.guide]="'icon-sec-whatsapp'" src="assets/icons/whatsapp.svg"
                                              alt="Whatsapp"
                                              style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                                          </div>
                                        </span>

                                        <!-- Created Date -->
                                        <span *ngSwitchCase="'totalCallDuration'">
                                          {{ formatSecondsToTime(element.totalCallDuration) }}
                                        </span>

                                        <span *ngSwitchCase="'createdDate'">
                                          <ng-container *ngIf="element.createdDate; else noDate">
                                            {{ element.createdDate | date: 'medium' }}
                                          </ng-container>
                                          <ng-template #noDate>--</ng-template>
                                        </span>

                                        <span *ngSwitchCase="'emailValid'">
                                          <ng-container *ngIf="element.emailValid">
                                            {{ element.emailValid==1 ? 'true' : 'false' }}
                                          </ng-container>

                                        </span>

                                        <span *ngSwitchCase="'firstResponseTime'">
                                          <ng-container *ngIf="element.firstResponseTime">

                                            {{ element.firstResponseTime | date: 'medium' }}
                                          </ng-container>

                                        </span>



                                        <span *ngSwitchCase="'lastActivityNotes'">
                                          <ng-container>
                                            {{ element.lastActivityNotes}}
                                          </ng-container>

                                        </span>

                                        <!-- Updated Date -->
                                        <span *ngSwitchCase="'updatedDate'">
                                          <ng-container *ngIf="element.updatedDate; else noDateUpdated">
                                            {{ element.updatedDate | date: 'medium' }}
                                          </ng-container>
                                          <ng-template #noDateUpdated>--</ng-template>
                                        </span>


                                        <span *ngSwitchCase="'select'">

                                          <mat-checkbox [attr.guide]="'common-product-chk-42' + '__' + sanitizeUrl(url)"
                                            (click)="$event.stopPropagation()"
                                            (change)="changeValue($event.checked, element); $event ? selection.toggle(element) : null"
                                            [checked]="selection.isSelected(element) || isRowSelected(element)"
                                            [aria-label]="checkboxLabel(element)">
                                          </mat-checkbox>

                                        </span>

                                        <span *ngSwitchCase="'actions'">
                                          <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                                            [attr.guide]="'btn-row-actions'" (click)="$event.stopPropagation()"
                                            class="premium-action-trigger">
                                            <mat-icon>more_horiz</mat-icon>
                                          </button>
                                          <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before"
                                            class="premium-action-menu">
                                            <button [disabled]="!resourcePrivilege?.update"
                                              (click)="editProduct(element.entityId, element.attributeSetId)"
                                              [attr.guide]="'menu-edit-lead'" mat-menu-item class="menu-item-edit">
                                              <mat-icon>edit_note</mat-icon>
                                              <span>Edit Details</span>
                                            </button>

                                            <button [disabled]="!resourcePrivilege?.delete"
                                              (click)="deleteAllProductId(element.entityId)"
                                              [attr.guide]="'menu-delete-lead'" mat-menu-item class="menu-item-delete">
                                              <mat-icon>delete_outline</mat-icon>
                                              <span>Delete</span>
                                            </button>

                                            <mat-divider
                                              *ngIf="leadToCustomer == 1 || enableSequence || crmType==0 || crmType==4"></mat-divider>

                                            <button *ngIf="leadToCustomer == 1" (click)="getApprove(element)"
                                              [attr.guide]="'menu-convert-customer'" mat-menu-item
                                              class="menu-item-convert">
                                              <mat-icon>swap_horiz</mat-icon>
                                              <span>Convert to Customer</span>
                                            </button>

                                            <button *ngIf="enableSequence"
                                              (click)="SequenceStatusPopup('single',element)"
                                              [attr.guide]="'menu-add-sequence'" mat-menu-item
                                              class="menu-item-sequence">
                                              <mat-icon>playlist_add</mat-icon>
                                              <span>Add Lead Sequences</span>
                                            </button>

                                            <ng-container *ngIf="crmType==0 || crmType==4 || enableEditStatusPopup==1">
                                              <button (click)="openLeadStage(element, i)"
                                                [attr.guide]="'menu-lead-stage'" mat-menu-item class="menu-item-stage">
                                                <mat-icon>moving</mat-icon>
                                                <span>Lead Stage</span>
                                              </button>
                                              <ng-container *ngIf="crmType==0 || crmType==4">
                                                <button (click)="openLeadPriority(element)"
                                                  [attr.guide]="'menu-lead-priority'" mat-menu-item
                                                  class="menu-item-priority">
                                                  <mat-icon>flag</mat-icon>
                                                  <span>Add Lead Priority</span>
                                                </button>
                                              </ng-container>
                                            </ng-container>
                                          </mat-menu>
                                        </span>



                                        <span *ngSwitchCase="'Country'">
                                          <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else countryReadMode">
                                            <input
                                              [attr.guide]="'common-product-inp-43-country' + '__' + sanitizeUrl(url)"
                                              *ngIf="col.inputType === 'text'" matInput
                                              [(ngModel)]="element[col.property]" placeholder="Enter Country" />
                                          </ng-container>
                                          <ng-template #countryReadMode>
                                            <div class="user-cell" style="padding-left: 15px;">
                                              {{ element.Country || element.country ||
                                              element.isCustomizedValue?.Country || element.isCustomizedValue?.country
                                              || '--' }}
                                            </div>
                                          </ng-template>
                                        </span>

                                        <span *ngSwitchCase="'country'">
                                          <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else countryReadModeLower">
                                            <input
                                              [attr.guide]="'common-product-inp-43-country-lower' + '__' + sanitizeUrl(url)"
                                              *ngIf="col.inputType === 'text'" matInput
                                              [(ngModel)]="element[col.property]" placeholder="Enter Country" />
                                            <mat-select style="width: 100px;" *ngIf="col.inputType === 'select'"
                                              [(ngModel)]="element[col.property]">
                                              <ng-container
                                                *ngIf="col.property == 'Country' || col.property == 'country' || col.property == 'customValuesIsCountry' || col.property == 'Country_cust'">
                                                <mat-option *ngFor="let opt of (filteredcountryTypeList || countryTypeList); let i=index;"
                                                  [value]="opt?.countryName || opt?.name || opt">
                                                  {{opt?.countryName || opt?.name || opt}}
                                                </mat-option>
                                              </ng-container>
                                            </mat-select>
                                          </ng-container>
                                          <ng-template #countryReadModeLower>
                                            <div class="user-cell" style="padding-left: 15px;">
                                              {{ element.Country || element.country ||
                                              element.isCustomizedValue?.Country || element.isCustomizedValue?.country
                                              || '--' }}
                                            </div>
                                          </ng-template>
                                        </span>

                                        <span *ngSwitchCase="'City'">
                                          <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else cityReadMode">
                                            <input [attr.guide]="'common-product-inp-43-city' + '__' + sanitizeUrl(url)"
                                              *ngIf="col.inputType === 'text'" matInput
                                              [(ngModel)]="element[col.property]" placeholder="Enter City" />
                                          </ng-container>
                                          <ng-template #cityReadMode>
                                            <div class="user-cell" style="padding-left: 15px;">
                                              {{ element.City || element.city || element.isCustomizedValue?.City ||
                                              element.isCustomizedValue?.city || '--' }}
                                            </div>
                                          </ng-template>
                                        </span>

                                        <span *ngSwitchCase="'city'">
                                          <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else cityReadModeLower">
                                            <input
                                              [attr.guide]="'common-product-inp-43-city-lower' + '__' + sanitizeUrl(url)"
                                              *ngIf="col.inputType === 'text'" matInput
                                              [(ngModel)]="element[col.property]" placeholder="Enter City" />
                                          </ng-container>
                                          <ng-template #cityReadModeLower>
                                            <div class="user-cell" style="padding-left: 15px;">
                                              {{ element.City || element.city || element.isCustomizedValue?.City ||
                                              element.isCustomizedValue?.city || '--' }}
                                            </div>
                                          </ng-template>
                                        </span>

                                        <span *ngSwitchCase="'State'">
                                          <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else stateReadMode">
                                            <input
                                              [attr.guide]="'common-product-inp-43-state' + '__' + sanitizeUrl(url)"
                                              *ngIf="col.inputType === 'text'" matInput
                                              [(ngModel)]="element[col.property]" placeholder="Enter State" />
                                          </ng-container>
                                          <ng-template #stateReadMode>
                                            <div class="user-cell" style="padding-left: 15px;">
                                              {{ element.State || element.state || element.isCustomizedValue?.State ||
                                              element.isCustomizedValue?.state || '--' }}
                                            </div>
                                          </ng-template>
                                        </span>

                                        <span *ngSwitchCase="'state'">
                                          <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else stateReadModeLower">
                                            <input
                                              [attr.guide]="'common-product-inp-43-state-lower' + '__' + sanitizeUrl(url)"
                                              *ngIf="col.inputType === 'text'" matInput
                                              [(ngModel)]="element[col.property]" placeholder="Enter State" />
                                          </ng-container>
                                          <ng-template #stateReadModeLower>
                                            <div class="user-cell" style="padding-left: 15px;">
                                              {{ element.State || element.state || element.isCustomizedValue?.State ||
                                              element.isCustomizedValue?.state || '--' }}
                                            </div>
                                          </ng-template>
                                        </span>

                                        <span *ngSwitchDefault>
                                          <ng-container *ngIf="editingCell?.rowId === element.entityId 
                                && editingCell?.colProperty === col.property; else readMode">

                                            <input [attr.guide]="'common-product-inp-43' + '__' + sanitizeUrl(url)"
                                              *ngIf="col.inputType === 'text'" matInput
                                              [(ngModel)]="element[col.property]" placeholder="Enter value" />


                                            <mat-select style="width: 100px;"
                                              *ngIf="col.inputType === 'select' && col.frontEndType !== 'boolean'"
                                              [(ngModel)]="element[col.property]">
                                              <ng-container *ngIf="col.property == 'ownerEmail'">
                                                <mat-option (onSelectionChange)="onOwnerSelected($event,opt,element)"
                                                  *ngFor="let opt of filtereduserTypeList; let i=index;"
                                                  [value]="opt.email">
                                                  {{opt.email}}
                                                </mat-option>
                                              </ng-container>

                                              <ng-container *ngIf="col.property == 'tagName' || col.property == 'Tags'">
                                                <mat-option
                                                  (onSelectionChange)="setTagName($event,opt , element.entityId,element)"
                                                  *ngFor="let opt of filteredtagsTypeList; let i=index;"
                                                  [value]="opt.statusName">
                                                  {{opt.statusName}}
                                                </mat-option>
                                              </ng-container>

                                              <ng-container *ngIf="col.property == 'sourceName'">
                                                <mat-option
                                                  (onSelectionChange)="setSourceName($event,opt , element.entityId,element)"
                                                  *ngFor="let opt of filteredLeadSourceTypeList; let i=index;"
                                                  [value]="opt.sourceName">
                                                  {{opt.sourceName}}
                                                </mat-option>
                                              </ng-container>

                                              <ng-container
                                                *ngIf="(col.optionValues && col.optionValues.length) || (col.options && col.options.length)">
                                                <mat-option
                                                  *ngFor="let opt of (col.optionValues && col.optionValues.length ? col.optionValues : col.options)"
                                                  [value]="opt?.countryName !== undefined ? opt?.countryName : (opt?.value !== undefined ? opt?.value : (opt?.name !== undefined ? opt?.name : opt))">
                                                  {{ opt?.countryName || opt?.viewValue || opt?.value || opt?.name || opt?.label || opt }}
                                                </mat-option>
                                              </ng-container>

                                            </mat-select>

                                            <mat-select style="width: 100px;"
                                              *ngIf="col.inputType === 'boolean' || col.frontEndType === 'boolean'"
                                              [(ngModel)]="element[col.property]">
                                              <mat-option [value]="'YES'">Yes</mat-option>
                                              <mat-option [value]="'NO'">No</mat-option>
                                            </mat-select>


                                            <mat-select style="width: 100px;"
                                              *ngIf="col.inputType === 'multiSelect' || col.inputType === 'multiselect'"
                                              multiple [(ngModel)]="element[col.property]">

                                              <ng-container *ngIf="col.property == 'ownerEmail'">
                                                <mat-option (onSelectionChange)="onOwnerSelected($event,opt,element)"
                                                  *ngFor="let opt of filtereduserTypeList; let i=index;"
                                                  [value]="opt.email">
                                                  {{opt.email}}
                                                </mat-option>
                                              </ng-container>

                                              <ng-container *ngIf="col.property == 'tagName' || col.property == 'Tags'">
                                                <mat-option
                                                  (onSelectionChange)="setTagName($event,opt , element.entityId,element)"
                                                  *ngFor="let opt of filteredtagsTypeList; let i=index;"
                                                  [value]="opt.statusName">
                                                  {{opt.statusName}}
                                                </mat-option>
                                              </ng-container>

                                              <ng-container *ngIf="col.property == 'tagName' || col.property == 'Tags'">
                                                <mat-option
                                                  (onSelectionChange)="setTagName($event,opt , element.entityId,element)"
                                                  *ngFor="let opt of filteredtagsTypeList; let i=index;"
                                                  [value]="opt.statusName">
                                                  {{opt.statusName}}
                                                </mat-option>
                                              </ng-container>

                                              <!-- <ng-container *ngIf="col.property == 'sourceName'">
                                                <mat-option
                                                  (onSelectionChange)="setSourceName($event,opt , element.entityId,element)"
                                                  *ngFor="let opt of filteredLeadSourceTypeList; let i=index;"
                                                  [value]="opt.sourceName">
                                                  {{opt.sourceName}}
                                                </mat-option>
                                              </ng-container> -->

                                              <ng-container *ngIf="col.optionValues && col.optionValues.length">
                                                <mat-option *ngFor="let opt of col.optionValues" [value]="opt?.countryName !== undefined ? opt?.countryName : (opt?.value !== undefined ? opt?.value : (opt?.name !== undefined ? opt?.name : opt))">
                                                  {{ opt?.countryName || opt?.viewValue || opt?.value || opt?.name || opt?.label || opt }}
                                                </mat-option>
                                              </ng-container>


                                            </mat-select>


                                          </ng-container>
                                          <ng-template #readMode>
                                            <span *ngIf="col.property.includes('customValuesIs'); else normalField">
                                              <ng-container
                                                *ngIf="col.frontEndType === 'boolean' || col.inputType === 'boolean'; else notBooleanCustom">
                                                <ng-container
                                                  *ngIf="!element.isCustomizedValue || element.isCustomizedValue[col.propertyName] === null || element.isCustomizedValue[col.propertyName] === undefined || element.isCustomizedValue[col.propertyName] === ''; else hasValue2">
                                                  --
                                                </ng-container>
                                                <ng-template #hasValue2>
                                                  {{ (element.isCustomizedValue &&
                                                  (element.isCustomizedValue[col.propertyName] == 1 ||
                                                  element.isCustomizedValue[col.propertyName] === '1' ||
                                                  element.isCustomizedValue[col.propertyName] === true ||
                                                  element.isCustomizedValue[col.propertyName] === 'true' ||
                                                  element.isCustomizedValue[col.propertyName] === 'Yes' ||
                                                  element.isCustomizedValue[col.propertyName] === 'YES')) ? 'Yes' : 'No'
                                                  }}
                                                </ng-template>
                                              </ng-container>
                                              <ng-template #notBooleanCustom>
                                                {{ getColumnValue(element, col) }}
                                              </ng-template>
                                            </span>
                                            <ng-template #normalField>
                                              <ng-container
                                                *ngIf="col.frontEndType === 'boolean' || col.inputType === 'boolean'; else normalNotBoolean">
                                                <ng-container
                                                  *ngIf="element[col.property] === null || element[col.property] === undefined || element[col.property] === ''; else normalHasValue2">
                                                  --
                                                </ng-container>
                                                <ng-template #normalHasValue2>
                                                  {{ (element[col.property] == 1 ||
                                                  element[col.property] === '1' ||
                                                  element[col.property] === true ||
                                                  element[col.property] === 'true' ||
                                                  element[col.property] === 'Yes' ||
                                                  element[col.property] === 'YES') ? 'Yes' : 'No' }}
                                                </ng-template>
                                              </ng-container>
                                              <ng-template #normalNotBoolean>
                                                <span
                                                  *ngIf="isPropertyColumn(col.property, col); else normalDefaultText"
                                                  (click)="openPropertyName(element, col); $event.stopPropagation()"
                                                  style="cursor: pointer;">
                                                  {{ getPropertyDisplayValue(element, col) || '--' }}
                                                </span>
                                                <ng-template #normalDefaultText>
                                                  {{ getColumnValue(element, col) }}
                                                </ng-template>
                                              </ng-template>
                                            </ng-template>
                                          </ng-template>
                                        </span>

                                      </ng-container>
                                    </div>


                                    <div *ngIf="col.property != 'actions' && col.property != 'select'
                          && col.property != 'lastActivityNotes' && col.property != 'favourite'
                           && col.property != 'icons'
                           && col.property != 'createdDate'
                           && col.property != 'updatedDate'
                            && col.property != 'activityCountOnLead'
                            && col.property != 'totalCallDuration'
                            && col.property != 'score'
                            && col.property != 'emailValid'
                            && col.property != 'emailBounced'
                            && col.property != 'firstResponseTime'
                            && col.property != 'lifeCycleStage'
                            && col.property != 'isClosedWon'
                            && col.attributeCode != 'OwnerFirstName'
                            && !isDateColumn(col)
                           " class="cell-actions"
                                      [class.icons-static]="leadPageIconVisibility == 1 && col.property === 'name'">
                                      <ng-container *ngIf="col.property === 'name'; else defaultEditIcon">
                                        <button id="btn-open-details" mat-icon-button
                                          [matTooltip]="isMobile ? '' : 'Open'"
                                          [matTooltipPosition]="isMobile ? '' : 'above'"
                                          (click)="details(element.entityId, element.attributeSetId); $event.stopPropagation()"
                                          [attr.guide]="'btn-open-details'" aria-label="Open details"
                                          class="icon-color icon-hover">
                                          <mat-icon style="font-size: 17px;">open_in_new</mat-icon>
                                        </button>

                                        <button id="btn-call-lead" mat-icon-button [matTooltip]="isMobile ? '' : 'Call'"
                                          [matTooltipPosition]="isMobile ? '' : 'above'"
                                          (click)="phoneNumbercall(element); $event.stopPropagation()"
                                          [attr.guide]="'btn-call-lead'" aria-label="Make a call"
                                          class="icon-color icon-hover">
                                          <mat-icon style="font-size: 17px;">phone</mat-icon>
                                        </button>

                                        <button id="btn-send-email" mat-icon-button
                                          [matTooltip]="isMobile ? '' : 'Send Email'"
                                          [matTooltipPosition]="isMobile ? '' : 'above'"
                                          (click)="openEmailPopup(element); $event.stopPropagation()"
                                          [attr.guide]="'btn-send-email'" aria-label="Send Email"
                                          class="icon-color icon-hover">
                                          <mat-icon style="font-size: 17px;">email</mat-icon>
                                        </button>

                                        <button id="btn-add-task" mat-icon-button
                                          [matTooltip]="isMobile ? '' : 'Add Task'"
                                          [matTooltipPosition]="isMobile ? '' : 'above'"
                                          (click)="addLeadActivity('Follow Up', 0, null, element.entityId)"
                                          [attr.guide]="'btn-add-task'" aria-label="Task Actions"
                                          class="icon-color icon-hover">
                                          <mat-icon style="font-size: 17px;">task</mat-icon>
                                        </button>

                                        <button id="btn-add-note" mat-icon-button
                                          [matTooltip]="isMobile ? '' : 'Add Note'"
                                          [matTooltipPosition]="isMobile ? '' : 'above'"
                                          (click)="createNote(null, 0, element.entityId)" [attr.guide]="'btn-add-note'"
                                          aria-label="Notes Actions" class="icon-color icon-hover">
                                          <mat-icon style="font-size: 17px;">assignment</mat-icon>
                                        </button>

                                        <button id="btn-send-whatsapp" mat-icon-button
                                          [matTooltip]="isMobile ? '' : 'Send Whatsapp'"
                                          [matTooltipPosition]="isMobile ? '' : 'above'"
                                          (click)="phonewhatsapp(element); $event.stopPropagation()"
                                          [attr.guide]="'btn-send-whatsapp'" aria-label="Send Whatsapp"
                                          class="icon-color icon-hover">
                                          <img src="assets/icons/whatsapp.svg" alt="Whatsapp"
                                            style="width: 17px; height: 17px; vertical-align: middle;">
                                        </button>

                                      </ng-container>

                                      <ng-template #defaultEditIcon>

                                        <button [attr.guide]="'common-product-btn-edit-value' + '__' + sanitizeUrl(url)"
                                          [disabled]="!resourcePrivilege?.update" mat-icon-button *ngIf="!(editingCell?.rowId === element.entityId
                                  && editingCell?.colProperty === col.property)" aria-label="Edit value"
                                          class="icon-color icon-background">
                                          <mat-icon (click)="startEdit(element.entityId, col.property, element, col);
                                    $event.stopPropagation()" [attr.guide]="'btn-start-edit-cell'"
                                            style="font-size: 17px;">edit</mat-icon>
                                        </button>

                                        <button [attr.guide]="'common-product-btn-save-value' + '__' + sanitizeUrl(url)"
                                          mat-icon-button
                                          *ngIf="editingCell?.rowId === element.entityId && editingCell?.colProperty === col.property"
                                          aria-label="Save value" class="icon-color icon-background">
                                          <mat-icon
                                            (click)="saveEdit(element.entityId, col.property , element[col.property],element , col); $event.stopPropagation()"
                                            style="font-size: 17px;">check</mat-icon>
                                        </button>

                                        <button
                                          [attr.guide]="'common-product-btn-cancel-value' + '__' + sanitizeUrl(url)"
                                          mat-icon-button *ngIf="editingCell?.rowId === element.entityId 
                                 && editingCell?.colProperty === col.property" aria-label="Cancel edit"
                                          class="icon-color icon-background">
                                          <mat-icon
                                            (click)="closeEdit(element.entityId, col.property , element[col.property],element); $event.stopPropagation()"
                                            style="font-size: 17px;">close</mat-icon>
                                        </button>


                                      </ng-template>
                                    </div>
                                  </div>
                                </td>


                              </ng-container>
                            </ng-container>


                            <!-- Table footer -->
                            <tr mat-header-row *matHeaderRowDef="visibleColumns;sticky:true"></tr>
                            <!-- Use column properties -->
                            <tr mat-row *matRowDef="let row; columns: visibleColumns;"
                              [class.selected-row]="selection.isSelected(row)">
                            </tr>

                          </table>

                          <div class="products-padding" fxLayoutAlign="center center"
                            *ngIf="productList?.data?.length === 0 || productList?.length === 0">
                            No records found
                          </div>


                        </div>
                      </div>

                      <div *ngIf="tableViewMode == 'kanbanView'">
                        <calsoft-crmdealskanban [resourcePrivilege]="resourcePrivilege"></calsoft-crmdealskanban>
                      </div>
                      <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
                        <mat-spinner [diameter]="20" *ngIf="spinner"></mat-spinner>
                        <mat-paginator *ngIf="tableViewMode === 'tableView'" class="paginator"
                          (page)="getUpdate($event)" showFirstLastButtons [length]="pageList" [pageIndex]="page"
                          [pageSize]="size" [pageSizeOptions]="pageSizeValue">
                        </mat-paginator>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </section>
          </main>
        </div>
      </div>

      <div class="side-form-container" *ngIf="isFilterPanelOpen" [fxFlex]="rowRight">
        <div class="side-form-card mat-elevation-z4" style="height: 100%;">
          <div style="flex: 1; display: flex; flex-direction: column; overflow: hidden; min-height: 0;">
            <calsoft-filter-list-popup
              style="display: flex; flex-direction: column; flex: 1; min-height: 0; height: 100%;" [type]="1"
              [columns]="columns" [filterSelectObj]="filterSelectObj"
              (filterChangeColumn)="onFilterChangeColumn($event,1)" [name]="'Lead'"
              (closePopup)="closePopupNew($event)"></calsoft-filter-list-popup>
          </div>
        </div>
      </div>

      <div class="side-form-container" *ngIf="isFilterPanelColumnOpen" [fxFlex]="rowRight">
        <div class="side-form-card mat-elevation-z4" style="height: 100%;">
          <div class="side-form-header" fxLayout="row" fxLayoutAlign="space-between center">
            <div class="title-area" fxLayout="row" fxLayoutAlign="space-between center">
              <!-- <mat-icon color="primary">view_column</mat-icon> -->
              <h3 style="margin: 0; margin-left: 5px;">Filter By Column</h3>
            </div>
            <button mat-icon-button (click)="toggleFilterColumnPanel()" aria-label="Close filter panel"
              [attr.guide]="sanitizedUrl + '-btn-close-filter-column'">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <div class="side-form-content">
            <calsoft-column-visibility [columns]="columns" [filterType]="true"
              (filterChangeColumn)="onFilterChangeColumn($event,1)"
              (closePopup)="closePopupTwo($event)"></calsoft-column-visibility>
          </div>
        </div>
      </div>

    </div>

    <div
      *ngIf="(GridType !=  8 && GridType !=  9) || (GridType == 8 && !display) && (display || leadTypeInMobile !== 0)">
      <calsoft-list [type]="leadType" [sirType]="GridType === 8" [progress]="spinner"
        [name]="(currentRouterPath | moduleName) || 'Lead'" [leadFilterType]="leadFilterType"
        [filterSelectObj]="filterSelectObj" [columns]="columns" (filterChangeColumn)="onFilterChangeColumn($event,1)"
        (filterChange)="onFilterChange($event,1)">

        <div class="actions">
          <button [attr.guide]="'common-product-btn-47' + '__' + sanitizeUrl(url)" mat-icon-button
            [matMenuTriggerFor]="viewMenu">
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #viewMenu="matMenu">
            <button [attr.guide]="'common-product-btn-48' + '__' + sanitizeUrl(url)" mat-menu-item
              (click)="selectView('leadView')">
              <mat-icon>view_list</mat-icon>
              <span>Lead View</span>
            </button>
            <button [attr.guide]="'common-product-btn-49' + '__' + sanitizeUrl(url)" mat-menu-item
              (click)="switchView('kanban')">
              <mat-icon>dashboard</mat-icon>
              <span>Kanban View</span>
            </button>
          </mat-menu>
        </div>

        <!-- Display Kanban View Conditionally -->

        <calsoft-crmdealskanban [resourcePrivilege]="resourcePrivilege"
          *ngIf="viewType === 'kanban'"></calsoft-crmdealskanban>

        <div class="actions" fxFlexAlign="center" fxHide fxShow.gt-md fxShow.gt-sm>
          <div *ngIf="!contactPage&&!connectedCall" style="border-radius: 4px; overflow: hidden; " class="colorbtnset">
            <button [attr.guide]="'common-product-btn-50' + '__' + sanitizeUrl(url)" [matMenuTriggerFor]="leadMenu"
              mat-button style="padding-right: 2px;padding-left: 10px;">Create
              Lead <mat-icon>arrow_drop_down</mat-icon>
            </button>
          </div>

          <mat-menu #leadMenu="matMenu">
            <button [attr.guide]="'common-product-btn-51' + '__' + sanitizeUrl(url)" mat-menu-item
              style="border-bottom: 1px solid lightgray;" (click)="addproduct()">Add Lead</button>

            <button [attr.guide]="'common-product-btn-52' + '__' + sanitizeUrl(url)"
              *ngIf="!contactPage&&!connectedCall" mat-menu-item (click)="importExcel()"
              style="border-bottom: 1px solid lightgray;">Import
              Lead</button>
            <button [attr.guide]="'common-product-btn-53' + '__' + sanitizeUrl(url)" mat-menu-item
              (click)="exportExcel()">Export Lead</button>
          </mat-menu>
        </div>

        <div class="actions" fxFlexAlign="center" fxHide fxShow.gt-md fxShow.gt-sm>
          <button [attr.guide]="'common-product-btn-54' + '__' + sanitizeUrl(url)" *ngIf="!contactPage&&!connectedCall"
            mat-button color="primary" class="actionbtnset" [matMenuTriggerFor]="actionsMenu">
            Actions
            <mat-icon style="margin-left: 4px;">arrow_drop_down</mat-icon>
          </button>

          <mat-menu [overlapTrigger]="false" xPosition="before" #actionsMenu="matMenu">
            <!-- <a [attr.guide]="'common-product-lnk-55' + '__' + sanitizeUrl(url)" mat-menu-item (click)="exportExcel()">
          <mat-icon class="material-icons-outlined mat-icon-sm">cloud_download</mat-icon>
          <span>Export-Excel-Template</span>
        </a>
        <a [attr.guide]="'common-product-lnk-56' + '__' + sanitizeUrl(url)" mat-menu-item (click)="importExcel()">
          <mat-icon class="material-icons-outlined mat-icon-sm">import_export</mat-icon>
          <span>Import-Excel</span>
        </a> -->

            <button [attr.guide]="'common-product-btn-57' + '__' + sanitizeUrl(url)"
              *ngIf="!selection.isEmpty()&&dialerType == 5" mat-menu-item (click)="sequenceCallWithWebsocketConnect()">
              <mat-icon style="font-size: 17px;padding-top: 5px;" class="primary-icon">call</mat-icon>
              <span> Auto dial</span>
            </button>

            <a [attr.guide]="'common-product-lnk-58' + '__' + sanitizeUrl(url)" mat-menu-item
              (click)="importExcelAdvance()">
              <mat-icon class="material-icons-outlined mat-icon-sm">import_export</mat-icon>
              <span>Import-Excel-Advance</span>
            </a>

            <a [attr.guide]="'common-product-lnk-59' + '__' + sanitizeUrl(url)" mat-menu-item (click)="advanceFilter()">
              <mat-icon class="material-icons-outlined mat-icon-sm">add</mat-icon>
              <span>Advance Filter</span>
            </a>

            <a [attr.guide]="'common-product-lnk-60' + '__' + sanitizeUrl(url)" mat-menu-item
              (click)="bulkUpload ? restritionPopup() : exportDataFilter()">
              <mat-icon>cloud_download</mat-icon>
              <span>Download</span>
            </a>

            <div *ngIf="selectionLead.length>0">
              <a [attr.guide]="'common-product-lnk-61' + '__' + sanitizeUrl(url)" mat-menu-item
                (click)="bulkUpload ? restritionPopup() : exportDataFilterSelected('selected')">
                <mat-icon class="material-icons-outlined mat-icon-sm">cloud_download</mat-icon>
                <span>Download Selected</span>
              </a>
            </div>

            <div *ngIf="selectionLead.length>0">
              <a [attr.guide]="'common-product-lnk-62' + '__' + sanitizeUrl(url)" mat-menu-item
                (click)="transferLead(0)">
                <mat-icon class="material-icons-outlined mat-icon-sm">transfer_within_a_station</mat-icon>
                <span>Transfer</span>
              </a>
            </div>

            <div *ngIf="selectionLead.length>0">
              <a [attr.guide]="'common-product-lnk-63' + '__' + sanitizeUrl(url)" mat-menu-item
                (click)="transferLead(1)">
                <mat-icon class="material-icons-outlined mat-icon-sm">transfer_within_a_station</mat-icon>
                <span>Random Assign</span>
              </a>
            </div>

            <ng-container *ngIf="resourcePrivilege?.delete">

              <button [attr.guide]="'common-product-btn-64' + '__' + sanitizeUrl(url)"
                [disabled]="!resourcePrivilege?.delete" mat-menu-item (click)="deleteAllProductDialog()">
                <mat-icon class="material-icons-outlined mat-icon-sm">delete_forever</mat-icon>
                <span class="actiontext"> Delete All </span>
              </button>
            </ng-container>

            <ng-container *ngIf="resourcePrivilege?.delete">

              <button [attr.guide]="'common-product-btn-65' + '__' + sanitizeUrl(url)"
                [disabled]="!resourcePrivilege?.delete" *ngIf="selectionLead.length>0" mat-menu-item
                (click)="deleteSelectedDialog()">
                <mat-icon class="material-icons-outlined mat-icon-sm">delete_forever</mat-icon>
                <span class="actiontext"> Delete Selected </span>
              </button>

            </ng-container>


            <!-- <button [attr.guide]="'common-product-btn-66' + '__' + sanitizeUrl(url)" mat-menu-item (click)="housingLeadData()">
              <mat-icon class="material-icons-outlined mat-icon-sm">date_range</mat-icon>
              <span>Common floor Lead</span>
            </button> -->
            <button [attr.guide]="'common-product-btn-67' + '__' + sanitizeUrl(url)" *ngIf="selectionLead.length>0"
              mat-menu-item (click)="sendWhatsappMessage()">
              <mat-icon class="material-icons-outlined mat-icon-sm">date_range</mat-icon>
              <span class="actiontext">Whatsapp Message</span>
            </button>



            <button [attr.guide]="'common-product-btn-68' + '__' + sanitizeUrl(url)" *ngIf="selectionLead.length>0"
              mat-menu-item (click)="sendEmailMessage()">
              <mat-icon class="material-icons-outlined mat-icon-sm">email</mat-icon>
              <span class="actiontext">Send Email</span>
            </button>

            <button [attr.guide]="'common-product-btn-69' + '__' + sanitizeUrl(url)" *ngIf="selectionLead.length>0"
              mat-menu-item (click)="UpdateStatus()">
              <mat-icon class="material-icons-outlined mat-icon-sm">thumbs_up_down</mat-icon>
              <span class="actiontext">Update Status</span>
            </button>
            <button [attr.guide]="'common-product-btn-70' + '__' + sanitizeUrl(url)" [disabled]="!read"
              (click)="LeadOwnerSearch(productList)" mat-menu-item>
              <mat-icon>settings_phone</mat-icon>
              <span class="actiontext">LeadOwnerSearch</span>
            </button>

          </mat-menu>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px" fxHide fxShow.lt-md fxShow.lt-sm
          style="padding: 10px 10px 0 10px;">

          <div class="actions" fxFlexAlign="center">
            <div style="border-radius: 4px; overflow: hidden; " class="colorbtnset">
              <button [attr.guide]="'common-product-btn-209' + '__' + sanitizeUrl(url)" [matMenuTriggerFor]="leadMenu"
                mat-button style="padding-right: 2px;padding-left: 10px;">Create Lead
                <mat-icon>arrow_drop_down</mat-icon>
              </button>
            </div>

            <mat-menu #leadMenu="matMenu">

              <button [attr.guide]="'common-product-btn-210' + '__' + sanitizeUrl(url)" mat-menu-item
                style="border-bottom: 1px solid lightgray;" (click)="addproduct()">Add
                Lead</button>

              <button [attr.guide]="'common-product-btn-211' + '__' + sanitizeUrl(url)" mat-menu-item
                (click)="importExcel()" style="border-bottom: 1px solid lightgray;">Import
                Lead</button>
              <button [attr.guide]="'common-product-btn-212' + '__' + sanitizeUrl(url)" mat-menu-item
                (click)="exportExcel()">Export Lead</button>
            </mat-menu>
          </div>

          <div class="actions" fxFlexAlign="center">
            <button [attr.guide]="'common-product-btn-213' + '__' + sanitizeUrl(url)" mat-button color="primary"
              class="actionbtnset" [matMenuTriggerFor]="actionsMenu">
              Actions
              <mat-icon style="margin-left: 4px;">arrow_drop_down</mat-icon>
            </button>

            <mat-menu [overlapTrigger]="false" xPosition="before" #actionsMenu="matMenu">
              <a [attr.guide]="'common-product-lnk-214' + '__' + sanitizeUrl(url)" mat-menu-item
                (click)="importExcelAdvance()">
                <mat-icon class="material-icons-outlined mat-icon-sm">import_export</mat-icon>
                <span>Import-Excel-Advance</span>
              </a>

              <a [attr.guide]="'common-product-lnk-215' + '__' + sanitizeUrl(url)" mat-menu-item
                (click)="advanceFilter()">
                <mat-icon class="material-icons-outlined mat-icon-sm">add</mat-icon>
                <span>Advance Filter</span>
              </a>

              <a [attr.guide]="'common-product-lnk-216' + '__' + sanitizeUrl(url)" mat-menu-item
                (click)="bulkUpload ? restritionPopup() : exportDataFilter()">
                <mat-icon>cloud_download</mat-icon>
                <span>Download</span>
              </a>

              <div *ngIf="selectionLead.length>0">
                <a [attr.guide]="'common-product-lnk-217' + '__' + sanitizeUrl(url)" mat-menu-item
                  (click)="bulkUpload ? restritionPopup() : exportDataFilterSelected('selected')">
                  <mat-icon class="material-icons-outlined mat-icon-sm">cloud_download</mat-icon>
                  <span>Download Selected</span>
                </a>
              </div>

              <div *ngIf="selectionLead.length>0">
                <a [attr.guide]="'common-product-lnk-218' + '__' + sanitizeUrl(url)" mat-menu-item
                  (click)="transferLead(0)">
                  <mat-icon class="material-icons-outlined mat-icon-sm">transfer_within_a_station</mat-icon>
                  <span>Transfer</span>
                </a>
              </div>

              <div *ngIf="selectionLead.length>0">
                <a [attr.guide]="'common-product-lnk-219' + '__' + sanitizeUrl(url)" mat-menu-item
                  (click)="transferLead(1)">
                  <mat-icon class="material-icons-outlined mat-icon-sm">transfer_within_a_station</mat-icon>
                  <span>Random Assign</span>
                </a>
              </div>

              <button [attr.guide]="'common-product-btn-220' + '__' + sanitizeUrl(url)"
                [disabled]="!resourcePrivilege?.delete" mat-menu-item (click)="deleteAllProductDialog()">
                <mat-icon class="material-icons-outlined mat-icon-sm">delete_forever</mat-icon>
                <span> Delete All </span>
              </button>

              <button [attr.guide]="'common-product-btn-221' + '__' + sanitizeUrl(url)"
                [disabled]="!resourcePrivilege?.delete" *ngIf="selectionLead.length>0" mat-menu-item
                (click)="deleteSelectedDialog()">
                <mat-icon class="material-icons-outlined mat-icon-sm">delete_forever</mat-icon>
                <span> Delete Selected </span>
              </button>

              <!-- <button [attr.guide]="'common-product-btn-222' + '__' + sanitizeUrl(url)" mat-menu-item (click)="housingLeadData()">
                  <mat-icon class="material-icons-outlined mat-icon-sm">date_range</mat-icon>
                  <span>Common floor Lead</span>
                </button> -->
              <button [attr.guide]="'common-product-btn-223' + '__' + sanitizeUrl(url)" *ngIf="selectionLead.length>0"
                mat-menu-item (click)="sendWhatsappMessage()">
                <mat-icon class="material-icons-outlined mat-icon-sm">date_range</mat-icon>
                <span>Whatsapp Message</span>
              </button>

              <button [attr.guide]="'common-product-btn-224' + '__' + sanitizeUrl(url)" *ngIf="selectionLead.length>0"
                mat-menu-item (click)="sendEmailMessage()">
                <mat-icon class="material-icons-outlined mat-icon-sm">email</mat-icon>
                <span>Send Email</span>
              </button>

              <button [attr.guide]="'common-product-btn-225' + '__' + sanitizeUrl(url)" *ngIf="selectionLead.length>0"
                mat-menu-item (click)="UpdateStatus()">
                <mat-icon class="material-icons-outlined mat-icon-sm">thumbs_up_down</mat-icon>
                <span>Update Status</span>
              </button>
              <button [attr.guide]="'common-product-btn-226' + '__' + sanitizeUrl(url)" [disabled]="!read"
                (click)="LeadOwnerSearch(productList)" mat-menu-item>
                <mat-icon>settings_phone</mat-icon>
                <span>LeadOwnerSearch</span>
              </button>
            </mat-menu>
          </div>

        </div>

        <div *ngIf="viewType != 'kanban'">
          <div *ngIf="leadTypeInMobile == 0  && !display && GridType != 8" style="overflow-x:auto;">

            <table (matSortChange)="sortData($event)" [dataSource]="productList" class="w-full" mat-table matSort>




              <ng-container matColumnDef="flag">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Flag</mat-header-cell>
                <mat-cell *matCellDef="let row ; let i=index;" class="cellmat">
                  <button [attr.guide]="'common-product-btn-74' + '__' + sanitizeUrl(url)" type="button" mat-icon-button
                    (click)="flag(row,i)">
                    <mat-icon>{{ row.flag==1 ? 'flag' : 'outlined_flag' }}</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>


              <ng-container matColumnDef="lastActivityNotes">

                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">
                  Last Activity Notes</mat-header-cell>
                <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                  {{(row.lastActivityNotes) | slice:0:20}}
                </mat-cell>
              </ng-container>




              <ng-container matColumnDef="phoneNumber">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Phone Number</mat-header-cell>
                <mat-cell (click)="details(row.entityId,row.attributeSetId)" *matCellDef="let row" class="cellmat">
                  <div>
                    <div *ngIf="row.phoneNumber != null">
                      <span size="23px" style="cursor: pointer;">
                        {{ row.phoneNumber }}
                      </span>

                    </div>

                    <div *ngIf="row.secondaryphoneno != null" style="margin-top: 10px;">
                      <span size="23px" style="cursor: pointer;">
                        {{ row.secondaryphoneno}}
                      </span>

                    </div>
                  </div>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="priority">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Priority</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{ getPriorityLetter(row.priority) }}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="icons" class="icon-list">

                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"></mat-header-cell>
                <mat-cell class="cellmat" *matCellDef="let row">
                  <div>
                    <div *ngIf="row.phoneNumber != null" style="display: flex; align-items: center;">
                      <mat-icon (click)="phoneNumbercall(row); $event.stopPropagation()" [icIcon]="icPhone" size="18px"
                        style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                      </mat-icon>
                      <img (click)="phonewhatsapp(row); $event.stopPropagation()" src="assets/icons/whatsapp.svg"
                        alt="Whatsapp"
                        style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                    </div>

                    <div *ngIf="row.secondaryphoneno?.length > 0"
                      style="margin-top: 5px; display: flex; align-items: center;">
                      <mat-icon (click)="secondaryphoneNumbercall(row); $event.stopPropagation()" [icIcon]="icPhone"
                        size="18px"
                        style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                      </mat-icon>
                      <img (click)="secondaryphonewhatsapp(row.customField10); $event.stopPropagation()"
                        src="assets/icons/whatsapp.svg" alt="Whatsapp"
                        style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                    </div>
                  </div>
                </mat-cell>
              </ng-container>


              <ng-container matColumnDef="walkIn">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Walk In</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <button [attr.guide]="'common-product-btn-75' + '__' + sanitizeUrl(url)" class="fav-button"
                    type="button" mat-icon-button (click)="walkIn(row)" [ngClass]="{ 'favorite': row.walkIn==1 }">
                    <mat-icon>{{ row.walkIn==1 ? 'directions_walk' : 'directions_walk' }}</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>

              <!-- <ng-container matColumnDef="emailValid">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Email Valid</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                 
                  {{ row.emailValid==1 ? 'true' : 'false' }}
                </mat-cell>
              </ng-container> -->

              <ng-container matColumnDef="favourite">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Favourite</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <button [attr.guide]="'common-product-btn-76' + '__' + sanitizeUrl(url)" class="fav-button"
                    type="button" mat-icon-button (click)="toggleFavorite(row)"
                    [ngClass]="{ 'favorite': row.favourite==1 }">
                    <mat-icon>{{ row.favourite==1 ? 'favorite' : 'favorite_border' }}</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>





              <ng-container matColumnDef="select" style="border-bottom: none;border-bottom-width: 0px;">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox [attr.guide]="'common-product-chk-77' + '__' + sanitizeUrl(url)"
                    (change)="toggleAllRows($event.checked)" [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                  </mat-checkbox>

                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox [attr.guide]="'common-product-chk-78' + '__' + sanitizeUrl(url)"
                    (click)="$event.stopPropagation()"
                    (change)="changeValue($event.checked, row); $event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)" [checked]="selection.isSelected(row)"
                    [aria-label]="checkboxLabel(row)">
                  </mat-checkbox>
                </td>
              </ng-container>

              <!-- fullName Column -->
              <ng-container *ngFor="let column of columns">
                <ng-container *ngIf="column.isModelProperty!='false'">

                  <ng-container *ngIf="column.isModelProperty && column.property!='actions'"
                    [matColumnDef]="column.property">


                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name }}
                    </mat-header-cell>
                    <mat-cell [ngClass]="column.cssClasses" class="cellmat" *matCellDef="let row">

                      <span *ngIf="column.property.includes('customValuesIs')">
                        {{row.isCustomizedValue[column.propertyName] }}

                      </span>
                      <span
                        *ngIf="!column.property.includes('customValuesIs')&&column.name!='Follow Up Data Time';else other_content">
                        {{row[column.property] }}

                      </span>
                      <ng-template #other_content>

                        {{row[column.property] | date:'medium'}}
                      </ng-template>


                    </mat-cell>
                  </ng-container>
                </ng-container>

              </ng-container>
              <ng-container matColumnDef="name">

                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Name</mat-header-cell>
                <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                  {{(row.name) | slice:0:20}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="statusName">

                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Status</mat-header-cell>
                <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                  {{(row.statusName) | slice:0:20}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="sourceName">

                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Source Name</mat-header-cell>
                <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                  {{(row.sourceName) | slice:0:20}}
                </mat-cell>
              </ng-container>





              <!-- <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef class="headcell">
              <span>

              </span>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="cellmat">
              <mat-checkbox [attr.guide]="'common-product-chk-79' + '__' + sanitizeUrl(url)" (click)="$event.stopPropagation()" (change)="changeValue($event.checked,row)"
                [checked]="selectionLead.indexOf(row.entityId) >= 0" [aria-label]="checkboxLabel(row.entityId)">
              </mat-checkbox>

            </mat-cell>
          </ng-container> -->



              <ng-container matColumnDef="createdDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Created Date</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{(row.createdDate) | date:'medium' }}
                </mat-cell>
              </ng-container>


              <ng-container matColumnDef="activityCountOnLead">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Activity Count</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <p style="text-align: center;">{{(row.activityCountOnLead) }}</p>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="CrNo_cust">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Cr No</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <p fxFlex="100" fxLayoutAlign="center center">
                    {{(row.isCustomizedValue.CrNo)}}
                  </p>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="CrName_cust">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Cr Name</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <p fxFlex="100" fxLayoutAlign="center center">
                    {{(row.isCustomizedValue.CrName)}}
                  </p>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="choiceofprogram">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Choice Of Program</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <p fxFlex="100" fxLayoutAlign="center center">
                    {{ row.isCustomizedValue['Choice Of Program'] || row.customField10?.ChoiceOfProgram }}
                  </p>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="preferablelanguage">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Preferable
                  Language</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <p fxFlex="100" fxLayoutAlign="center center">
                    {{ row.isCustomizedValue?.['Preferable Language'] || row.customField10?.PreferableLanguage }}
                  </p>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="collegeName">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">College</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{ row.collegeName }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="jobtitle">

                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Job title</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{ row.jobtitle ?? '' }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="department">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Department</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{ row.customField10?.Department ?? '' }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="district">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">District</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{ row.customField10?.District ?? '' }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="parentsnumber">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">ParentsNumber</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{ row.customField10?.ParentsNumber ?? '' }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="yearofstudy">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">YearOfStudy</mat-header-cell>
                <mat-cell class="cellmat" *matCellDef="let row">
                  {{ row.customField10?.YearOfStudy ?? '' }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="section">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Section</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{ row.customField1?.Section ?? '' }}
                </mat-cell>
              </ng-container>



              <ng-container matColumnDef="quoted">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Quoted Value</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">

                  <span *ngIf="row.customField10 && row.customField10.QuotedValue != null">
                    <p fxFlex="100" fxLayoutAlign="center center">
                      {{ row.customField10.QuotedValue }}
                    </p>
                  </span>

                </mat-cell>
              </ng-container>



              <ng-container matColumnDef="updatedDate">
                <mat-header-cell class="headcell" *matHeaderCellDef mat-sort-header>Updated Date</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{(row.updatedDate) | date:'medium' }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="adGroupName">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Campaign Name</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{ row.jsonRecieved?.adGroupName!=null?row.jsonRecieved?.adGroupName:row.campaignName}}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="note">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Note</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <button [attr.guide]="'common-product-btn-80' + '__' + sanitizeUrl(url)"
                    style="border: 1px solid #dee2e6; padding: 2px; border-radius: 15px; display: flex; align-items: center;"
                    (click)="Note(row)">
                    <mat-icon>add_circle</mat-icon>
                    <span>New Notes</span>
                  </button>

                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="followUpDateTimePopup">
                <mat-header-cell *matHeaderCellDef class="headcell">Upcoming Follow Up</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <button [attr.guide]="'common-product-btn-81' + '__' + sanitizeUrl(url)"
                    style="border: 1px solid #dee2e6; padding: 2px; border-radius: 15px; display: flex; align-items: center; gap: 5px;"
                    (click)="openFollowUp(row)">
                    <mat-icon>add_circle</mat-icon>
                    <span>Follow Up</span>
                  </button>

                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="deal">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Deal</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <span class="deals">{{row.deal || 'Open'}}</span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="score">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Score</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{ row.score || 0.0}}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Status</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <span [ngClass]="{'statustType': row.status}">{{row.status}}</span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="totalCallDuration">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Total Call
                  Duration</mat-header-cell>
                <mat-cell style="text-align: center;" *matCellDef="let row" class="cellmat">
                  {{ formatSecondsToTime(row.totalCallDuration) }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Country">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Country</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{(row.isCustomizedValue.Country)}}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="City">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">City</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{(row.isCustomizedValue.City)}}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="State">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">State</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{ row.State || row.state || row.isCustomizedValue?.State || row.isCustomizedValue?.state }}
                </mat-cell>
              </ng-container>



              <!-- actions Column -->
              <ng-container matColumnDef="actions">

                <mat-header-cell class="actions-cell" *matHeaderCellDef class="headcell">Action</mat-header-cell>
                <mat-cell class="actions-cell" *matCellDef="let row;let i=index" class="cellmat">
                  <button [attr.guide]="'common-product-btn-82' + '__' + sanitizeUrl(url)" type="button" mat-icon-button
                    [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
                    <mat-icon>more_horiz</mat-icon>
                  </button>
                  <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                    <button [attr.guide]="'common-product-btn-83' + '__' + sanitizeUrl(url)"
                      [disabled]="!resourcePrivilege?.update" (click)="editProduct(row.entityId,row.attributeSetId)"
                      mat-menu-item>
                      <mat-icon>edit</mat-icon>
                      <span>edit</span>
                    </button>

                    <button [attr.guide]="'common-product-btn-84' + '__' + sanitizeUrl(url)"
                      [disabled]="!resourcePrivilege?.delete" (click)="deleteAllProductId(row.entityId)" mat-menu-item>
                      <mat-icon>delete</mat-icon>
                      <span>delete</span>
                    </button>

                    <button [attr.guide]="'common-product-btn-85' + '__' + sanitizeUrl(url)" *ngIf="leadToCustomer == 1"
                      (click)="getApprove(row)" mat-menu-item>
                      <mat-icon>refresh</mat-icon>
                      <span>Convert to Customer</span>
                    </button>

                    <button [attr.guide]="'common-product-btn-86' + '__' + sanitizeUrl(url)" *ngIf="enableSequence"
                      (click)="SequenceStatusPopup('single',row)" mat-menu-item>
                      <mat-icon>start</mat-icon>
                      <span>Add Lead Sequences</span>
                    </button>

                    <ng-container *ngIf="crmType==0 || crmType==4">
                      <button [attr.guide]="'common-product-btn-87' + '__' + sanitizeUrl(url)"
                        (click)="openLeadStage(row,i)" mat-menu-item>
                        <mat-icon>group_add</mat-icon>
                        <span>Lead Stage</span>
                      </button>
                      <button [attr.guide]="'common-product-btn-88' + '__' + sanitizeUrl(url)"
                        (click)="openLeadPriority(row)" mat-menu-item>
                        <mat-icon>priority_high</mat-icon>
                        <span>Add Lead Priority</span>
                      </button>

                    </ng-container>



                  </mat-menu>
                </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="visibleColumns;sticky:true"></mat-header-row>
              <mat-row *matRowDef="let row; columns: visibleColumns;" class="clickable">
              </mat-row>
            </table>

          </div>

          <div *ngIf="display && GridType ==1 " class="table-responsive custom-table"
            style="width: 100%;overflow-x: auto;">

            <table (matSortChange)="sortData($event)" [dataSource]="productList" class="w-full" mat-table matSort>

              <ng-container matColumnDef="select" style="border-bottom: none;border-bottom-width: 0px;">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox [attr.guide]="'common-product-chk-89' + '__' + sanitizeUrl(url)"
                    (change)="toggleAllRows($event.checked)" [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox [attr.guide]="'common-product-chk-90' + '__' + sanitizeUrl(url)"
                    (click)="$event.stopPropagation()"
                    (change)="changeValue($event.checked, row); selection.toggle(row)"
                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                  </mat-checkbox>
                </td>
              </ng-container>

              <ng-container *ngFor="let column of columns">
                <ng-container *ngIf="column.isModelProperty!='false'">

                  <ng-container *ngIf="column.isModelProperty && column.property!='actions'"
                    [matColumnDef]="column.property">


                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name }}
                    </mat-header-cell>
                    <mat-cell [ngClass]="column.cssClasses" class="cellmat" *matCellDef="let row">

                      <span *ngIf="column.property.includes('customValuesIs')">
                        {{row.isCustomizedValue[column.propertyName] }}

                      </span>
                      <span *ngIf="!column.property.includes('customValuesIs')
                        &&column.name!='Follow Up Data Time';else other_content">
                        {{row[column.property] }}

                      </span>
                      <ng-template #other_content>

                        {{row[column.property] | date:'medium'}}
                      </ng-template>


                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='actions'">
                  <ng-container matColumnDef="actions">

                    <mat-header-cell class="actions-cell" *matHeaderCellDef class="headcell">Action</mat-header-cell>
                    <mat-cell class="actions-cell" *matCellDef="let row;let i=index" class="cellmat">
                      <button [attr.guide]="'common-product-btn-91' + '__' + sanitizeUrl(url)" type="button"
                        mat-icon-button [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
                        <mat-icon>more_horiz</mat-icon>
                      </button>
                      <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                        <button [attr.guide]="'common-product-btn-92' + '__' + sanitizeUrl(url)"
                          [disabled]="!resourcePrivilege?.update" (click)="editProduct(row.entityId,row.attributeSetId)"
                          mat-menu-item>
                          <mat-icon>edit</mat-icon>
                          <span>edit</span>
                        </button>



                        <button [attr.guide]="'common-product-btn-93' + '__' + sanitizeUrl(url)"
                          *ngIf="leadToCustomer == 1" (click)="getApprove(row)" mat-menu-item>
                          <mat-icon>refresh</mat-icon>
                          <span>Convert to Customer</span>
                        </button>

                        <button [attr.guide]="'common-product-btn-94' + '__' + sanitizeUrl(url)"
                          [disabled]="!resourcePrivilege?.delete" (click)="deleteAllProductId(row.entityId)"
                          mat-menu-item>
                          <mat-icon>delete</mat-icon>
                          <span>delete</span>
                        </button>

                        <ng-container *ngIf="crmType==0 || crmType==4">
                          <button [attr.guide]="'common-product-btn-95' + '__' + sanitizeUrl(url)"
                            (click)="openLeadStage(row,i)" mat-menu-item>
                            <mat-icon>group_add</mat-icon>
                            <span>Lead Stage</span>
                          </button>
                          <button [attr.guide]="'common-product-btn-96' + '__' + sanitizeUrl(url)"
                            (click)="openLeadPriority(row)" mat-menu-item>
                            <mat-icon>priority_high</mat-icon>
                            <span>Add Lead Priority</span>
                          </button>

                        </ng-container>

                        <button [attr.guide]="'common-product-btn-97' + '__' + sanitizeUrl(url)"
                          *ngIf="column.showLeadStage==1" (click)="openLeadStage(row,i)" mat-menu-item>
                          <mat-icon>group_add</mat-icon>
                          <span>Lead Stage</span>
                        </button>
                        <button [attr.guide]="'common-product-btn-98' + '__' + sanitizeUrl(url)"
                          *ngIf="column.showLeadPriority==1" (click)="openLeadPriority(row)" mat-menu-item>
                          <mat-icon>priority_high</mat-icon>
                          <span>Add Lead Priority</span>
                        </button>

                        <button [attr.guide]="'common-product-btn-99' + '__' + sanitizeUrl(url)" *ngIf="enableSequence"
                          (click)="SequenceStatusPopup('single',row)" mat-menu-item>
                          <mat-icon>start</mat-icon>
                          <span>Add Lead Sequences</span>
                        </button>

                      </mat-menu>
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='name'">
                  <ng-container matColumnDef="name">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.name) | slice:0:20}}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='lastActivityNotes'">
                  <ng-container matColumnDef="lastActivityNotes">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.lastActivityNotes) | slice:0:20}}
                    </mat-cell>
                  </ng-container>

                </ng-container>


                <ng-container *ngIf="column.property=='statusName'">
                  <ng-container matColumnDef="statusName">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.statusName) | slice:0:20}}
                    </mat-cell>
                  </ng-container>

                </ng-container>


                <!-- <ng-container *ngIf="column.property=='company'">
                  <ng-container matColumnDef="company">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="companyNavigation(row.companyId)" class="cellmat" *matCellDef="let row">
                      {{(row.company) }}
                    </mat-cell>
                  </ng-container>

                </ng-container> -->

                <ng-container *ngIf="column.property=='totalCallDuration'">

                  <ng-container matColumnDef="totalCallDuration">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell style="text-align: center;" *matCellDef="let row" class="cellmat">
                      {{ formatSecondsToTime(row.totalCallDuration) }}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='note'">


                  <ng-container matColumnDef="note">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-100' + '__' + sanitizeUrl(url)"
                        style="border: 1px solid #dee2e6; padding: 2px; border-radius: 15px; display: flex; align-items: center;"
                        (click)="Note(row)">
                        <mat-icon>add_circle</mat-icon>
                        <span>New Notes</span>
                      </button>

                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='followUpDateTimePopup'">
                  <ng-container matColumnDef="followUpDateTimePopup">
                    <mat-header-cell *matHeaderCellDef class="headcell">{{ column.name }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-101' + '__' + sanitizeUrl(url)"
                        style="border: 1px solid #dee2e6; padding: 2px; border-radius: 15px; display: flex; align-items: center; gap: 5px;"
                        (click)="openFollowUp(row)">
                        <mat-icon>add_circle</mat-icon>
                        <span>Follow Up</span>
                      </button>

                    </mat-cell>
                  </ng-container>

                </ng-container>


                <ng-container *ngIf="column.property=='deal'">
                  <ng-container matColumnDef="deal">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <span class="deals">{{row.deal || 'Open'}}</span>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='score'">
                  <ng-container matColumnDef="score">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.score || 0.0}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='status'">
                  <ng-container matColumnDef="status">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <span [ngClass]="{'statustType': row.status}">{{row.status}}</span>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='sourceName'">
                  <ng-container matColumnDef="sourceName">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.sourceName) | slice:0:20}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='createdDate'">

                  <ng-container matColumnDef="createdDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.createdDate) | date:'medium' }}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='activityCountOnLead'">
                  <ng-container matColumnDef="activityCountOnLead">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p style="text-align: center;">{{(row.activityCountOnLead) }}</p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='CrNo_cust'">
                  <ng-container matColumnDef="CrNo_cust">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{(row.isCustomizedValue.CrNo)}}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='CrName_cust'">
                  <ng-container matColumnDef="CrName_cust">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{(row.isCustomizedValue.CrName)}}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='choiceofprogram'">
                  <ng-container matColumnDef="choiceofprogram">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{ row.isCustomizedValue['Choice Of Program'] || row.customField10?.ChoiceOfProgram }}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='preferablelanguage'">
                  <ng-container matColumnDef="preferablelanguage">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{ row.isCustomizedValue?.['Preferable Language'] || row.customField10?.PreferableLanguage }}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='collegeName'">
                  <ng-container matColumnDef="collegeName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.collegeName }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='jobtitle'">

                  <ng-container matColumnDef="jobtitle">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Job title</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.jobtitle ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='department'">
                  <ng-container matColumnDef="department">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField10?.Department ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='district'">
                  <ng-container matColumnDef="district">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField10?.District ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='parentsnumber'">

                  <ng-container matColumnDef="parentsnumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField10?.ParentsNumber ?? '' }}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='yearofstudy'">
                  <ng-container matColumnDef="yearofstudy">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell class="cellmat" *matCellDef="let row">
                      {{ row.customField10?.YearOfStudy ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='section'">
                  <ng-container matColumnDef="section">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField1?.Section ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='quoted'">
                  <ng-container matColumnDef="quoted">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">

                      <span *ngIf="row.customField10 && row.customField10.QuotedValue != null">
                        <p fxFlex="100" fxLayoutAlign="center center">
                          {{ row.customField10.QuotedValue }}
                        </p>
                      </span>

                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='updatedDate'">
                  <ng-container matColumnDef="updatedDate">
                    <mat-header-cell class="headcell" *matHeaderCellDef mat-sort-header>{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.updatedDate) | date:'medium' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='adGroupName'">

                  <ng-container matColumnDef="adGroupName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.jsonRecieved?.adGroupName!=null?row.jsonRecieved?.adGroupName:row.campaignName}}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='Country'">
                  <ng-container matColumnDef="Country">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.isCustomizedValue.Country)}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='City'">
                  <ng-container matColumnDef="City">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.isCustomizedValue.City)}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='State'">
                  <ng-container matColumnDef="State">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.isCustomizedValue.State)}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='flag'">
                  <ng-container matColumnDef="flag">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row ; let i=index;" class="cellmat">
                      <button [attr.guide]="'common-product-btn-102' + '__' + sanitizeUrl(url)" type="button"
                        mat-icon-button (click)="flag(row,i)">
                        <mat-icon>{{ row.flag==1 ? 'flag' : 'outlined_flag' }}</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='priority'">
                  <ng-container matColumnDef="priority">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" *matCellDef="let row" class="cellmat">
                      {{ getPriorityLetter(row.priority) }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='phoneNumber'">
                  <ng-container matColumnDef="phoneNumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" *matCellDef="let row" class="cellmat">
                      <div>
                        <div *ngIf="row.phoneNumber != null">


                          <span *ngIf="encryptPhone==0" size="23px" style="cursor: pointer;">
                            {{ row.phoneNumber }}
                          </span>

                          <span *ngIf="encryptPhone==1" size="23px" style="cursor: pointer;">
                            {{ row.phoneNumber| slice:0:4 }} ****
                          </span>

                        </div>

                        <div *ngIf="row.secondaryphoneno != null" style="margin-top: 10px;">
                          <span *ngIf="encryptPhone==0" size="23px" style="cursor: pointer;">
                            {{ row.secondaryphoneno}}
                          </span>
                          <span *ngIf="encryptPhone==1" size="23px" style="cursor: pointer;">
                            {{ row.secondaryphoneno| slice:0:4 }} ****
                          </span>

                        </div>
                      </div>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='icons'">
                  <ng-container matColumnDef="icons" class="icon-list">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"></mat-header-cell>
                    <mat-cell class="cellmat" *matCellDef="let row">
                      <div>
                        <div *ngIf="row.phoneNumber != null" style="display: flex; align-items: center;">
                          <mat-icon (click)="phoneNumbercall(row); $event.stopPropagation()" [icIcon]="icPhone"
                            size="18px"
                            style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                          </mat-icon>
                          <img (click)="phonewhatsapp(row); $event.stopPropagation()" src="assets/icons/whatsapp.svg"
                            alt="Whatsapp"
                            style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                        </div>

                        <div *ngIf="row.secondaryphoneno?.length > 0"
                          style="margin-top: 5px; display: flex; align-items: center;">
                          <mat-icon (click)="secondaryphoneNumbercall(row); $event.stopPropagation()" [icIcon]="icPhone"
                            size="18px"
                            style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                          </mat-icon>
                          <img (click)="secondaryphonewhatsapp(row.customField10); $event.stopPropagation()"
                            src="assets/icons/whatsapp.svg" alt="Whatsapp"
                            style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                        </div>
                      </div>
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='walkIn'">
                  <ng-container matColumnDef="walkIn">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-103' + '__' + sanitizeUrl(url)" class="fav-button"
                        type="button" mat-icon-button (click)="walkIn(row)" [ngClass]="{ 'favorite': row.walkIn==1 }">
                        <mat-icon>{{ row.walkIn==1 ? 'directions_walk' : 'directions_walk' }}</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <!-- <ng-container matColumnDef="emailValid">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Email Valid</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                 
                  {{ row.emailValid==1 ? 'true' : 'false' }}
                </mat-cell>
              </ng-container> -->

                <ng-container *ngIf="column.property=='favourite'">
                  <ng-container matColumnDef="favourite">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-104' + '__' + sanitizeUrl(url)" class="fav-button"
                        type="button" mat-icon-button (click)="toggleFavorite(row)"
                        [ngClass]="{ 'favorite': row.favourite==1 }">
                        <mat-icon>{{ row.favourite==1 ? 'favorite' : 'favorite_border' }}</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                </ng-container>


              </ng-container>

              <!-- <calsoft-common-grid [icPhone]="icPhone" [storeName]="storeName" [columns]="columns" [icWhatsapp]="icWhatsapp" 
          [defaultSet]="defaultSet"
          [leadDetailType]="leadDetailType" [dialerType]="dialerType" [resourcePrivilege]="resourcePrivilege" [GridType]="GridType"
           [whatAppUrl]="whatAppUrl" [whatsAppCustomUrl]="whatsAppCustomUrl" [crmType]="crmType"></calsoft-common-grid> -->

              <mat-header-row *matHeaderRowDef="visibleColumns;sticky:true"></mat-header-row>
              <mat-row *matRowDef="let row; columns: visibleColumns;" class="clickable">
              </mat-row>
            </table>
          </div>

          <div *ngIf="display && GridType ==2 " style="overflow-x:auto;">

            <table (matSortChange)="sortData($event)" [dataSource]="productList" class="w-full" mat-table matSort>





              <ng-container matColumnDef="select" style="border-bottom: none;border-bottom-width: 0px;">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox [attr.guide]="'common-product-chk-105' + '__' + sanitizeUrl(url)"
                    (change)="toggleAllRows($event.checked)" [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                  </mat-checkbox>

                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox [attr.guide]="'common-product-chk-106' + '__' + sanitizeUrl(url)"
                    (click)="$event.stopPropagation()"
                    (change)="changeValue($event.checked, row); $event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)" [checked]="selection.isSelected(row)"
                    [aria-label]="checkboxLabel(row)">
                  </mat-checkbox>
                </td>
              </ng-container>
              <ng-container *ngFor="let column of columns">
                <ng-container *ngIf="column.isModelProperty!='false'">

                  <ng-container *ngIf="column.isModelProperty && column.property!='actions'"
                    [matColumnDef]="column.property">


                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name }}
                    </mat-header-cell>
                    <mat-cell [ngClass]="column.cssClasses" class="cellmat" *matCellDef="let row">

                      <span *ngIf="column.property.includes('customValuesIs')">
                        {{row.isCustomizedValue[column.propertyName] }}

                      </span>
                      <span
                        *ngIf="!column.property.includes('customValuesIs')&&column.name!='Follow Up Data Time';else other_content">
                        {{row[column.property] }}

                      </span>
                      <ng-template #other_content>

                        {{row[column.property] | date:'medium'}}
                      </ng-template>


                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='actions'">
                  <ng-container matColumnDef="actions">

                    <mat-header-cell class="actions-cell" *matHeaderCellDef class="headcell">Action</mat-header-cell>
                    <mat-cell class="actions-cell" *matCellDef="let row;let i=index" class="cellmat">
                      <button [attr.guide]="'common-product-btn-107' + '__' + sanitizeUrl(url)" type="button"
                        mat-icon-button [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
                        <mat-icon>more_horiz</mat-icon>
                      </button>
                      <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                        <button [attr.guide]="'common-product-btn-108' + '__' + sanitizeUrl(url)"
                          [disabled]="!resourcePrivilege?.update" (click)="editProduct(row.entityId,row.attributeSetId)"
                          mat-menu-item>
                          <mat-icon>edit</mat-icon>
                          <span>edit</span>
                        </button>



                        <button [attr.guide]="'common-product-btn-109' + '__' + sanitizeUrl(url)"
                          *ngIf="leadToCustomer == 1" (click)="getApprove(row)" mat-menu-item>
                          <mat-icon>refresh</mat-icon>
                          <span>Convert to Customer</span>
                        </button>

                        <button [attr.guide]="'common-product-btn-110' + '__' + sanitizeUrl(url)"
                          [disabled]="!resourcePrivilege?.delete" (click)="deleteAllProductId(row.entityId)"
                          mat-menu-item>
                          <mat-icon>delete</mat-icon>
                          <span>delete</span>
                        </button>

                        <ng-container *ngIf="crmType==0 || crmType==4">
                          <button [attr.guide]="'common-product-btn-111' + '__' + sanitizeUrl(url)"
                            (click)="openLeadStage(row,i)" mat-menu-item>
                            <mat-icon>group_add</mat-icon>
                            <span>Lead Stage</span>
                          </button>
                          <button [attr.guide]="'common-product-btn-112' + '__' + sanitizeUrl(url)"
                            (click)="openLeadPriority(row)" mat-menu-item>
                            <mat-icon>priority_high</mat-icon>
                            <span>Add Lead Priority</span>
                          </button>

                        </ng-container>

                        <button [attr.guide]="'common-product-btn-113' + '__' + sanitizeUrl(url)"
                          *ngIf="column.showLeadStage==1" (click)="openLeadStage(row,i)" mat-menu-item>
                          <mat-icon>group_add</mat-icon>
                          <span>Lead Stage</span>
                        </button>
                        <button [attr.guide]="'common-product-btn-114' + '__' + sanitizeUrl(url)"
                          *ngIf="column.showLeadPriority==1" (click)="openLeadPriority(row)" mat-menu-item>
                          <mat-icon>priority_high</mat-icon>
                          <span>Add Lead Priority</span>
                        </button>

                        <button [attr.guide]="'common-product-btn-115' + '__' + sanitizeUrl(url)" *ngIf="enableSequence"
                          (click)="SequenceStatusPopup('single',row)" mat-menu-item>
                          <mat-icon>start</mat-icon>
                          <span>Add Lead Sequences</span>
                        </button>

                      </mat-menu>
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='name'">
                  <ng-container matColumnDef="name">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.name) | slice:0:20}}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='lastActivityNotes'">
                  <ng-container matColumnDef="lastActivityNotes">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.lastActivityNotes) | slice:0:20}}
                    </mat-cell>
                  </ng-container>

                </ng-container>


                <ng-container *ngIf="column.property=='statusName'">
                  <ng-container matColumnDef="statusName">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.statusName) | slice:0:20}}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <!-- <ng-container *ngIf="column.property=='company'">
                  <ng-container matColumnDef="company">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="companyNavigation(row.companyId)" class="cellmat" *matCellDef="let row">
                      {{(row.company) }}
                    </mat-cell>
                  </ng-container>

                </ng-container> -->

                <ng-container *ngIf="column.property=='totalCallDuration'">

                  <ng-container matColumnDef="totalCallDuration">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell style="text-align: center;" *matCellDef="let row" class="cellmat">
                      {{ formatSecondsToTime(row.totalCallDuration) }}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='note'">


                  <ng-container matColumnDef="note">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-116' + '__' + sanitizeUrl(url)"
                        style="border: 1px solid #dee2e6; padding: 2px; border-radius: 15px; display: flex; align-items: center;"
                        (click)="Note(row)">
                        <mat-icon>add_circle</mat-icon>
                        <span>New Notes</span>
                      </button>

                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='followUpDateTimePopup'">
                  <ng-container matColumnDef="followUpDateTimePopup">
                    <mat-header-cell *matHeaderCellDef class="headcell">{{ column.name }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-117' + '__' + sanitizeUrl(url)"
                        style="border: 1px solid #dee2e6; padding: 2px; border-radius: 15px; display: flex; align-items: center; gap: 5px;"
                        (click)="openFollowUp(row)">
                        <mat-icon>add_circle</mat-icon>
                        <span>Follow Up</span>
                      </button>

                    </mat-cell>
                  </ng-container>

                </ng-container>


                <ng-container *ngIf="column.property=='deal'">
                  <ng-container matColumnDef="deal">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <span class="deals">{{row.deal || 'Open'}}</span>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='score'">
                  <ng-container matColumnDef="score">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.score || 0.0}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='status'">
                  <ng-container matColumnDef="status">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <span [ngClass]="{'statustType': row.status}">{{row.status}}</span>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='sourceName'">
                  <ng-container matColumnDef="sourceName">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.sourceName) | slice:0:20}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='createdDate'">

                  <ng-container matColumnDef="createdDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.createdDate) | date:'medium' }}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='activityCountOnLead'">
                  <ng-container matColumnDef="activityCountOnLead">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p style="text-align: center;">{{(row.activityCountOnLead) }}</p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='CrNo_cust'">
                  <ng-container matColumnDef="CrNo_cust">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{(row.isCustomizedValue.CrNo)}}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='CrName_cust'">
                  <ng-container matColumnDef="CrName_cust">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{(row.isCustomizedValue.CrName)}}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='choiceofprogram'">
                  <ng-container matColumnDef="choiceofprogram">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{ row.isCustomizedValue['Choice Of Program'] || row.customField10?.ChoiceOfProgram }}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='preferablelanguage'">
                  <ng-container matColumnDef="preferablelanguage">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{ row.isCustomizedValue?.['Preferable Language'] || row.customField10?.PreferableLanguage }}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='collegeName'">
                  <ng-container matColumnDef="collegeName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.collegeName }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='jobtitle'">

                  <ng-container matColumnDef="jobtitle">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Job title</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.jobtitle ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='department'">
                  <ng-container matColumnDef="department">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField10?.Department ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='district'">
                  <ng-container matColumnDef="district">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField10?.District ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='parentsnumber'">

                  <ng-container matColumnDef="parentsnumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField10?.ParentsNumber ?? '' }}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='yearofstudy'">
                  <ng-container matColumnDef="yearofstudy">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell class="cellmat" *matCellDef="let row">
                      {{ row.customField10?.YearOfStudy ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='section'">
                  <ng-container matColumnDef="section">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField1?.Section ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='quoted'">
                  <ng-container matColumnDef="quoted">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">

                      <span *ngIf="row.customField10 && row.customField10.QuotedValue != null">
                        <p fxFlex="100" fxLayoutAlign="center center">
                          {{ row.customField10.QuotedValue }}
                        </p>
                      </span>

                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='updatedDate'">
                  <ng-container matColumnDef="updatedDate">
                    <mat-header-cell class="headcell" *matHeaderCellDef mat-sort-header>{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.updatedDate) | date:'medium' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='adGroupName'">

                  <ng-container matColumnDef="adGroupName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.jsonRecieved?.adGroupName!=null?row.jsonRecieved?.adGroupName:row.campaignName}}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='Country'">
                  <ng-container matColumnDef="Country">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.isCustomizedValue.Country)}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='City'">
                  <ng-container matColumnDef="City">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.isCustomizedValue.City)}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='State'">
                  <ng-container matColumnDef="State">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.isCustomizedValue.State)}}
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='flag'">
                  <ng-container matColumnDef="flag">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row ; let i=index;" class="cellmat">
                      <button [attr.guide]="'common-product-btn-118' + '__' + sanitizeUrl(url)" type="button"
                        mat-icon-button (click)="flag(row,i)">
                        <mat-icon>{{ row.flag==1 ? 'flag' : 'outlined_flag' }}</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='priority'">
                  <ng-container matColumnDef="priority">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" *matCellDef="let row" class="cellmat">
                      {{ getPriorityLetter(row.priority) }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='phoneNumber'">
                  <ng-container matColumnDef="phoneNumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" *matCellDef="let row" class="cellmat">
                      <div>
                        <div *ngIf="row.phoneNumber != null">
                          <span size="23px" style="cursor: pointer;">
                            {{ row.phoneNumber }}
                          </span>

                        </div>

                        <div *ngIf="row.secondaryphoneno != null" style="margin-top: 10px;">
                          <span size="23px" style="cursor: pointer;">
                            {{ row.secondaryphoneno}}
                          </span>

                        </div>
                      </div>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='icons'">
                  <ng-container matColumnDef="icons" class="icon-list">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"></mat-header-cell>
                    <mat-cell class="cellmat" *matCellDef="let row">
                      <div>
                        <div *ngIf="row.phoneNumber != null" style="display: flex; align-items: center;">
                          <mat-icon (click)="phoneNumbercall(row); $event.stopPropagation()" [icIcon]="icPhone"
                            size="18px"
                            style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                          </mat-icon>
                          <img (click)="phonewhatsapp(row); $event.stopPropagation()" src="assets/icons/whatsapp.svg"
                            alt="Whatsapp"
                            style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                        </div>

                        <div *ngIf="row.secondaryphoneno?.length > 0"
                          style="margin-top: 5px; display: flex; align-items: center;">
                          <mat-icon (click)="secondaryphoneNumbercall(row); $event.stopPropagation()" [icIcon]="icPhone"
                            size="18px"
                            style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                          </mat-icon>
                          <img (click)="secondaryphonewhatsapp(row.customField10); $event.stopPropagation()"
                            src="assets/icons/whatsapp.svg" alt="Whatsapp"
                            style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                        </div>
                      </div>
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='walkIn'">
                  <ng-container matColumnDef="walkIn">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-119' + '__' + sanitizeUrl(url)" class="fav-button"
                        type="button" mat-icon-button (click)="walkIn(row)" [ngClass]="{ 'favorite': row.walkIn==1 }">
                        <mat-icon>{{ row.walkIn==1 ? 'directions_walk' : 'directions_walk' }}</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <!-- <ng-container matColumnDef="emailValid">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Email Valid</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                 
                  {{ row.emailValid==1 ? 'true' : 'false' }}
                </mat-cell>
              </ng-container> -->

                <ng-container *ngIf="column.property=='favourite'">
                  <ng-container matColumnDef="favourite">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-120' + '__' + sanitizeUrl(url)" class="fav-button"
                        type="button" mat-icon-button (click)="toggleFavorite(row)"
                        [ngClass]="{ 'favorite': row.favourite==1 }">
                        <mat-icon>{{ row.favourite==1 ? 'favorite' : 'favorite_border' }}</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                </ng-container>


              </ng-container>



              <mat-header-row *matHeaderRowDef="visibleColumns;sticky:true"></mat-header-row>
              <mat-row *matRowDef="let row; columns: visibleColumns;" class="clickable">
              </mat-row>
            </table>
          </div>
          <div *ngIf="display && GridType ==3 " class="Type-three" style="width: 100%;overflow-x: auto;">

            <table (matSortChange)="sortData($event)" [dataSource]="productList" class="w-full" mat-table matSort>


              <ng-container matColumnDef="select" style="border-bottom: none;border-bottom-width: 0px;">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox [attr.guide]="'common-product-chk-121' + '__' + sanitizeUrl(url)"
                    (change)="toggleAllRows($event.checked)" [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                  </mat-checkbox>

                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox [attr.guide]="'common-product-chk-122' + '__' + sanitizeUrl(url)"
                    (click)="$event.stopPropagation()"
                    (change)="changeValue($event.checked, row); $event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)" [checked]="selection.isSelected(row)"
                    [aria-label]="checkboxLabel(row)">
                  </mat-checkbox>
                </td>
              </ng-container>

              <ng-container *ngFor="let column of columns">
                <ng-container *ngIf="column.isModelProperty!='false'">

                  <ng-container *ngIf="column.isModelProperty && column.property!='actions'"
                    [matColumnDef]="column.property">


                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name }}
                    </mat-header-cell>
                    <mat-cell [ngClass]="column.cssClasses" class="cellmat" *matCellDef="let row">

                      <span *ngIf="column.property.includes('customValuesIs')">
                        {{row.isCustomizedValue[column.propertyName] }}

                      </span>
                      <span
                        *ngIf="!column.property.includes('customValuesIs')&&column.name!='Follow Up Data Time';else other_content">
                        {{row[column.property] }}

                      </span>
                      <ng-template #other_content>

                        {{row[column.property] | date:'medium'}}
                      </ng-template>


                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='actions'">
                  <ng-container matColumnDef="actions">

                    <mat-header-cell class="actions-cell" *matHeaderCellDef class="headcell">Action</mat-header-cell>
                    <mat-cell class="actions-cell" *matCellDef="let row;let i=index" class="cellmat">
                      <button [attr.guide]="'common-product-btn-123' + '__' + sanitizeUrl(url)" type="button"
                        mat-icon-button [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
                        <mat-icon>more_horiz</mat-icon>
                      </button>
                      <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                        <button [attr.guide]="'common-product-btn-124' + '__' + sanitizeUrl(url)"
                          [disabled]="!resourcePrivilege?.update" (click)="editProduct(row.entityId,row.attributeSetId)"
                          mat-menu-item>
                          <mat-icon>edit</mat-icon>
                          <span>edit</span>
                        </button>



                        <button [attr.guide]="'common-product-btn-125' + '__' + sanitizeUrl(url)"
                          *ngIf="leadToCustomer == 1" (click)="getApprove(row)" mat-menu-item>
                          <mat-icon>refresh</mat-icon>
                          <span>Convert to Customer</span>
                        </button>

                        <button [attr.guide]="'common-product-btn-126' + '__' + sanitizeUrl(url)"
                          [disabled]="!resourcePrivilege?.delete" (click)="deleteAllProductId(row.entityId)"
                          mat-menu-item>
                          <mat-icon>delete</mat-icon>
                          <span>delete</span>
                        </button>

                        <ng-container *ngIf="crmType==0 || crmType==4">
                          <button [attr.guide]="'common-product-btn-127' + '__' + sanitizeUrl(url)"
                            (click)="openLeadStage(row,i)" mat-menu-item>
                            <mat-icon>group_add</mat-icon>
                            <span>Lead Stage</span>
                          </button>
                          <button [attr.guide]="'common-product-btn-128' + '__' + sanitizeUrl(url)"
                            (click)="openLeadPriority(row)" mat-menu-item>
                            <mat-icon>priority_high</mat-icon>
                            <span>Add Lead Priority</span>
                          </button>

                        </ng-container>

                        <button [attr.guide]="'common-product-btn-129' + '__' + sanitizeUrl(url)"
                          *ngIf="column.showLeadStage==1" (click)="openLeadStage(row,i)" mat-menu-item>
                          <mat-icon>group_add</mat-icon>
                          <span>Lead Stage</span>
                        </button>
                        <button [attr.guide]="'common-product-btn-130' + '__' + sanitizeUrl(url)"
                          *ngIf="column.showLeadPriority==1" (click)="openLeadPriority(row)" mat-menu-item>
                          <mat-icon>priority_high</mat-icon>
                          <span>Add Lead Priority</span>
                        </button>

                        <button [attr.guide]="'common-product-btn-131' + '__' + sanitizeUrl(url)" *ngIf="enableSequence"
                          (click)="SequenceStatusPopup('single',row)" mat-menu-item>
                          <mat-icon>start</mat-icon>
                          <span>Add Lead Sequences</span>
                        </button>

                      </mat-menu>
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='name'">
                  <ng-container matColumnDef="name">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.name) | slice:0:20}}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='lastActivityNotes'">
                  <ng-container matColumnDef="lastActivityNotes">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.lastActivityNotes) | slice:0:20}}
                    </mat-cell>
                  </ng-container>

                </ng-container>


                <ng-container *ngIf="column.property=='statusName'">
                  <ng-container matColumnDef="statusName">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.statusName) | slice:0:20}}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <!-- <ng-container *ngIf="column.property=='company'">
                  <ng-container matColumnDef="company">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="companyNavigation(row.companyId)" class="cellmat" *matCellDef="let row">
                      {{(row.company) }}
                    </mat-cell>
                  </ng-container>

                </ng-container> -->

                <ng-container *ngIf="column.property=='totalCallDuration'">

                  <ng-container matColumnDef="totalCallDuration">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell style="text-align: center;" *matCellDef="let row" class="cellmat">
                      {{ formatSecondsToTime(row.totalCallDuration) }}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='note'">


                  <ng-container matColumnDef="note">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-132' + '__' + sanitizeUrl(url)"
                        style="border: 1px solid #dee2e6; padding: 2px; border-radius: 15px; display: flex; align-items: center;"
                        (click)="Note(row)">
                        <mat-icon>add_circle</mat-icon>
                        <span>New Notes</span>
                      </button>

                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='followUpDateTimePopup'">
                  <ng-container matColumnDef="followUpDateTimePopup">
                    <mat-header-cell *matHeaderCellDef class="headcell">{{ column.name }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-133' + '__' + sanitizeUrl(url)"
                        style="border: 1px solid #dee2e6; padding: 2px; border-radius: 15px; display: flex; align-items: center; gap: 5px;"
                        (click)="openFollowUp(row)">
                        <mat-icon>add_circle</mat-icon>
                        <span>Follow Up</span>
                      </button>

                    </mat-cell>
                  </ng-container>

                </ng-container>


                <ng-container *ngIf="column.property=='deal'">
                  <ng-container matColumnDef="deal">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <span class="deals">{{row.deal || 'Open'}}</span>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='score'">
                  <ng-container matColumnDef="score">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.score || 0.0}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='status'">
                  <ng-container matColumnDef="status">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <span [ngClass]="{'statustType': row.status}">{{row.status}}</span>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='sourceName'">
                  <ng-container matColumnDef="sourceName">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.sourceName) | slice:0:20}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='createdDate'">

                  <ng-container matColumnDef="createdDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.createdDate) | date:'medium' }}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='activityCountOnLead'">
                  <ng-container matColumnDef="activityCountOnLead">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p style="text-align: center;">{{(row.activityCountOnLead) }}</p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='CrNo_cust'">
                  <ng-container matColumnDef="CrNo_cust">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{(row.isCustomizedValue.CrNo)}}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='CrName_cust'">
                  <ng-container matColumnDef="CrName_cust">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{(row.isCustomizedValue.CrName)}}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='choiceofprogram'">
                  <ng-container matColumnDef="choiceofprogram">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{ row.isCustomizedValue['Choice Of Program'] || row.customField10?.ChoiceOfProgram }}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='preferablelanguage'">
                  <ng-container matColumnDef="preferablelanguage">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{ row.isCustomizedValue?.['Preferable Language'] || row.customField10?.PreferableLanguage }}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='collegeName'">
                  <ng-container matColumnDef="collegeName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.collegeName }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='jobtitle'">
                  <ng-container matColumnDef="jobtitle">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Job title</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.jobtitle ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='department'">
                  <ng-container matColumnDef="department">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField10?.Department ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='district'">
                  <ng-container matColumnDef="district">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField10?.District ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='parentsnumber'">

                  <ng-container matColumnDef="parentsnumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField10?.ParentsNumber ?? '' }}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='yearofstudy'">
                  <ng-container matColumnDef="yearofstudy">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell class="cellmat" *matCellDef="let row">
                      {{ row.customField10?.YearOfStudy ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='section'">
                  <ng-container matColumnDef="section">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField1?.Section ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='quoted'">
                  <ng-container matColumnDef="quoted">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">

                      <span *ngIf="row.customField10 && row.customField10.QuotedValue != null">
                        <p fxFlex="100" fxLayoutAlign="center center">
                          {{ row.customField10.QuotedValue }}
                        </p>
                      </span>

                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='updatedDate'">
                  <ng-container matColumnDef="updatedDate">
                    <mat-header-cell class="headcell" *matHeaderCellDef mat-sort-header>{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.updatedDate) | date:'medium' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='adGroupName'">

                  <ng-container matColumnDef="adGroupName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.jsonRecieved?.adGroupName!=null?row.jsonRecieved?.adGroupName:row.campaignName}}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='Country'">
                  <ng-container matColumnDef="Country">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.isCustomizedValue.Country)}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='City'">
                  <ng-container matColumnDef="City">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.isCustomizedValue.City)}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='State'">
                  <ng-container matColumnDef="State">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.isCustomizedValue.State)}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                ///
                <ng-container *ngIf="column.property=='flag'">
                  <ng-container matColumnDef="flag">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row ; let i=index;" class="cellmat">
                      <button [attr.guide]="'common-product-btn-134' + '__' + sanitizeUrl(url)" type="button"
                        mat-icon-button (click)="flag(row,i)">
                        <mat-icon>{{ row.flag==1 ? 'flag' : 'outlined_flag' }}</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='priority'">
                  <ng-container matColumnDef="priority">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" *matCellDef="let row" class="cellmat">
                      {{ getPriorityLetter(row.priority) }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='phoneNumber'">
                  <ng-container matColumnDef="phoneNumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" *matCellDef="let row" class="cellmat">
                      <div>
                        <div *ngIf="row.phoneNumber != null">
                          <span size="23px" style="cursor: pointer;">
                            {{ row.phoneNumber }}
                          </span>

                        </div>

                        <div *ngIf="row.secondaryphoneno != null" style="margin-top: 10px;">
                          <span size="23px" style="cursor: pointer;">
                            {{ row.secondaryphoneno}}
                          </span>

                        </div>
                      </div>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='icons'">
                  <ng-container matColumnDef="icons" class="icon-list">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"></mat-header-cell>
                    <mat-cell class="cellmat" *matCellDef="let row">
                      <div>
                        <div *ngIf="row.phoneNumber != null" style="display: flex; align-items: center;">
                          <mat-icon (click)="phoneNumbercall(row); $event.stopPropagation()" [icIcon]="icPhone"
                            size="18px"
                            style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                          </mat-icon>
                          <img (click)="phonewhatsapp(row); $event.stopPropagation()" src="assets/icons/whatsapp.svg"
                            alt="Whatsapp"
                            style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                        </div>

                        <div *ngIf="row.secondaryphoneno?.length > 0"
                          style="margin-top: 5px; display: flex; align-items: center;">
                          <mat-icon (click)="secondaryphoneNumbercall(row); $event.stopPropagation()" [icIcon]="icPhone"
                            size="18px"
                            style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                          </mat-icon>
                          <img (click)="secondaryphonewhatsapp(row.customField10); $event.stopPropagation()"
                            src="assets/icons/whatsapp.svg" alt="Whatsapp"
                            style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                        </div>
                      </div>
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='walkIn'">
                  <ng-container matColumnDef="walkIn">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-135' + '__' + sanitizeUrl(url)" class="fav-button"
                        type="button" mat-icon-button (click)="walkIn(row)" [ngClass]="{ 'favorite': row.walkIn==1 }">
                        <mat-icon>{{ row.walkIn==1 ? 'directions_walk' : 'directions_walk' }}</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <!-- <ng-container matColumnDef="emailValid">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Email Valid</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                 
                  {{ row.emailValid==1 ? 'true' : 'false' }}
                </mat-cell>
              </ng-container> -->

                <ng-container *ngIf="column.property=='favourite'">
                  <ng-container matColumnDef="favourite">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-136' + '__' + sanitizeUrl(url)" class="fav-button"
                        type="button" mat-icon-button (click)="toggleFavorite(row)"
                        [ngClass]="{ 'favorite': row.favourite==1 }">
                        <mat-icon>{{ row.favourite==1 ? 'favorite' : 'favorite_border' }}</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                </ng-container>


              </ng-container>



              <mat-header-row *matHeaderRowDef="visibleColumns;sticky:true"></mat-header-row>
              <mat-row *matRowDef="let row; columns: visibleColumns;" class="clickable">
              </mat-row>
            </table>
          </div>

          <div *ngIf="display && GridType ==4 " class="table-responsive custom-table table-type-four"
            style="width: 100%;overflow-x: auto;">

            <table (matSortChange)="sortData($event)" [dataSource]="productList" class="w-full" mat-table matSort>

              <ng-container matColumnDef="select" style="border-bottom: none;border-bottom-width: 0px;">
                <th style="padding-right: 15px;" mat-header-cell *matHeaderCellDef>
                  <mat-checkbox [attr.guide]="'common-product-chk-137' + '__' + sanitizeUrl(url)"
                    (change)="toggleAllRows($event.checked)" [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                  </mat-checkbox>

                </th>
                <td style="padding-right: 15px;" mat-cell *matCellDef="let row">
                  <mat-checkbox [attr.guide]="'common-product-chk-138' + '__' + sanitizeUrl(url)"
                    (click)="$event.stopPropagation()"
                    (change)="changeValue($event.checked, row); $event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)" [checked]="selection.isSelected(row)"
                    [aria-label]="checkboxLabel(row)">
                  </mat-checkbox>
                </td>
              </ng-container>




              <ng-container *ngFor="let column of columns">
                <ng-container *ngIf="column.isModelProperty!='false'">

                  <ng-container *ngIf="column.isModelProperty && column.property!='actions'"
                    [matColumnDef]="column.property">


                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name }}
                    </mat-header-cell>
                    <mat-cell [ngClass]="column.cssClasses" class="cellmat" *matCellDef="let row">

                      <span *ngIf="column.property.includes('customValuesIs')">
                        {{row.isCustomizedValue[column.propertyName] }}

                      </span>
                      <span
                        *ngIf="!column.property.includes('customValuesIs')&&column.name!='Follow Up Data Time';else other_content">
                        {{row[column.property] }}

                      </span>
                      <ng-template #other_content>

                        {{row[column.property] | date:'medium'}}
                      </ng-template>


                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='actions'">
                  <ng-container matColumnDef="actions">

                    <mat-header-cell class="actions-cell" *matHeaderCellDef class="headcell">Action</mat-header-cell>
                    <mat-cell class="actions-cell" *matCellDef="let row;let i=index" class="cellmat">
                      <button [attr.guide]="'common-product-btn-139' + '__' + sanitizeUrl(url)" type="button"
                        mat-icon-button [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
                        <mat-icon>more_horiz</mat-icon>
                      </button>
                      <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                        <button [attr.guide]="'common-product-btn-140' + '__' + sanitizeUrl(url)"
                          [disabled]="!resourcePrivilege?.update" (click)="editProduct(row.entityId,row.attributeSetId)"
                          mat-menu-item>
                          <mat-icon>edit</mat-icon>
                          <span>edit</span>
                        </button>



                        <button [attr.guide]="'common-product-btn-141' + '__' + sanitizeUrl(url)"
                          *ngIf="leadToCustomer == 1" (click)="getApprove(row)" mat-menu-item>
                          <mat-icon>refresh</mat-icon>
                          <span>Convert to Customer</span>
                        </button>

                        <button [attr.guide]="'common-product-btn-142' + '__' + sanitizeUrl(url)"
                          [disabled]="!resourcePrivilege?.delete" (click)="deleteAllProductId(row.entityId)"
                          mat-menu-item>
                          <mat-icon>delete</mat-icon>
                          <span>delete</span>
                        </button>

                        <ng-container *ngIf="crmType==0 || crmType==4">
                          <button [attr.guide]="'common-product-btn-143' + '__' + sanitizeUrl(url)"
                            (click)="openLeadStage(row,i)" mat-menu-item>
                            <mat-icon>group_add</mat-icon>
                            <span>Lead Stage</span>
                          </button>
                          <button [attr.guide]="'common-product-btn-144' + '__' + sanitizeUrl(url)"
                            (click)="openLeadPriority(row)" mat-menu-item>
                            <mat-icon>priority_high</mat-icon>
                            <span>Add Lead Priority</span>
                          </button>

                        </ng-container>

                        <button [attr.guide]="'common-product-btn-145' + '__' + sanitizeUrl(url)"
                          *ngIf="column.showLeadStage==1" (click)="openLeadStage(row,i)" mat-menu-item>
                          <mat-icon>group_add</mat-icon>
                          <span>Lead Stage</span>
                        </button>
                        <button [attr.guide]="'common-product-btn-146' + '__' + sanitizeUrl(url)"
                          *ngIf="column.showLeadPriority==1" (click)="openLeadPriority(row)" mat-menu-item>
                          <mat-icon>priority_high</mat-icon>
                          <span>Add Lead Priority</span>
                        </button>

                        <button [attr.guide]="'common-product-btn-147' + '__' + sanitizeUrl(url)" *ngIf="enableSequence"
                          (click)="SequenceStatusPopup('single',row)" mat-menu-item>
                          <mat-icon>start</mat-icon>
                          <span>Add Lead Sequences</span>
                        </button>

                      </mat-menu>
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='name'">
                  <ng-container matColumnDef="name">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.name) | slice:0:20}}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='lastActivityNotes'">
                  <ng-container matColumnDef="lastActivityNotes">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.lastActivityNotes) | slice:0:20}}
                    </mat-cell>
                  </ng-container>

                </ng-container>


                <ng-container *ngIf="column.property=='statusName'">
                  <ng-container matColumnDef="statusName">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.statusName) | slice:0:20}}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <!-- <ng-container *ngIf="column.property=='company'">
                  <ng-container matColumnDef="company">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="companyNavigation(row.companyId)" class="cellmat" *matCellDef="let row">
                      {{(row.company) }}
                    </mat-cell>
                  </ng-container>

                </ng-container> -->

                <ng-container *ngIf="column.property=='totalCallDuration'">

                  <ng-container matColumnDef="totalCallDuration">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell style="text-align: center;" *matCellDef="let row" class="cellmat">
                      {{ formatSecondsToTime(row.totalCallDuration) }}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='note'">


                  <ng-container matColumnDef="note">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-148' + '__' + sanitizeUrl(url)"
                        style="border: 1px solid #dee2e6; padding: 2px; border-radius: 15px; display: flex; align-items: center;"
                        (click)="Note(row)">
                        <mat-icon>add_circle</mat-icon>
                        <span>New Notes</span>
                      </button>

                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='followUpDateTimePopup'">
                  <ng-container matColumnDef="followUpDateTimePopup">
                    <mat-header-cell *matHeaderCellDef class="headcell">{{ column.name }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-149' + '__' + sanitizeUrl(url)"
                        style="border: 1px solid #dee2e6; padding: 2px; border-radius: 15px; display: flex; align-items: center; gap: 5px;"
                        (click)="openFollowUp(row)">
                        <mat-icon>add_circle</mat-icon>
                        <span>Follow Up</span>
                      </button>

                    </mat-cell>
                  </ng-container>

                </ng-container>


                <ng-container *ngIf="column.property=='deal'">
                  <ng-container matColumnDef="deal">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <span class="deals">{{row.deal || 'Open'}}</span>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='score'">
                  <ng-container matColumnDef="score">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.score || 0.0}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='status'">
                  <ng-container matColumnDef="status">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <span [ngClass]="{'statustType': row.status}">{{row.status}}</span>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='sourceName'">
                  <ng-container matColumnDef="sourceName">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.sourceName) | slice:0:20}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='createdDate'">

                  <ng-container matColumnDef="createdDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.createdDate) | date:'medium' }}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='activityCountOnLead'">
                  <ng-container matColumnDef="activityCountOnLead">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p style="text-align: center;">{{(row.activityCountOnLead) }}</p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='CrNo_cust'">
                  <ng-container matColumnDef="CrNo_cust">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{(row.isCustomizedValue.CrNo)}}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='CrName_cust'">
                  <ng-container matColumnDef="CrName_cust">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{(row.isCustomizedValue.CrName)}}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='choiceofprogram'">
                  <ng-container matColumnDef="choiceofprogram">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{ row.isCustomizedValue['Choice Of Program'] || row.customField10?.ChoiceOfProgram }}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='preferablelanguage'">
                  <ng-container matColumnDef="preferablelanguage">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{ row.isCustomizedValue?.['Preferable Language'] || row.customField10?.PreferableLanguage }}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='collegeName'">
                  <ng-container matColumnDef="collegeName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.collegeName }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='jobtitle'">

                  <ng-container matColumnDef="jobtitle">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Job title</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.jobtitle ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='department'">
                  <ng-container matColumnDef="department">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField10?.Department ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='district'">
                  <ng-container matColumnDef="district">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField10?.District ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='parentsnumber'">

                  <ng-container matColumnDef="parentsnumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField10?.ParentsNumber ?? '' }}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='yearofstudy'">
                  <ng-container matColumnDef="yearofstudy">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell class="cellmat" *matCellDef="let row">
                      {{ row.customField10?.YearOfStudy ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='section'">
                  <ng-container matColumnDef="section">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField1?.Section ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='quoted'">
                  <ng-container matColumnDef="quoted">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">

                      <span *ngIf="row.customField10 && row.customField10.QuotedValue != null">
                        <p fxFlex="100" fxLayoutAlign="center center">
                          {{ row.customField10.QuotedValue }}
                        </p>
                      </span>

                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='updatedDate'">
                  <ng-container matColumnDef="updatedDate">
                    <mat-header-cell class="headcell" *matHeaderCellDef mat-sort-header>{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.updatedDate) | date:'medium' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='adGroupName'">

                  <ng-container matColumnDef="adGroupName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.jsonRecieved?.adGroupName!=null?row.jsonRecieved?.adGroupName:row.campaignName}}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='Country'">
                  <ng-container matColumnDef="Country">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.isCustomizedValue.Country)}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='City'">
                  <ng-container matColumnDef="City">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.isCustomizedValue.City)}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='State'">
                  <ng-container matColumnDef="State">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.isCustomizedValue.State)}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                ///
                <ng-container *ngIf="column.property=='flag'">
                  <ng-container matColumnDef="flag">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row ; let i=index;" class="cellmat">
                      <button [attr.guide]="'common-product-btn-150' + '__' + sanitizeUrl(url)" type="button"
                        mat-icon-button (click)="flag(row,i)">
                        <mat-icon>{{ row.flag==1 ? 'flag' : 'outlined_flag' }}</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='priority'">
                  <ng-container matColumnDef="priority">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" *matCellDef="let row" class="cellmat">
                      {{ getPriorityLetter(row.priority) }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='phoneNumber'">
                  <ng-container matColumnDef="phoneNumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" *matCellDef="let row" class="cellmat">
                      <div>
                        <div *ngIf="row.phoneNumber != null">
                          <span size="23px" style="cursor: pointer;">
                            {{ row.phoneNumber }}
                          </span>

                        </div>

                        <div *ngIf="row.secondaryphoneno != null" style="margin-top: 10px;">
                          <span size="23px" style="cursor: pointer;">
                            {{ row.secondaryphoneno}}
                          </span>

                        </div>
                      </div>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='icons'">
                  <ng-container matColumnDef="icons" class="icon-list">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"></mat-header-cell>
                    <mat-cell class="cellmat" *matCellDef="let row">
                      <div>
                        <div *ngIf="row.phoneNumber != null" style="display: flex; align-items: center;">
                          <mat-icon (click)="phoneNumbercall(row); $event.stopPropagation()" [icIcon]="icPhone"
                            size="18px"
                            style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                          </mat-icon>
                          <img (click)="phonewhatsapp(row); $event.stopPropagation()" src="assets/icons/whatsapp.svg"
                            alt="Whatsapp"
                            style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                        </div>

                        <div *ngIf="row.secondaryphoneno?.length > 0"
                          style="margin-top: 5px; display: flex; align-items: center;">
                          <mat-icon (click)="secondaryphoneNumbercall(row); $event.stopPropagation()" [icIcon]="icPhone"
                            size="18px"
                            style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                          </mat-icon>
                          <img (click)="secondaryphonewhatsapp(row.customField10); $event.stopPropagation()"
                            src="assets/icons/whatsapp.svg" alt="Whatsapp"
                            style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                        </div>
                      </div>
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='walkIn'">
                  <ng-container matColumnDef="walkIn">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-151' + '__' + sanitizeUrl(url)" class="fav-button"
                        type="button" mat-icon-button (click)="walkIn(row)" [ngClass]="{ 'favorite': row.walkIn==1 }">
                        <mat-icon>{{ row.walkIn==1 ? 'directions_walk' : 'directions_walk' }}</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <!-- <ng-container matColumnDef="emailValid">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Email Valid</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                 
                  {{ row.emailValid==1 ? 'true' : 'false' }}
                </mat-cell>
              </ng-container> -->

                <ng-container *ngIf="column.property=='favourite'">
                  <ng-container matColumnDef="favourite">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-152' + '__' + sanitizeUrl(url)" class="fav-button"
                        type="button" mat-icon-button (click)="toggleFavorite(row)"
                        [ngClass]="{ 'favorite': row.favourite==1 }">
                        <mat-icon>{{ row.favourite==1 ? 'favorite' : 'favorite_border' }}</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                </ng-container>


              </ng-container>
              <mat-header-row *matHeaderRowDef="visibleColumns;sticky:true"></mat-header-row>
              <mat-row *matRowDef="let row; columns: visibleColumns;" class="clickable">
              </mat-row>
            </table>
          </div>

          <div *ngIf="display && GridType == 5" class="table-responsive custom-table table-type-four"
            style="width: 100%;overflow-x: auto;">


            <table (matSortChange)="sortData($event)" [dataSource]="productList" class="w-full" mat-table matSort>

              <ng-container matColumnDef="select" style="border-bottom: none;border-bottom-width: 0px;">
                <th style="padding-right: 15px; border: none;" mat-header-cell *matHeaderCellDef>
                  <mat-checkbox [attr.guide]="'common-product-chk-153' + '__' + sanitizeUrl(url)"
                    (change)="toggleAllRows($event.checked)" [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                  </mat-checkbox>

                </th>
                <td style="padding-right: 15px;" mat-cell *matCellDef="let row">
                  <mat-checkbox [attr.guide]="'common-product-chk-154' + '__' + sanitizeUrl(url)"
                    (click)="$event.stopPropagation()"
                    (change)="changeValue($event.checked, row); $event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)" [checked]="selection.isSelected(row)"
                    [aria-label]="checkboxLabel(row)">
                  </mat-checkbox>
                </td>
              </ng-container>



              <ng-container matColumnDef="flag">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Flag</mat-header-cell>
                <mat-cell *matCellDef="let row ; let i=index;" class="cellmat">
                  <button [attr.guide]="'common-product-btn-155' + '__' + sanitizeUrl(url)" type="button"
                    mat-icon-button (click)="flag(row,i)">
                    <mat-icon>{{ row.flag==1 ? 'flag' : 'outlined_flag' }}</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>


              <!-- fullName Column -->
              <ng-container *ngFor="let column of columns">
                <ng-container *ngIf="column.isModelProperty!='false'">

                  <ng-container *ngIf="column.isModelProperty && column.property!='actions'"
                    [matColumnDef]="column.property">


                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name }}
                    </mat-header-cell>
                    <mat-cell [ngClass]="column.cssClasses" class="cellmat" *matCellDef="let row">

                      <span *ngIf="column.property.includes('customValuesIs')">
                        {{row.isCustomizedValue[column.propertyName] }}

                      </span>
                      <span
                        *ngIf="!column.property.includes('customValuesIs')&&column.name!='Follow Up Data Time';else other_content">
                        {{row[column.property] }}

                      </span>
                      <ng-template #other_content>

                        {{row[column.property] | date:'medium'}}
                      </ng-template>


                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='actions'">
                  <ng-container matColumnDef="actions">

                    <mat-header-cell class="actions-cell" *matHeaderCellDef class="headcell">Action</mat-header-cell>
                    <mat-cell class="actions-cell" *matCellDef="let row;let i=index" class="cellmat">
                      <button [attr.guide]="'common-product-btn-156' + '__' + sanitizeUrl(url)" type="button"
                        mat-icon-button [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
                        <mat-icon>more_horiz ss</mat-icon>
                      </button>
                      <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                        <button [attr.guide]="'common-product-btn-157' + '__' + sanitizeUrl(url)"
                          [disabled]="!resourcePrivilege?.update" (click)="editProduct(row.entityId,row.attributeSetId)"
                          mat-menu-item>
                          <mat-icon>edit</mat-icon>
                          <span>edit</span>
                        </button>



                        <button [attr.guide]="'common-product-btn-158' + '__' + sanitizeUrl(url)"
                          *ngIf="leadToCustomer == 1" (click)="getApprove(row)" mat-menu-item>
                          <mat-icon>refresh</mat-icon>
                          <span>Convert to Customer</span>
                        </button>

                        <button [attr.guide]="'common-product-btn-159' + '__' + sanitizeUrl(url)"
                          [disabled]="!resourcePrivilege?.delete" (click)="deleteAllProductId(row.entityId)"
                          mat-menu-item>
                          <mat-icon>delete</mat-icon>
                          <span>delete</span>
                        </button>

                        <ng-container *ngIf="crmType==0 || crmType==4">
                          <button [attr.guide]="'common-product-btn-160' + '__' + sanitizeUrl(url)"
                            (click)="openLeadStage(row,i)" mat-menu-item>
                            <mat-icon>group_add</mat-icon>
                            <span>Lead Stage</span>
                          </button>
                          <button [attr.guide]="'common-product-btn-161' + '__' + sanitizeUrl(url)"
                            (click)="openLeadPriority(row)" mat-menu-item>
                            <mat-icon>priority_high</mat-icon>
                            <span>Add Lead Priority</span>
                          </button>



                        </ng-container>

                        <button [attr.guide]="'common-product-btn-162' + '__' + sanitizeUrl(url)"
                          *ngIf="column.showLeadStage==1" (click)="openLeadStage(row,i)" mat-menu-item>
                          <mat-icon>group_add</mat-icon>
                          <span>Lead Stage</span>
                        </button>
                        <button [attr.guide]="'common-product-btn-163' + '__' + sanitizeUrl(url)"
                          *ngIf="column.showLeadPriority==1" (click)="openLeadPriority(row)" mat-menu-item>
                          <mat-icon>priority_high</mat-icon>
                          <span>Add Lead Priority</span>
                        </button>
                        <button [attr.guide]="'common-product-btn-164' + '__' + sanitizeUrl(url)" *ngIf="enableSequence"
                          (click)="SequenceStatusPopup('single',row)" mat-menu-item>
                          <mat-icon>start</mat-icon>
                          <span>Add Lead Sequences</span>
                        </button>


                      </mat-menu>
                    </mat-cell>
                  </ng-container>

                </ng-container>

              </ng-container>
              <ng-container matColumnDef="name" sticky>

                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Name </mat-header-cell>
                <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                  {{(row.name)}}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="statusName">

                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Life Stage</mat-header-cell>
                <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                  {{row.statusName}}

                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="phoneNumber">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Phone No</mat-header-cell>
                <mat-cell (click)="details(row.entityId,row.attributeSetId)" *matCellDef="let row" class="cellmat">
                  <div>
                    <div *ngIf="row.phoneNumber != null">
                      <span size="23px" style="cursor: pointer;">
                        {{ row.phoneNumber }}
                      </span>

                    </div>

                    <div *ngIf="row.secondaryphoneno != null" style="margin-top: 10px;">
                      <span size="23px" style="cursor: pointer;">
                        {{ row.secondaryphoneno}}
                      </span>

                    </div>
                  </div>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="sourceName">

                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Source Name</mat-header-cell>
                <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                  {{(row.sourceName) | slice:0:20}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="icons" class="icon-list">

                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"></mat-header-cell>
                <mat-cell class="cellmat" *matCellDef="let row">
                  <div>
                    <div *ngIf="row.phoneNumber != null" style="display: flex; align-items: center;">
                      <mat-icon (click)="phoneNumbercall(row); $event.stopPropagation()" [icIcon]="icPhone" size="18px"
                        style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                      </mat-icon>
                      <img (click)="phonewhatsapp(row); $event.stopPropagation()" src="assets/icons/whatsapp.svg"
                        alt="Whatsapp"
                        style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                    </div>

                    <div *ngIf="row.secondaryphoneno?.length > 0"
                      style="margin-top: 5px; display: flex; align-items: center;">
                      <mat-icon (click)="secondaryphoneNumbercall(row); $event.stopPropagation()" [icIcon]="icPhone"
                        size="18px"
                        style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                      </mat-icon>
                      <img (click)="secondaryphonewhatsapp(row.customField10); $event.stopPropagation()"
                        src="assets/icons/whatsapp.svg" alt="Whatsapp"
                        style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                    </div>
                  </div>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="priority">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Priority</mat-header-cell>
                <mat-cell (click)="details(row.entityId,row.attributeSetId)" *matCellDef="let row" class="cellmat">
                  {{row.priority }}
                </mat-cell>
              </ng-container>


              <ng-container matColumnDef="createdDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Created Date</mat-header-cell>
                <mat-cell (click)="details(row.entityId,row.attributeSetId)" *matCellDef="let row" class="cellmat">
                  {{(row.createdDate) | date:'medium' }}
                </mat-cell>
              </ng-container>


              <ng-container matColumnDef="activityCountOnLead">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Activity Count</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <p style="text-align: center;">{{(row.activityCountOnLead) }}</p>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="CrNo_cust">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Cr No</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <p fxFlex="100" fxLayoutAlign="center center">
                    {{(row.isCustomizedValue.CrNo)}}
                  </p>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="CrName_cust">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Cr Name</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <p fxFlex="100" fxLayoutAlign="center center">
                    {{(row.isCustomizedValue.CrName)}}
                  </p>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="choiceofprogram">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Choice Of Program</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <p fxFlex="100" fxLayoutAlign="center center">
                    {{ row.isCustomizedValue['Choice Of Program'] || row.customField10?.ChoiceOfProgram }}
                  </p>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="preferablelanguage">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Preferable
                  Language</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <p fxFlex="100" fxLayoutAlign="center center">
                    {{ row.isCustomizedValue?.['Preferable Language'] || row.customField10?.PreferableLanguage }}
                  </p>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="collegeName">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">College</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{ row.collegeName }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="jobtitle">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Job title</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{ row.jobtitle ?? '' }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="department">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Department</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{ row.customField10?.Department ?? '' }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="district">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">District</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{ row.customField10?.District ?? '' }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="parentsnumber">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">ParentsNumber</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{ row.customField10?.ParentsNumber ?? '' }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="yearofstudy">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">YearOfStudy</mat-header-cell>
                <mat-cell class="cellmat" *matCellDef="let row">
                  {{ row.customField10?.YearOfStudy ?? '' }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="section">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Section</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{ row.customField1?.Section ?? '' }}
                </mat-cell>
              </ng-container>



              <ng-container matColumnDef="quoted">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Quoted Value</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">

                  <span *ngIf="row.customField10 && row.customField10.QuotedValue != null">
                    <p fxFlex="100" fxLayoutAlign="center center">
                      {{ row.customField10.QuotedValue }}
                    </p>
                  </span>

                </mat-cell>
              </ng-container>



              <ng-container matColumnDef="updatedDate">
                <mat-header-cell class="headcell" *matHeaderCellDef mat-sort-header>Updated Date</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{(row.updatedDate) | date:'medium' }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="adGroupName">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Campaign Name</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{ row.jsonRecieved?.adGroupName!=null?row.jsonRecieved?.adGroupName:row.campaignName}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="totalCallDuration">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Total Call
                  Duration</mat-header-cell>
                <mat-cell style="text-align: center;" *matCellDef="let row" class="cellmat">
                  {{ formatSecondsToTime(row.totalCallDuration) }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Country">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Country</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{(row.isCustomizedValue.Country)}}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="City">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">City</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{(row.isCustomizedValue.City)}}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="State">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">State</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{(row.isCustomizedValue.State)}}
                </mat-cell>
              </ng-container>





              <ng-container matColumnDef="walkIn">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Walk In</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <button [attr.guide]="'common-product-btn-165' + '__' + sanitizeUrl(url)" class="fav-button"
                    type="button" mat-icon-button (click)="walkIn(row)" [ngClass]="{ 'favorite': row.walkIn==1 }">
                    <mat-icon>{{ row.walkIn==1 ? 'directions_walk' : 'directions_walk' }}</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>

              <!-- <ng-container matColumnDef="emailValid">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Email Valid</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                 
                  {{ row.emailValid==1 ? 'true' : 'false' }}
                </mat-cell>
              </ng-container> -->

              <ng-container matColumnDef="note">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Note</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <button [attr.guide]="'common-product-btn-166' + '__' + sanitizeUrl(url)"
                    style="border: 1px solid #dee2e6; padding: 2px; border-radius: 15px; display: flex; align-items: center; gap: 5px;"
                    (click)="Note(row)">
                    <mat-icon>add_circle</mat-icon>
                    <span>New Notes</span>
                  </button>

                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="followUpDateTimePopup">
                <mat-header-cell *matHeaderCellDef class="headcell">Upcoming Follow Up</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <button [attr.guide]="'common-product-btn-167' + '__' + sanitizeUrl(url)"
                    style="border: 1px solid #dee2e6; padding: 2px; border-radius: 15px; display: flex; align-items: center; gap: 5px;"
                    (click)="openFollowUp(row)">
                    <mat-icon>add_circle</mat-icon>
                    <span>Follow Up</span>
                  </button>

                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="deal">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Deal</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <span class="deals">{{row.deal || 'Open'}}</span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="score">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Score</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  {{ row.score || 0.0}}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Status</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <span [ngClass]="{'statustType': row.status}">{{row.status}}</span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="favourite">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Favourite</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                  <button [attr.guide]="'common-product-btn-168' + '__' + sanitizeUrl(url)" class="fav-button"
                    type="button" mat-icon-button (click)="toggleFavorite(row)"
                    [ngClass]="{ 'favorite': row.favourite==1 }">
                    <mat-icon>{{ row.favourite==1 ? 'favorite' : 'favorite_border' }}</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>


              <!-- actions Column -->
              <!-- <mat-icon [icIcon]="icPhone" size="18px"></mat-icon> -->
              <!-- <ng-container matColumnDef="actions" style="width: 100%; z-index: 1000;">

            <mat-header-cell class="actions-cell" *matHeaderCellDef class="headcell">Action</mat-header-cell>
            <mat-cell class="actions-cell" *matCellDef="let row;let i=index" class="cellmat">


              <button [attr.guide]="'common-product-btn-169' + '__' + sanitizeUrl(url)" class="actionsbtn" type="button" [matMenuTriggerFor]="actionsMenu"
                (click)="$event.stopPropagation()">
                <span>
                  Actions
                </span>
                <mat-icon>keyboard_arrow_down</mat-icon>
              </button>


              <mat-menu #actionsMenu="matMenu" xPosition="after">

                <button [attr.guide]="'common-product-btn-170' + '__' + sanitizeUrl(url)" [disabled]="!resourcePrivilege?.update" (click)="details(row.entityId,row.attributeSetId)"
                  mat-menu-item>
                  <mat-icon>remove_red_eye</mat-icon>
                  <span>View</span>
                </button>

                <button [attr.guide]="'common-product-btn-171' + '__' + sanitizeUrl(url)" (click)="openLeadPriority(row)" mat-menu-item>
                  <mat-icon>priority_high</mat-icon>
                  <span>Add Lead Priority</span>
                </button>

                <button [attr.guide]="'common-product-btn-172' + '__' + sanitizeUrl(url)" [disabled]="!resourcePrivilege?.update" (click)="editProduct(row.entityId,row.attributeSetId)"
                  mat-menu-item>
                  <mat-icon>edit</mat-icon>
                  <span>edit</span>
                </button>

                <button [attr.guide]="'common-product-btn-173' + '__' + sanitizeUrl(url)" [disabled]="!resourcePrivilege?.delete" (click)="deleteAllProductId(row.entityId)"
                  mat-menu-item>
                  <mat-icon>delete</mat-icon>
                  <span>delete</span>
                </button>

                
                
                <button [attr.guide]="'common-product-btn-174' + '__' + sanitizeUrl(url)" *ngIf="leadToCustomer == 1" (click)="getApprove(row)" mat-menu-item>
                  <mat-icon>refresh</mat-icon>
                  <span>Convert to Customer</span>
                </button>

                <ng-container *ngIf="crmType==0 || crmType==4">
                  <button [attr.guide]="'common-product-btn-175' + '__' + sanitizeUrl(url)" (click)="openLeadStage(row,i)" mat-menu-item>
                    <mat-icon>group_add</mat-icon>
                    <span>Lead Stage</span>
                  </button>


                  <button [attr.guide]="'common-product-btn-176' + '__' + sanitizeUrl(url)" *ngIf="row.statusName!='Not intrested'" (click)="openFollowUp(row)" mat-menu-item>
                    <mat-icon>update</mat-icon>
                    <span>Follow Up</span>
                  </button>
                </ng-container>
              </mat-menu>
            </mat-cell>
          </ng-container> -->
              <mat-header-row *matHeaderRowDef="visibleColumns;sticky:true"></mat-header-row>
              <mat-row *matRowDef="let row; columns: visibleColumns;" class="clickable">
              </mat-row>
            </table>
          </div>
          <div *ngIf="display && GridType == 6" class="table-responsive custom-table gridtable-class"
            style="width: 100%;overflow-x: auto;">

            <table (matSortChange)="sortData($event)" [dataSource]="productList" class="w-full" mat-table matSort>

              <ng-container matColumnDef="select" style="border-bottom: none;border-bottom-width: 0px;">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox [attr.guide]="'common-product-chk-177' + '__' + sanitizeUrl(url)"
                    (change)="toggleAllRows($event.checked)" [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox [attr.guide]="'common-product-chk-178' + '__' + sanitizeUrl(url)"
                    (click)="$event.stopPropagation()"
                    (change)="changeValue($event.checked, row); selection.toggle(row)"
                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                  </mat-checkbox>
                </td>
              </ng-container>

              <ng-container *ngFor="let column of columns">
                <ng-container *ngIf="column.isModelProperty!='false'">

                  <ng-container *ngIf="column.isModelProperty && column.property!='actions'"
                    [matColumnDef]="column.property">


                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name }}
                    </mat-header-cell>
                    <mat-cell [ngClass]="column.cssClasses" class="cellmat" *matCellDef="let row">

                      <span *ngIf="column.property.includes('customValuesIs')">
                        {{row.isCustomizedValue[column.propertyName] }}

                      </span>
                      <span
                        *ngIf="!column.property.includes('customValuesIs')&&column.name!='Follow Up Data Time';else other_content">
                        {{row[column.property] }}

                      </span>
                      <ng-template #other_content>

                        {{row[column.property] | date:'medium'}}
                      </ng-template>


                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='actions'">
                  <ng-container matColumnDef="actions">

                    <mat-header-cell class="actions-cell" *matHeaderCellDef class="headcell">Action</mat-header-cell>
                    <mat-cell class="actions-cell" *matCellDef="let row;let i=index" class="cellmat">
                      <button [attr.guide]="'common-product-btn-179' + '__' + sanitizeUrl(url)" type="button"
                        mat-icon-button [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
                        <mat-icon>more_horiz</mat-icon>
                      </button>
                      <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                        <button [attr.guide]="'common-product-btn-180' + '__' + sanitizeUrl(url)"
                          [disabled]="!resourcePrivilege?.update" (click)="editProduct(row.entityId,row.attributeSetId)"
                          mat-menu-item>
                          <mat-icon>edit</mat-icon>
                          <span>edit</span>
                        </button>



                        <button [attr.guide]="'common-product-btn-181' + '__' + sanitizeUrl(url)"
                          *ngIf="leadToCustomer == 1" (click)="getApprove(row)" mat-menu-item>
                          <mat-icon>refresh</mat-icon>
                          <span>Convert to Customer</span>
                        </button>

                        <button [attr.guide]="'common-product-btn-182' + '__' + sanitizeUrl(url)"
                          [disabled]="!resourcePrivilege?.delete" (click)="deleteAllProductId(row.entityId)"
                          mat-menu-item>
                          <mat-icon>delete</mat-icon>
                          <span>delete</span>
                        </button>

                        <ng-container *ngIf="crmType==0 || crmType==4">
                          <button [attr.guide]="'common-product-btn-183' + '__' + sanitizeUrl(url)"
                            (click)="openLeadStage(row,i)" mat-menu-item>
                            <mat-icon>group_add</mat-icon>
                            <span>Lead Stage</span>
                          </button>
                          <button [attr.guide]="'common-product-btn-184' + '__' + sanitizeUrl(url)"
                            (click)="openLeadPriority(row)" mat-menu-item>
                            <mat-icon>priority_high</mat-icon>
                            <span>Add Lead Priority</span>
                          </button>

                        </ng-container>

                        <button [attr.guide]="'common-product-btn-185' + '__' + sanitizeUrl(url)"
                          *ngIf="column.showLeadStage==1" (click)="openLeadStage(row,i)" mat-menu-item>
                          <mat-icon>group_add</mat-icon>
                          <span>Lead Stage</span>
                        </button>
                        <button [attr.guide]="'common-product-btn-186' + '__' + sanitizeUrl(url)"
                          *ngIf="column.showLeadPriority==1" (click)="openLeadPriority(row)" mat-menu-item>
                          <mat-icon>priority_high</mat-icon>
                          <span>Add Lead Priority</span>
                        </button>

                        <button [attr.guide]="'common-product-btn-187' + '__' + sanitizeUrl(url)" *ngIf="enableSequence"
                          (click)="SequenceStatusPopup('single',row)" mat-menu-item>
                          <mat-icon>start</mat-icon>
                          <span>Add Lead Sequences</span>
                        </button>


                      </mat-menu>
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='name'">
                  <ng-container matColumnDef="name">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.name) | slice:0:20}}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='lastActivityNotes'">
                  <ng-container matColumnDef="lastActivityNotes">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.lastActivityNotes) | slice:0:20}}
                    </mat-cell>
                  </ng-container>

                </ng-container>



                <ng-container *ngIf="column.property=='statusName'">
                  <ng-container matColumnDef="statusName">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.statusName) | slice:0:20}}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <!-- <ng-container *ngIf="column.property=='company'">
                  <ng-container matColumnDef="company">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="companyNavigation(row.companyId)" class="cellmat" *matCellDef="let row">
                      {{(row.company) }}
                    </mat-cell>
                  </ng-container>

                </ng-container> -->

                <ng-container *ngIf="column.property=='totalCallDuration'">

                  <ng-container matColumnDef="totalCallDuration">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell style="text-align: center;" *matCellDef="let row" class="cellmat">
                      {{ formatSecondsToTime(row.totalCallDuration) }}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='note'">


                  <ng-container matColumnDef="note">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-188' + '__' + sanitizeUrl(url)"
                        style="border: 1px solid #dee2e6; padding: 2px; border-radius: 15px; display: flex; align-items: center;"
                        (click)="Note(row)">
                        <mat-icon>add_circle</mat-icon>
                        <span>New Notes</span>
                      </button>

                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='followUpDateTimePopup'">
                  <ng-container matColumnDef="followUpDateTimePopup">
                    <mat-header-cell *matHeaderCellDef class="headcell">{{ column.name }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-189' + '__' + sanitizeUrl(url)"
                        style="border: 1px solid #dee2e6; padding: 2px; border-radius: 15px; display: flex; align-items: center; gap: 5px;"
                        (click)="openFollowUp(row)">
                        <mat-icon>add_circle</mat-icon>
                        <span>Follow Up</span>
                      </button>

                    </mat-cell>
                  </ng-container>

                </ng-container>


                <ng-container *ngIf="column.property=='deal'">
                  <ng-container matColumnDef="deal">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <span class="deals">{{row.deal || 'Open'}}</span>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='score'">
                  <ng-container matColumnDef="score">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.score || 0.0}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='status'">
                  <ng-container matColumnDef="status">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <span [ngClass]="{'statustType': row.status}">{{row.status}}</span>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='sourceName'">
                  <ng-container matColumnDef="sourceName">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.sourceName) | slice:0:20}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='createdDate'">

                  <ng-container matColumnDef="createdDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.createdDate) | date:'medium' }}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='activityCountOnLead'">
                  <ng-container matColumnDef="activityCountOnLead">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p style="text-align: center;">{{(row.activityCountOnLead) }}</p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='CrNo_cust'">
                  <ng-container matColumnDef="CrNo_cust">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{(row.isCustomizedValue.CrNo)}}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='CrName_cust'">
                  <ng-container matColumnDef="CrName_cust">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{(row.isCustomizedValue.CrName)}}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='choiceofprogram'">
                  <ng-container matColumnDef="choiceofprogram">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{ row.isCustomizedValue['Choice Of Program'] || row.customField10?.ChoiceOfProgram }}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='preferablelanguage'">
                  <ng-container matColumnDef="preferablelanguage">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{ row.isCustomizedValue?.['Preferable Language'] || row.customField10?.PreferableLanguage }}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='collegeName'">
                  <ng-container matColumnDef="collegeName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.collegeName }}
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='jobtitle'">

                  <ng-container matColumnDef="jobtitle">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Job title</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.jobtitle ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='department'">
                  <ng-container matColumnDef="department">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField10?.Department ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='district'">
                  <ng-container matColumnDef="district">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField10?.District ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='parentsnumber'">

                  <ng-container matColumnDef="parentsnumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField10?.ParentsNumber ?? '' }}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='yearofstudy'">
                  <ng-container matColumnDef="yearofstudy">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell class="cellmat" *matCellDef="let row">
                      {{ row.customField10?.YearOfStudy ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='section'">
                  <ng-container matColumnDef="section">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField1?.Section ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='quoted'">
                  <ng-container matColumnDef="quoted">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">

                      <span *ngIf="row.customField10 && row.customField10.QuotedValue != null">
                        <p fxFlex="100" fxLayoutAlign="center center">
                          {{ row.customField10.QuotedValue }}
                        </p>
                      </span>

                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='updatedDate'">
                  <ng-container matColumnDef="updatedDate">
                    <mat-header-cell class="headcell" *matHeaderCellDef mat-sort-header>{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.updatedDate) | date:'medium' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='adGroupName'">

                  <ng-container matColumnDef="adGroupName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.jsonRecieved?.adGroupName!=null?row.jsonRecieved?.adGroupName:row.campaignName}}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='Country'">
                  <ng-container matColumnDef="Country">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.isCustomizedValue.Country)}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='City'">
                  <ng-container matColumnDef="City">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.isCustomizedValue.City)}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='State'">
                  <ng-container matColumnDef="State">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.isCustomizedValue.State)}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='flag'">
                  <ng-container matColumnDef="flag">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row ; let i=index;" class="cellmat">
                      <button [attr.guide]="'common-product-btn-190' + '__' + sanitizeUrl(url)" type="button"
                        mat-icon-button (click)="flag(row,i)">
                        <mat-icon>{{ row.flag==1 ? 'flag' : 'outlined_flag' }}</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='priority'">
                  <ng-container matColumnDef="priority">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" *matCellDef="let row" class="cellmat">
                      {{ getPriorityLetter(row.priority) }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='phoneNumber'">
                  <ng-container matColumnDef="phoneNumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" *matCellDef="let row" class="cellmat">
                      <div>
                        <div *ngIf="row.phoneNumber != null">
                          <span size="23px" style="cursor: pointer;">
                            {{ row.phoneNumber }}
                          </span>

                        </div>

                        <div *ngIf="row.secondaryphoneno != null" style="margin-top: 10px;">
                          <span size="23px" style="cursor: pointer;">
                            {{ row.secondaryphoneno}}
                          </span>

                        </div>
                      </div>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='icons'">
                  <ng-container matColumnDef="icons" class="icon-list">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"></mat-header-cell>
                    <mat-cell class="cellmat" *matCellDef="let row">
                      <div>
                        <div *ngIf="row.phoneNumber != null" style="display: flex; align-items: center;">
                          <mat-icon (click)="phoneNumbercall(row); $event.stopPropagation()" [icIcon]="icPhone"
                            size="18px"
                            style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                          </mat-icon>
                          <img (click)="phonewhatsapp(row); $event.stopPropagation()" src="assets/icons/whatsapp.svg"
                            alt="Whatsapp"
                            style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                        </div>

                        <div *ngIf="row.secondaryphoneno?.length > 0"
                          style="margin-top: 5px; display: flex; align-items: center;">
                          <mat-icon (click)="secondaryphoneNumbercall(row); $event.stopPropagation()" [icIcon]="icPhone"
                            size="18px"
                            style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                          </mat-icon>
                          <img (click)="secondaryphonewhatsapp(row.customField10); $event.stopPropagation()"
                            src="assets/icons/whatsapp.svg" alt="Whatsapp"
                            style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                        </div>
                      </div>
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='walkIn'">
                  <ng-container matColumnDef="walkIn">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-191' + '__' + sanitizeUrl(url)" class="fav-button"
                        type="button" mat-icon-button (click)="walkIn(row)" [ngClass]="{ 'favorite': row.walkIn==1 }">
                        <mat-icon>{{ row.walkIn==1 ? 'directions_walk' : 'directions_walk' }}</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <!-- <ng-container matColumnDef="emailValid">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Email Valid</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                 
                  {{ row.emailValid==1 ? 'true' : 'false' }}
                </mat-cell>
              </ng-container> -->

                <ng-container *ngIf="column.property=='favourite'">
                  <ng-container matColumnDef="favourite">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-192' + '__' + sanitizeUrl(url)" class="fav-button"
                        type="button" mat-icon-button (click)="toggleFavorite(row)"
                        [ngClass]="{ 'favorite': row.favourite==1 }">
                        <mat-icon>{{ row.favourite==1 ? 'favorite' : 'favorite_border' }}</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                </ng-container>


              </ng-container>





              <mat-header-row *matHeaderRowDef="visibleColumns;sticky:true"></mat-header-row>
              <mat-row *matRowDef="let row; columns: visibleColumns;" class="clickable">
              </mat-row>
            </table>
          </div>
          <div *ngIf="display && GridType ==  7" class="table-responsive custom-table"
            style="width: 100%;overflow-x: auto;">

            <table (matSortChange)="sortData($event)" [dataSource]="productList" class="w-full" mat-table matSort>



              <ng-container matColumnDef="select" style="border-bottom: none;border-bottom-width: 0px;">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox [attr.guide]="'common-product-chk-193' + '__' + sanitizeUrl(url)"
                    (change)="toggleAllRows($event.checked)" [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox [attr.guide]="'common-product-chk-194' + '__' + sanitizeUrl(url)"
                    (click)="$event.stopPropagation()"
                    (change)="changeValue($event.checked, row); selection.toggle(row)"
                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                  </mat-checkbox>
                </td>
              </ng-container>


              <!-- fullName Column -->
              <ng-container *ngFor="let column of columns">
                <ng-container *ngIf="column.isModelProperty!='false'">

                  <ng-container *ngIf="column.isModelProperty && column.property!='actions'"
                    [matColumnDef]="column.property">


                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name }}
                    </mat-header-cell>
                    <mat-cell [ngClass]="column.cssClasses" class="cellmat" *matCellDef="let row">

                      <span *ngIf="column.property.includes('customValuesIs')">
                        {{row.isCustomizedValue[column.propertyName] }}

                      </span>
                      <span
                        *ngIf="!column.property.includes('customValuesIs')&&column.name!='Follow Up Data Time';else other_content">
                        {{row[column.property] }}

                      </span>
                      <ng-template #other_content>

                        {{row[column.property] | date:'medium'}}
                      </ng-template>


                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='actions'">
                  <ng-container matColumnDef="actions">

                    <mat-header-cell class="actions-cell" *matHeaderCellDef class="headcell">Action</mat-header-cell>
                    <mat-cell class="actions-cell" *matCellDef="let row;let i=index" class="cellmat">
                      <button [attr.guide]="'common-product-btn-195' + '__' + sanitizeUrl(url)" type="button"
                        mat-icon-button [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
                        <mat-icon>more_horiz ss</mat-icon>
                      </button>
                      <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                        <button [attr.guide]="'common-product-btn-196' + '__' + sanitizeUrl(url)"
                          [disabled]="!resourcePrivilege?.update" (click)="editProduct(row.entityId,row.attributeSetId)"
                          mat-menu-item>
                          <mat-icon>edit</mat-icon>
                          <span>edit</span>
                        </button>



                        <button [attr.guide]="'common-product-btn-197' + '__' + sanitizeUrl(url)"
                          *ngIf="leadToCustomer == 1" (click)="getApprove(row)" mat-menu-item>
                          <mat-icon>refresh</mat-icon>
                          <span>Convert to Customer</span>
                        </button>

                        <button [attr.guide]="'common-product-btn-198' + '__' + sanitizeUrl(url)"
                          [disabled]="!resourcePrivilege?.delete" (click)="deleteAllProductId(row.entityId)"
                          mat-menu-item>
                          <mat-icon>delete</mat-icon>
                          <span>delete</span>
                        </button>

                        <ng-container *ngIf="crmType==0 || crmType==4">
                          <button [attr.guide]="'common-product-btn-199' + '__' + sanitizeUrl(url)"
                            (click)="openLeadStage(row,i)" mat-menu-item>
                            <mat-icon>group_add</mat-icon>
                            <span>Lead Stage</span>
                          </button>
                          <button [attr.guide]="'common-product-btn-200' + '__' + sanitizeUrl(url)"
                            (click)="openLeadPriority(row)" mat-menu-item>
                            <mat-icon>priority_high</mat-icon>
                            <span>Add Lead Priority</span>
                          </button>

                        </ng-container>

                        <button [attr.guide]="'common-product-btn-201' + '__' + sanitizeUrl(url)"
                          *ngIf="column.showLeadStage==1" (click)="openLeadStage(row,i)" mat-menu-item>
                          <mat-icon>group_add</mat-icon>
                          <span>Lead Stage</span>
                        </button>
                        <button [attr.guide]="'common-product-btn-202' + '__' + sanitizeUrl(url)"
                          *ngIf="column.showLeadPriority==1" (click)="openLeadPriority(row)" mat-menu-item>
                          <mat-icon>priority_high</mat-icon>
                          <span>Add Lead Priority</span>
                        </button>

                        <button [attr.guide]="'common-product-btn-203' + '__' + sanitizeUrl(url)" *ngIf="enableSequence"
                          (click)="SequenceStatusPopup('single',row)" mat-menu-item>
                          <mat-icon>start</mat-icon>
                          <span>Add Lead Sequences</span>
                        </button>

                      </mat-menu>
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='name'">
                  <ng-container matColumnDef="name">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.name) | slice:0:20}}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='lastActivityNotes'">
                  <ng-container matColumnDef="lastActivityNotes">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.lastActivityNotes) | slice:0:20}}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='statusName'">
                  <ng-container matColumnDef="statusName">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.statusName) | slice:0:20}}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='company'">
                  <ng-container matColumnDef="company">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="companyNavigation(row.companyId)" class="cellmat" *matCellDef="let row">
                      {{(row.company) }}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='totalCallDuration'">

                  <ng-container matColumnDef="totalCallDuration">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell style="text-align: center;" *matCellDef="let row" class="cellmat">
                      {{ formatSecondsToTime(row.totalCallDuration) }}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='note'">


                  <ng-container matColumnDef="note">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-204' + '__' + sanitizeUrl(url)"
                        style="border: 1px solid #dee2e6; padding: 2px; border-radius: 15px; display: flex; align-items: center;"
                        (click)="Note(row)">
                        <mat-icon>add_circle</mat-icon>
                        <span>New Notes</span>
                      </button>

                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='followUpDateTimePopup'">
                  <ng-container matColumnDef="followUpDateTimePopup">
                    <mat-header-cell *matHeaderCellDef class="headcell">{{ column.name }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-205' + '__' + sanitizeUrl(url)"
                        style="border: 1px solid #dee2e6; padding: 2px; border-radius: 15px; display: flex; align-items: center; gap: 5px;"
                        (click)="openFollowUp(row)">
                        <mat-icon>add_circle</mat-icon>
                        <span>Follow Up</span>
                      </button>

                    </mat-cell>
                  </ng-container>

                </ng-container>


                <ng-container *ngIf="column.property=='deal'">
                  <ng-container matColumnDef="deal">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <span class="deals">{{row.deal || 'Open'}}</span>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='score'">
                  <ng-container matColumnDef="score">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.score || 0.0}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='status'">
                  <ng-container matColumnDef="status">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <span [ngClass]="{'statustType': row.status}">{{row.status}}</span>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='sourceName'">
                  <ng-container matColumnDef="sourceName">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" class="cellmat" *matCellDef="let row">
                      {{(row.sourceName) | slice:0:20}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='createdDate'">

                  <ng-container matColumnDef="createdDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.createdDate) | date:'medium' }}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='activityCountOnLead'">
                  <ng-container matColumnDef="activityCountOnLead">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p style="text-align: center;">{{(row.activityCountOnLead) }}</p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='CrNo_cust'">
                  <ng-container matColumnDef="CrNo_cust">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{(row.isCustomizedValue.CrNo)}}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='CrName_cust'">
                  <ng-container matColumnDef="CrName_cust">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{(row.isCustomizedValue.CrName)}}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='choiceofprogram'">
                  <ng-container matColumnDef="choiceofprogram">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{ row.isCustomizedValue['Choice Of Program'] || row.customField10?.ChoiceOfProgram }}
                      </p>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='preferablelanguage'">
                  <ng-container matColumnDef="preferablelanguage">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <p fxFlex="100" fxLayoutAlign="center center">
                        {{ row.isCustomizedValue?.['Preferable Language'] || row.customField10?.PreferableLanguage }}
                      </p>

                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='collegeName'">
                  <ng-container matColumnDef="collegeName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.collegeName }}
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='jobtitle'">

                  <ng-container matColumnDef="jobtitle">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Job title</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.jobtitle ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='department'">
                  <ng-container matColumnDef="department">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField10?.Department ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='district'">
                  <ng-container matColumnDef="district">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField10?.District ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='parentsnumber'">

                  <ng-container matColumnDef="parentsnumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField10?.ParentsNumber ?? '' }}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='yearofstudy'">
                  <ng-container matColumnDef="yearofstudy">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell class="cellmat" *matCellDef="let row">
                      {{ row.customField10?.YearOfStudy ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='section'">
                  <ng-container matColumnDef="section">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.customField1?.Section ?? '' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='quoted'">
                  <ng-container matColumnDef="quoted">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">

                      <span *ngIf="row.customField10 && row.customField10.QuotedValue != null">
                        <p fxFlex="100" fxLayoutAlign="center center">
                          {{ row.customField10.QuotedValue }}
                        </p>
                      </span>

                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='updatedDate'">
                  <ng-container matColumnDef="updatedDate">
                    <mat-header-cell class="headcell" *matHeaderCellDef mat-sort-header>{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.updatedDate) | date:'medium' }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='adGroupName'">

                  <ng-container matColumnDef="adGroupName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{ row.jsonRecieved?.adGroupName!=null?row.jsonRecieved?.adGroupName:row.campaignName}}
                    </mat-cell>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.property=='Country'">
                  <ng-container matColumnDef="Country">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.isCustomizedValue.Country)}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='City'">
                  <ng-container matColumnDef="City">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.isCustomizedValue.City)}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='State'">
                  <ng-container matColumnDef="State">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      {{(row.isCustomizedValue.State)}}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='flag'">
                  <ng-container matColumnDef="flag">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row ; let i=index;" class="cellmat">
                      <button [attr.guide]="'common-product-btn-206' + '__' + sanitizeUrl(url)" type="button"
                        mat-icon-button (click)="flag(row,i)">
                        <mat-icon>{{ row.flag==1 ? 'flag' : 'outlined_flag' }}</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='priority'">
                  <ng-container matColumnDef="priority">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" *matCellDef="let row" class="cellmat">
                      {{ getPriorityLetter(row.priority) }}
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='phoneNumber'">
                  <ng-container matColumnDef="phoneNumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell (click)="details(row.entityId,row.attributeSetId)" *matCellDef="let row" class="cellmat">
                      <div>
                        <div *ngIf="row.phoneNumber != null">
                          <span size="23px" style="cursor: pointer;">
                            {{ row.phoneNumber }}
                          </span>

                        </div>

                        <div *ngIf="row.secondaryphoneno != null" style="margin-top: 10px;">
                          <span size="23px" style="cursor: pointer;">
                            {{ row.secondaryphoneno}}
                          </span>

                        </div>
                      </div>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="column.property=='icons'">
                  <ng-container matColumnDef="icons" class="icon-list">

                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"></mat-header-cell>
                    <mat-cell class="cellmat" *matCellDef="let row">
                      <div>
                        <div *ngIf="row.phoneNumber != null" style="display: flex; align-items: center;">
                          <mat-icon (click)="phoneNumbercall(row); $event.stopPropagation()" [icIcon]="icPhone"
                            size="18px"
                            style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                          </mat-icon>
                          <img (click)="phonewhatsapp(row); $event.stopPropagation()" src="assets/icons/whatsapp.svg"
                            alt="Whatsapp"
                            style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                        </div>

                        <div *ngIf="row.secondaryphoneno?.length > 0"
                          style="margin-top: 5px; display: flex; align-items: center;">
                          <mat-icon (click)="secondaryphoneNumbercall(row); $event.stopPropagation()" [icIcon]="icPhone"
                            size="18px"
                            style="cursor: pointer; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;">
                          </mat-icon>
                          <img (click)="secondaryphonewhatsapp(row.customField10); $event.stopPropagation()"
                            src="assets/icons/whatsapp.svg" alt="Whatsapp"
                            style="width: 18px; height: 18px; cursor: pointer; margin-left: 10px; object-fit: contain;">
                        </div>
                      </div>
                    </mat-cell>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="column.property=='walkIn'">
                  <ng-container matColumnDef="walkIn">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-207' + '__' + sanitizeUrl(url)" class="fav-button"
                        type="button" mat-icon-button (click)="walkIn(row)" [ngClass]="{ 'favorite': row.walkIn==1 }">
                        <mat-icon>{{ row.walkIn==1 ? 'directions_walk' : 'directions_walk' }}</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                </ng-container>

                <!-- <ng-container matColumnDef="emailValid">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">Email Valid</mat-header-cell>
                <mat-cell *matCellDef="let row" class="cellmat">
                 
                  {{ row.emailValid==1 ? 'true' : 'false' }}
                </mat-cell>
              </ng-container> -->

                <ng-container *ngIf="column.property=='favourite'">
                  <ng-container matColumnDef="favourite">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell">{{ column.name
                      }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="cellmat">
                      <button [attr.guide]="'common-product-btn-208' + '__' + sanitizeUrl(url)" class="fav-button"
                        type="button" mat-icon-button (click)="toggleFavorite(row)"
                        [ngClass]="{ 'favorite': row.favourite==1 }">
                        <mat-icon>{{ row.favourite==1 ? 'favorite' : 'favorite_border' }}</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                </ng-container>


              </ng-container>


              <mat-header-row *matHeaderRowDef="visibleColumns;sticky:true"></mat-header-row>
              <mat-row *matRowDef="let row; columns: visibleColumns;" class="clickable">
              </mat-row>
            </table>
          </div>





          <div class="leads-section products-padding"
            *ngIf="leadTypeInMobile == 1  && !display  && productList?.length > 0">

            <div *ngFor="let lead of productList" fxLayout="row" fxLayoutAlign="space-between center" class="lead-card">
              <div fxFlex="65" fxLayoutAlign="start center" class="lead-info">
                <div class="avatar pending">{{ generateLetterIcon(lead.name) | uppercase }}</div>
                <div fxLayout="column" class="lead-details" (click)="details(lead.entityId,lead.attributeSetId)"
                  style="cursor: pointer;word-wrap: break-word;word-break: break-all;">

                  <div class="lead-name">{{ lead.name }}</div>
                  <div class="lead-date">
                    Date: {{ lead.createdDate | date:'yyyy-MM-dd' }}<br>
                    Time: {{ lead.createdDate | date:'HH:mm:ss' }}
                  </div>
                </div>
              </div>
              <div class="lead-status" fxFlex="35">
                <div fxLayout="row" fxLayoutAlign="center center">
                  <span style="cursor: pointer;word-wrap: break-word;word-break: break-all;"
                    class="pending curved-button">{{ lead.statusName }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="products-padding" fxLayoutAlign="center center" *ngIf="productList?.length == 0&&!spinner">No
            records found
          </div>

          <div class="mobile-accordion-list products-padding"
            *ngIf="leadTypeInMobile == 2  && !display  && productList?.length > 0">
            <div *ngFor="let section of productList; let i = index" class="lead-accordion-card">
              <button type="button" class="lead-accordion-header" (click)="toggleSection(i)">
                <span class="lead-accordion-left">
                  <span class="header-icon-circle">
                    <mat-icon class="expand-icon">{{ section.open ? 'remove' : 'add' }}</mat-icon>
                  </span>
                  <span class="header-title-text">{{ section.name }}</span>
                </span>

                <span class="status-pill" [style.backgroundColor]="getStatusColor(section.statusName)">
                  {{ section.statusName }}
                </span>
              </button>

              <div *ngIf="section.open" class="detail-panel" (click)="details(section.entityId,section.attributeSetId)">
                <div class="detail-row">
                  <div class="label">Name</div>
                  <div class="value">{{ section.name }}</div>
                </div>

                <div class="detail-row">
                  <div class="label">Phone</div>
                  <div class="value">
                    <span class="link-text">{{ section.phoneNumber }}</span>
                  </div>
                </div>

                <div class="detail-row">
                  <div class="label">Created at</div>
                  <div class="value">{{ section.createdDate | date:'yyyy-MM-dd HH:mm:ss' }}</div>
                </div>

                <div class="detail-row">
                  <div class="label">Status</div>
                  <div class="value">
                    <span class="status-pill" [style.backgroundColor]="getStatusColor(section.statusName)">
                      {{ section.statusName }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
            <mat-spinner [diameter]="20" *ngIf="spinner"></mat-spinner>
            <mat-paginator class="paginator" (page)="getUpdate($event)" showFirstLastButtons [length]="pageList"
              [pageIndex]="page" [pageSize]="size" [pageSizeOptions]="pageSizeValue"> </mat-paginator>
          </div>
        </div>
      </calsoft-list>
    </div>




  </div>
</div>


<ng-template #delete>

  <div class="index-head" fxLayout="row" fxLayoutAlign="start center">
    <mat-icon style="color: #f44336; margin-right: 8px;">warning</mat-icon>
    <span>Delete</span>
  </div>
  <div class="padding-index" fxLayout="column" fxLayoutGap="10px">
    <span> Do you want to Delete All Leads</span>
    <mat-form-field appearance="outline" style="width: 100%; margin-top: 10px;">
      <mat-label>Type 'delete' to confirm</mat-label>
      <input matInput [(ngModel)]="deleteConfirmText" placeholder="delete" autocomplete="off" />
    </mat-form-field>
  </div>

  <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
    <button [attr.guide]="'common-product-btn-227' + '__' + sanitizeUrl(url)" mat-raised-button mat-dialog-close
      [disabled]="textAccount !='OK'" tabindex="-1">Cancel</button>
    <button [attr.guide]="'common-product-btn-228' + '__' + sanitizeUrl(url)" [disabled]="isDeleteDisabled"
      (click)="submit()" mat-raised-button color="warn">
      {{textAccount}}
      <mat-icon *ngIf="textAccount !='OK' ">
        <mat-spinner color="primary" diameter="20">
        </mat-spinner>
      </mat-icon></button>
  </div>
</ng-template>

<ng-template #housindata>

  <div class="index-head">
    <span>Common floor</span>
  </div>
  <form [formGroup]="range">
    <div class="padding-10" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
      <mat-form-field fxFlex appearance="outline">
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
          <input [attr.guide]="'common-product-inp-start' + '__' + sanitizeUrl(url)" matStartDate
            formControlName="start" placeholder="Start date" />
          <input [attr.guide]="'common-product-inp-end' + '__' + sanitizeUrl(url)" matEndDate formControlName="end"
            placeholder="End date" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker color="accent" #picker></mat-date-range-picker>

        <div *ngIf="range.invalid && (range.dirty || range.touched)">
          <p *ngIf="range.errors?.exceedsMaxRange" class="error-message">Date range exceeds 7 days</p>
        </div>
      </mat-form-field>
    </div>
  </form>

  <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
    <button [attr.guide]="'common-product-btn-229' + '__' + sanitizeUrl(url)" mat-raised-button mat-dialog-close
      tabindex="-1">Cancel</button>
    <button [attr.guide]="'common-product-btn-230' + '__' + sanitizeUrl(url)" [disabled]="textAccountHousing != 'OK'"
      (click)="createHousingLead()" mat-raised-button>
      {{textAccountHousing}}
      <mat-icon *ngIf="textAccountHousing != 'OK'">
        <mat-spinner color="primary" diameter="20"></mat-spinner>
      </mat-icon>
    </button>
  </div>
</ng-template>
<ng-template #whatsapptemplatedata>

  <div class="index-head">
    <span>Send WhatsApp Message</span>
  </div>
  <div class="padding-index">

  </div>

  <div class="padding-10" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
    <mat-form-field fxFlex appearance="outline">
      <mat-label>Select Message Template</mat-label>
      <mat-select [formControl]="templateId" [disableOptionCentering]="true" #singleSelect name="item">
        <mat-option>
          <ngx-mat-select-search name="WhatsApp Template Message Search" ngDefaultControl [formControl]="
          WhatsappTemplateMessageFilterControl
      " placeholderLabel="WhatsApp Template Message Search" [preventHomeEndKeyPropagation]="
        true
      " noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredWhatsappTemplateMessageTypeList;" [value]="opt.messageTemplateId">
          {{ opt.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="input-row" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10px">


  </div>

  <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
    <button [attr.guide]="'common-product-btn-231' + '__' + sanitizeUrl(url)" mat-raised-button mat-dialog-close
      tabindex="-1">Cancel</button>
    <button [attr.guide]="'common-product-btn-232' + '__' + sanitizeUrl(url)" [disabled]="text !='Save'"
      (click)="getALLWhatsAppNumbers()" mat-raised-button>
      {{text}}
      <mat-icon *ngIf="text !='Save' ">
        <mat-spinner color="primary" diameter="20">
        </mat-spinner>
      </mat-icon>
    </button>
  </div>


</ng-template>


<ng-template #emailtemplatedata>

  <div class="index-head">
    <span>Send Email Message</span>
  </div>
  <div class="padding-index">

  </div>

  <div *ngIf="useIndividualMail == 1" class="padding-10" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

    <mat-form-field appearance="outline" floatLabel="always" fxFlex>
      <mat-label>From</mat-label>
      <mat-select [formControl]="fromEmailId" [disableOptionCentering]="true" #singleSelect autocomplete="off"
        (selectionChange)="onFromEmailChange($event.value)">
        <mat-option>
          <ngx-mat-select-search name="Email Search" ngDefaultControl [formControl]="typeEmailYFilterControl"
            placeholderLabel="Email Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredEmaildropdownTypeList; let i=index;" [value]="opt.userMailConfigId">
          {{ opt.emailAddress }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="fromEmailId.hasError('required')">
        From Email is required.
      </mat-error>
    </mat-form-field>

  </div>

  <div class="padding-10" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">


    <mat-form-field fxFlex appearance="outline">
      <mat-label>Select Email Template</mat-label>
      <mat-select [formControl]="emailtemplateId" [disableOptionCentering]="true" #singleSelect name="item">
        <mat-option>
          <ngx-mat-select-search name="Email Template Message Search" ngDefaultControl
            [formControl]="emailTemplateMessageFilterControl" placeholderLabel="Email Template Message Search"
            [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredEmailTemplateMessageTypeList;" [value]="opt.emailTemplateId">
          {{ opt.templateName }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="emailtemplateId.hasError('required')">
        Email Template is required.
      </mat-error>
    </mat-form-field>
  </div>

  <div class="input-row" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10px">


  </div>

  <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
    <button [attr.guide]="'common-product-btn-233' + '__' + sanitizeUrl(url)" mat-raised-button mat-dialog-close
      tabindex="-1">Cancel</button>
    <button [attr.guide]="'common-product-btn-234' + '__' + sanitizeUrl(url)" [disabled]="textSend !='Send'"
      (click)="sendMailTemplate()" mat-raised-button>
      {{textSend}}
      <mat-icon *ngIf="textSend !='Send' ">
        <mat-spinner color="primary" diameter="20">
        </mat-spinner>
      </mat-icon>
    </button>
  </div>


</ng-template>

<ng-template #updateStatus>

  <div class="index-head">
    <span>Update Status</span>
  </div>
  <div class="padding-index">
    <span> Please select Lead Status to update </span>
  </div>

  <div class="padding-10" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">


    <mat-form-field fxFlex appearance="outline">
      <mat-label>Lead Status</mat-label>
      <mat-select [formControl]="defaultLeadStatus" [disableOptionCentering]="true" #singleSelect autocomplete="off">
        <mat-option>
          <ngx-mat-select-search name="Lead Status Search" ngDefaultControl [formControl]="typeYFilterControl"
            placeholderLabel="Lead Status Search" [preventHomeEndKeyPropagation]="true"
            noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filtereddropdownTypeList; let i=index;" [value]="opt.statusId">
          {{opt.statusName}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="defaultLeadStatus.hasError('required')">
        Lead Status is required
      </mat-error>
    </mat-form-field>

  </div>


  <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
    <button [attr.guide]="'common-product-btn-235' + '__' + sanitizeUrl(url)" mat-raised-button mat-dialog-close
      tabindex="-1">Cancel</button>
    <button [attr.guide]="'common-product-btn-236' + '__' + sanitizeUrl(url)" [disabled]="text !='Save'"
      (click)="UpdateLeadStatus()" mat-raised-button>
      {{text}}
      <mat-icon *ngIf="text !='Save' ">
        <mat-spinner color="primary" diameter="20">
        </mat-spinner>
      </mat-icon>
    </button>
  </div>


</ng-template>

<ng-template #deleteSelected>

  <div class="index-head">
    <span>Delete Selected Leads</span>
  </div>
  <div class="padding-index">
    <span> Do you want to Delete Selected Leads</span>
  </div>


  <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
    <button [attr.guide]="'common-product-btn-237' + '__' + sanitizeUrl(url)" mat-raised-button mat-dialog-close
      [disabled]="textAccount !='OK'" tabindex="-1">Cancel</button>
    <button [attr.guide]="'common-product-btn-238' + '__' + sanitizeUrl(url)" [disabled]="textAccount !='OK'"
      (click)="deleteSelectedLead()" mat-raised-button>
      {{textAccount}}
      <mat-icon *ngIf="textAccount !='OK' ">
        <mat-spinner color="primary" diameter="20">
        </mat-spinner>
      </mat-icon></button>
  </div>
</ng-template>


<div class="popup" *ngIf="isPopupOpen" (click)="$event.stopPropagation()">
  <calsoft-popup-leadstatus [LeadDetailsObject]="leadObject" [popupType]="popupType" [incomingId]="currentLeadID"
    (closePopup)="closePopup($event)"></calsoft-popup-leadstatus>
</div>



<div *ngIf="dialerType == 2" id="mydailer" class="chat-popup" [ngClass]="{'minimized': isMinimized}">
  <iframe allow="camera *; geolocation *; microphone *; autoplay *; display-capture *" #myFrame
    src="https://app.doocti.com/" [ngStyle.md]="{'height.px': isMinimized ? 55 : 300}"
    [ngStyle]="{'height.px': isMinimized ? 55 : 400}">
  </iframe>
  <div *ngIf="dialerShow" style="background-color: white;" fxLayoutAlign="center center" fxLayoutGap="10px">
    <!-- <button [attr.guide]="'common-product-btn-239' + '__' + sanitizeUrl(url)" mat-button *ngIf="dialerShow" (click)="callANumber(data)" class="call-btn">
            Call
        </button> -->
    <button [attr.guide]="'common-product-btn-240' + '__' + sanitizeUrl(url)" mat-button *ngIf="dialerShow"
      (click)="minimizeToggle()" class="call-btn">
      {{isMinimized ? 'Maximize' : 'Minimize'}}
    </button>
    <button [attr.guide]="'common-product-btn-241' + '__' + sanitizeUrl(url)" mat-button *ngIf="dialerShow"
      (click)="dialClose()" class="cls-btn">Close</button>
  </div>
</div>
<!-- FreJun Dialer (dialerType == 12) is handled globally by layout.component -->

<div class="popup" *ngIf="isPopupOpen1">
  <calsoft-filter-list-popup [type]="1" [columns]="columns" [filterSelectObj]="filterSelectObj"
    (filterChangeColumn)="onFilterChangeColumn($event,1)" [name]="'Lead'"
    (closePopup)="closePopupNew($event)"></calsoft-filter-list-popup>
</div>

<div class="popup" *ngIf="isPopupOpenTwo" (click)="$event.stopPropagation()">
  <calsoft-column-visibility [columns]="columns" (filterChangeColumn)="onFilterChangeColumn($event,1)"
    (closePopup)="closePopupTwo($event)"></calsoft-column-visibility>
</div>

<ng-template #SequenceStatus let-data="data">

  <div class="index-head">
    <span>Sequences</span>
  </div>

  <div *ngIf="!showFailedRecords">

    <div class="padding-10" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

      <mat-form-field fxFlex appearance="outline">
        <mat-label>Sequences</mat-label>
        <input type="text" matInput [formControl]="typeYFilterControl" [matAutocomplete]="autoSequence"
          placeholder="Search Sequences" autocomplete="off" />
        <mat-icon *ngIf="sequences.value" matSuffix (click)="sequences.setValue(null); typeYFilterControl.setValue('')"
          style="cursor: pointer;">clear</mat-icon>
        <mat-autocomplete #autoSequence="matAutocomplete">
          <mat-option *ngFor="let opt of filteredSequencesdropdownTypeList; let i=index;" [value]="opt.sequenceName"
            (onSelectionChange)="$event.isUserInput ? sequences.setValue(opt.sequenceId) : null">
            {{opt.sequenceName}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

    </div>


    <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
      <button [attr.guide]="'common-product-btn-242' + '__' + sanitizeUrl(url)" mat-raised-button mat-dialog-close
        tabindex="-1">Cancel</button>
      <button [attr.guide]="'common-product-btn-243' + '__' + sanitizeUrl(url)" [disabled]="text !='Save'"
        (click)="UpdateSequence()" mat-raised-button>
        {{text}}
        <mat-icon *ngIf="text !='Save' ">
          <mat-spinner color="primary" diameter="20">
          </mat-spinner>
        </mat-icon>
      </button>
    </div>

  </div>

  <div *ngIf="showFailedRecords" class="padding-10">

    <calsoft-success-falure [typeText]="'Email'" [failedRecords]="failedRecords">


    </calsoft-success-falure>

  </div>

  <div *ngIf="showFailedRecords" class="padding-10">


    <button [attr.guide]="'common-product-btn-244' + '__' + sanitizeUrl(url)" mat-raised-button
      (click)="UpdateFailedList()">Ok</button>

  </div>



</ng-template>


<ng-template #tagName>

  <div class="index-head">
    <span>Update Tag</span>
  </div>
  <div class="padding-index">

  </div>

  <div class="padding-10" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
    <mat-form-field fxFlex appearance="outline">
      <mat-label>Tag Name</mat-label>
      <mat-select [formControl]="tagNames" [disableOptionCentering]="true" #singleSelect name="item" multiple>
        <mat-option>
          <ngx-mat-select-search name="Tag Name Search" ngDefaultControl [formControl]="tagsFilterControl"
            placeholderLabel="Tag Name Search" [preventHomeEndKeyPropagation]="true"
            noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredtagsTypeList; let i=index;" [value]="opt.statusName">
          {{opt.statusName}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="input-row" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10px">


  </div>

  <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
    <button [attr.guide]="'lead-detail-btn-302' + '__' + sanitizeUrl(url)" mat-raised-button mat-dialog-close
      tabindex="-1">Cancel</button>

    <button [attr.guide]="'lead-detail-btn-303' + '__' + sanitizeUrl(url)" (click)="tagNameUpdate()"
      mat-raised-button>Save</button>
  </div>


</ng-template>


<ng-template #propertyNameModal>

  <div class="index-head">
    <span>Update Property</span>
  </div>
  <div class="padding-index">

  </div>

  <div class="padding-10" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
    <mat-form-field fxFlex appearance="outline">
      <mat-label>Property Name</mat-label>
      <mat-chip-list #chipList>
        <mat-chip *ngFor="let item of selectedProperties" [removable]="true" (removed)="removeProperty(item)">
          {{item.propertyName || item.name}}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
        <input [attr.guide]="'property-autocomplete-inp' + '__' + sanitizeUrl(url)" type="text" #propertyInput
          placeholder="Click to select records" (input)="onPropertyInput($event)" matInput [formControl]="propertyCtrl"
          [matAutocomplete]="autoProperty" [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" />
      </mat-chip-list>

      <mat-autocomplete #autoProperty="matAutocomplete"
        (optionSelected)="onPropertyOptionSelected($event.option.value)">
        <mat-option *ngFor="let option of filteredPropertyList" [value]="option">
          {{option.propertyName || option.name}}
        </mat-option>
        <mat-option
          *ngIf="(propertyCtrl.value || '').toString().trim().length > 0 && (!filteredPropertyList || filteredPropertyList.length === 0)"
          disabled>
          No results found
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div class="input-row" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10px">

  </div>

  <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
    <button [attr.guide]="'lead-property-btn-cancel' + '__' + sanitizeUrl(url)" mat-raised-button mat-dialog-close
      tabindex="-1">Cancel</button>

    <button [attr.guide]="'lead-property-btn-save' + '__' + sanitizeUrl(url)" (click)="propertyNameUpdate()"
      mat-raised-button color="primary">Save</button>
  </div>

</ng-template>


<ng-template #editPhoneModal>

  <div class="index-head">
    <span>Edit Phone Number</span>
  </div>
  <div class="padding-index">

  </div>

  <div class="padding-10" fxLayout="column" fxLayoutGap="15px">
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Phone Number</mat-label>
      <input matInput numbersOnly [(ngModel)]="editPrimaryPhone" placeholder="Enter Phone Number" />
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Secondary Phone Number</mat-label>
      <input matInput numbersOnly [(ngModel)]="editSecondaryPhone" placeholder="Enter Secondary Phone Number" />
    </mat-form-field>
  </div>

  <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
    <button [attr.guide]="'lead-phone-btn-cancel' + '__' + sanitizeUrl(url)" mat-raised-button mat-dialog-close
      tabindex="-1">Cancel</button>

    <button [attr.guide]="'lead-phone-btn-save' + '__' + sanitizeUrl(url)" (click)="savePhoneDialog()"
      [disabled]="isSavingPhone" mat-raised-button color="primary">
      {{ isSavingPhone ? 'Saving...' : 'Save' }}
    </button>
  </div>

</ng-template>